const cidades = [
  {
    name: "Abadia de Goiás",
  }, {
    name: "Abadia dos Dourados",
  }, {
    name: "Abadiânia",
  }, {
    name: "Abaetetuba",
  }, {
    name: "Abaeté",
  }, {
    name: "Abaiara",
  }, {
    name: "Abaré",
  }, {
    name: "Abatiá",
  }, {
    name: "Abaíra",
  }, {
    name: "Abdon Batista",
  }, {
    name: "Abel Figueiredo",
  }, {
    name: "Abelardo Luz",
  }, {
    name: "Abre Campo",
  }, {
    name: "Abreu e Lima",
  }, {
    name: "Abreulândia",
  }, {
    name: "Acaiaca",
  }, {
    name: "Acajutiba",
  }, {
    name: "Acarape",
  }, {
    name: "Acaraú",
  }, {
    name: "Acari",
  }, {
    name: "Acará",
  }, {
    name: "Acauã",
  }, {
    name: "Aceguá",
  }, {
    name: "Acopiara",
  }, {
    name: "Acorizal",
  }, {
    name: "Acrelândia",
  }, {
    name: "Acreúna",
  }, {
    name: "Adamantina",
  }, {
    name: "Adelândia",
  }, {
    name: "Adolfo",
  }, {
    name: "Adrianópolis",
  }, {
    name: "Adustina",
  }, {
    name: "Afogados da Ingazeira",
  }, {
    name: "Afonso Bezerra",
  }, {
    name: "Afonso Cláudio",
  }, {
    name: "Afonso Cunha",
  }, {
    name: "Afrânio",
  }, {
    name: "Afuá",
  }, {
    name: "Agrestina",
  }, {
    name: "Agricolândia",
  }, {
    name: "Agrolândia",
  }, {
    name: "Agronômica",
  }, {
    name: "Aguanil",
  }, {
    name: "Aguaí",
  }, {
    name: "Agudo",
  }, {
    name: "Agudos",
  }, {
    name: "Agudos do Sul",
  }, {
    name: "Aguiar",
  }, {
    name: "Aguiarnópolis",
  }, {
    name: "Aimorés",
  }, {
    name: "Aiquara",
  }, {
    name: "Aiuaba",
  }, {
    name: "Aiuruoca",
  }, {
    name: "Ajuricaba",
  }, {
    name: "Alagoa",
  }, {
    name: "Alagoa Grande",
  }, {
    name: "Alagoa Nova",
  }, {
    name: "Alagoinha",
  }, {
    name: "Alagoinha do Piauí",
  }, {
    name: "Alagoinhas",
  }, {
    name: "Alambari",
  }, {
    name: "Albertina",
  }, {
    name: "Alcantil",
  }, {
    name: "Alcinópolis",
  }, {
    name: "Alcobaça",
  }, {
    name: "Alcântara",
  }, {
    name: "Alcântaras",
  }, {
    name: "Aldeias Altas",
  }, {
    name: "Alecrim",
  }, {
    name: "Alegre",
  }, {
    name: "Alegrete",
  }, {
    name: "Alegrete do Piauí",
  }, {
    name: "Alegria",
  }, {
    name: "Alenquer",
  }, {
    name: "Alexandria",
  }, {
    name: "Alexânia",
  }, {
    name: "Alfenas",
  }, {
    name: "Alfredo Chaves",
  }, {
    name: "Alfredo Marcondes",
  }, {
    name: "Alfredo Vasconcelos",
  }, {
    name: "Alfredo Wagner",
  }, {
    name: "Algodão de Jandaíra",
  }, {
    name: "Alhandra",
  }, {
    name: "Aliança",
  }, {
    name: "Aliança do Tocantins",
  }, {
    name: "Almadina",
  }, {
    name: "Almas",
  }, {
    name: "Almeirim",
  }, {
    name: "Almenara",
  }, {
    name: "Almino Afonso",
  }, {
    name: "Almirante Tamandaré",
  }, {
    name: "Almirante Tamandaré do Sul",
  }, {
    name: "Aloândia",
  }, {
    name: "Alpercata",
  }, {
    name: "Alpestre",
  }, {
    name: "Alpinópolis",
  }, {
    name: "Alta Floresta",
  }, {
    name: "Alta Floresta D'Oeste",
  }, {
    name: "Altair",
  }, {
    name: "Altamira",
  }, {
    name: "Altamira do Maranhão",
  }, {
    name: "Altamira do Paraná",
  }, {
    name: "Altaneira",
  }, {
    name: "Alterosa",
  }, {
    name: "Altinho",
  }, {
    name: "Altinópolis",
  }, {
    name: "Alto Alegre",
  }, {
    name: "Alto Alegre do Maranhão",
  }, {
    name: "Alto Alegre do Pindaré",
  }, {
    name: "Alto Alegre dos Parecis",
  }, {
    name: "Alto Araguaia",
  }, {
    name: "Alto Bela Vista",
  }, {
    name: "Alto Boa Vista",
  }, {
    name: "Alto Caparaó",
  }, {
    name: "Alto Feliz",
  }, {
    name: "Alto Garças",
  }, {
    name: "Alto Horizonte",
  }, {
    name: "Alto Jequitibá",
  }, {
    name: "Alto Longá",
  }, {
    name: "Alto Paraguai",
  }, {
    name: "Alto Paraná",
  }, {
    name: "Alto Paraíso",
  }, {
    name: "Alto Paraíso de Goiás",
  }, {
    name: "Alto Parnaíba",
  }, {
    name: "Alto Piquiri",
  }, {
    name: "Alto Rio Doce",
  }, {
    name: "Alto Rio Novo",
  }, {
    name: "Alto Santo",
  }, {
    name: "Alto Taquari",
  }, {
    name: "Alto do Rodrigues",
  }, {
    name: "Altos",
  }, {
    name: "Altônia",
  }, {
    name: "Alumínio",
  }, {
    name: "Alvarenga",
  }, {
    name: "Alvarães",
  }, {
    name: "Alvinlândia",
  }, {
    name: "Alvinópolis",
  }, {
    name: "Alvorada",
  }, {
    name: "Alvorada D'Oeste",
  }, {
    name: "Alvorada de Minas",
  }, {
    name: "Alvorada do Gurguéia",
  }, {
    name: "Alvorada do Norte",
  }, {
    name: "Alvorada do Sul",
  }, {
    name: "Além Paraíba",
  }, {
    name: "Amajari",
  }, {
    name: "Amambai",
  }, {
    name: "Amaporã",
  }, {
    name: "Amapá",
  }, {
    name: "Amapá do Maranhão",
  }, {
    name: "Amaraji",
  }, {
    name: "Amaral Ferrador",
  }, {
    name: "Amaralina",
  }, {
    name: "Amarante",
  }, {
    name: "Amarante do Maranhão",
  }, {
    name: "Amargosa",
  }, {
    name: "Amaturá",
  }, {
    name: "Americana",
  }, {
    name: "Americano do Brasil",
  }, {
    name: "Ametista do Sul",
  }, {
    name: "Amontada",
  }, {
    name: "Amorinópolis",
  }, {
    name: "Amparo",
  }, {
    name: "Amparo de São Francisco",
  }, {
    name: "Amparo do Serra",
  }, {
    name: "Ampére",
  }, {
    name: "Amélia Rodrigues",
  }, {
    name: "América Dourada",
  }, {
    name: "Américo Brasiliense",
  }, {
    name: "Américo de Campos",
  }, {
    name: "Anadia",
  }, {
    name: "Anagé",
  }, {
    name: "Anahy",
  }, {
    name: "Anajatuba",
  }, {
    name: "Anajás",
  }, {
    name: "Analândia",
  }, {
    name: "Anamã",
  }, {
    name: "Ananindeua",
  }, {
    name: "Ananás",
  }, {
    name: "Anapu",
  }, {
    name: "Anapurus",
  }, {
    name: "Anastácio",
  }, {
    name: "Anaurilândia",
  }, {
    name: "Anchieta",
  }, {
    name: "Andaraí",
  }, {
    name: "Andirá",
  }, {
    name: "Andorinha",
  }, {
    name: "Andradas",
  }, {
    name: "Andradina",
  }, {
    name: "Andrelândia",
  }, {
    name: "André da Rocha",
  }, {
    name: "Angatuba",
  }, {
    name: "Angelim",
  }, {
    name: "Angelina",
  }, {
    name: "Angelândia",
  }, {
    name: "Angical",
  }, {
    name: "Angical do Piauí",
  }, {
    name: "Angico",
  }, {
    name: "Angicos",
  }, {
    name: "Angra dos Reis",
  }, {
    name: "Anguera",
  }, {
    name: "Angélica",
  }, {
    name: "Anhanguera",
  }, {
    name: "Anhembi",
  }, {
    name: "Anhumas",
  }, {
    name: "Anicuns",
  }, {
    name: "Anita Garibaldi",
  }, {
    name: "Anitápolis",
  }, {
    name: "Anori",
  }, {
    name: "Anta Gorda",
  }, {
    name: "Antas",
  }, {
    name: "Antonina",
  }, {
    name: "Antonina do Norte",
  }, {
    name: "Antônio Almeida",
  }, {
    name: "Antônio Cardoso",
  }, {
    name: "Antônio Carlos",
  }, {
    name: "Antônio Dias",
  }, {
    name: "Antônio Gonçalves",
  }, {
    name: "Antônio João",
  }, {
    name: "Antônio Martins",
  }, {
    name: "Antônio Olinto",
  }, {
    name: "Antônio Prado",
  }, {
    name: "Antônio Prado de Minas",
  }, {
    name: "Anápolis",
  }, {
    name: "Anísio de Abreu",
  }, {
    name: "Aparecida",
  }, {
    name: "Aparecida d'Oeste",
  }, {
    name: "Aparecida de Goiânia",
  }, {
    name: "Aparecida do Rio Doce",
  }, {
    name: "Aparecida do Rio Negro",
  }, {
    name: "Aparecida do Taboado",
  }, {
    name: "Aperibé",
  }, {
    name: "Apiacá",
  }, {
    name: "Apiacás",
  }, {
    name: "Apiaí",
  }, {
    name: "Apicum-Açu",
  }, {
    name: "Apiúna",
  }, {
    name: "Apodi",
  }, {
    name: "Aporá",
  }, {
    name: "Aporé",
  }, {
    name: "Apuarema",
  }, {
    name: "Apucarana",
  }, {
    name: "Apuiarés",
  }, {
    name: "Apuí",
  }, {
    name: "Aquidabã",
  }, {
    name: "Aquidauana",
  }, {
    name: "Aquiraz",
  }, {
    name: "Arabutã",
  }, {
    name: "Aracaju",
  }, {
    name: "Aracati",
  }, {
    name: "Aracatu",
  }, {
    name: "Araci",
  }, {
    name: "Aracitaba",
  }, {
    name: "Aracoiaba",
  }, {
    name: "Aracruz",
  }, {
    name: "Aragarças",
  }, {
    name: "Aragoiânia",
  }, {
    name: "Aragominas",
  }, {
    name: "Araguacema",
  }, {
    name: "Araguaiana",
  }, {
    name: "Araguainha",
  }, {
    name: "Araguanã",
  }, {
    name: "Araguapaz",
  }, {
    name: "Araguari",
  }, {
    name: "Araguatins",
  }, {
    name: "Araguaçu",
  }, {
    name: "Araguaína",
  }, {
    name: "Araioses",
  }, {
    name: "Aral Moreira",
  }, {
    name: "Aramari",
  }, {
    name: "Arambaré",
  }, {
    name: "Arame",
  }, {
    name: "Aramina",
  }, {
    name: "Arandu",
  }, {
    name: "Arantina",
  }, {
    name: "Arapeí",
  }, {
    name: "Arapiraca",
  }, {
    name: "Arapoema",
  }, {
    name: "Araponga",
  }, {
    name: "Arapongas",
  }, {
    name: "Araporã",
  }, {
    name: "Arapoti",
  }, {
    name: "Araputanga",
  }, {
    name: "Arapuá",
  }, {
    name: "Arapuã",
  }, {
    name: "Araquari",
  }, {
    name: "Arara",
  }, {
    name: "Araranguá",
  }, {
    name: "Araraquara",
  }, {
    name: "Araras",
  }, {
    name: "Ararendá",
  }, {
    name: "Arari",
  }, {
    name: "Araricá",
  }, {
    name: "Araripe",
  }, {
    name: "Araripina",
  }, {
    name: "Araruama",
  }, {
    name: "Araruna",
  }, {
    name: "Arataca",
  }, {
    name: "Aratiba",
  }, {
    name: "Aratuba",
  }, {
    name: "Aratuípe",
  }, {
    name: "Araucária",
  }, {
    name: "Arauá",
  }, {
    name: "Araxá",
  }, {
    name: "Araçagi",
  }, {
    name: "Araçariguama",
  }, {
    name: "Araçatuba",
  }, {
    name: "Araçaí",
  }, {
    name: "Araçoiaba",
  }, {
    name: "Araçoiaba da Serra",
  }, {
    name: "Araçu",
  }, {
    name: "Araçuaí",
  }, {
    name: "Araçás",
  }, {
    name: "Araújos",
  }, {
    name: "Arceburgo",
  }, {
    name: "Arco-Íris",
  }, {
    name: "Arcos",
  }, {
    name: "Arcoverde",
  }, {
    name: "Areado",
  }, {
    name: "Areal",
  }, {
    name: "Arealva",
  }, {
    name: "Areia",
  }, {
    name: "Areia Branca",
  }, {
    name: "Areia de Baraúnas",
  }, {
    name: "Areial",
  }, {
    name: "Areias",
  }, {
    name: "Areiópolis",
  }, {
    name: "Arenápolis",
  }, {
    name: "Arenópolis",
  }, {
    name: "Argirita",
  }, {
    name: "Aricanduva",
  }, {
    name: "Arinos",
  }, {
    name: "Aripuanã",
  }, {
    name: "Ariquemes",
  }, {
    name: "Ariranha",
  }, {
    name: "Ariranha do Ivaí",
  }, {
    name: "Armazém",
  }, {
    name: "Armação dos Búzios",
  }, {
    name: "Arneiroz",
  }, {
    name: "Aroazes",
  }, {
    name: "Aroeiras",
  }, {
    name: "Aroeiras do Itaim",
  }, {
    name: "Arraial",
  }, {
    name: "Arraial do Cabo",
  }, {
    name: "Arraias",
  }, {
    name: "Arroio Grande",
  }, {
    name: "Arroio Trinta",
  }, {
    name: "Arroio do Meio",
  }, {
    name: "Arroio do Padre",
  }, {
    name: "Arroio do Sal",
  }, {
    name: "Arroio do Tigre",
  }, {
    name: "Arroio dos Ratos",
  }, {
    name: "Artur Nogueira",
  }, {
    name: "Aruanã",
  }, {
    name: "Arujá",
  }, {
    name: "Arvoredo",
  }, {
    name: "Arvorezinha",
  }, {
    name: "Arês",
  }, {
    name: "Ascurra",
  }, {
    name: "Aspásia",
  }, {
    name: "Assaré",
  }, {
    name: "Assaí",
  }, {
    name: "Assis",
  }, {
    name: "Assis Brasil",
  }, {
    name: "Assis Chateaubriand",
  }, {
    name: "Assunção",
  }, {
    name: "Assunção do Piauí",
  }, {
    name: "Astolfo Dutra",
  }, {
    name: "Astorga",
  }, {
    name: "Atalaia",
  }, {
    name: "Atalaia do Norte",
  }, {
    name: "Atalanta",
  }, {
    name: "Ataléia",
  }, {
    name: "Atibaia",
  }, {
    name: "Atílio Vivacqua",
  }, {
    name: "Augustinópolis",
  }, {
    name: "Augusto Corrêa",
  }, {
    name: "Augusto Pestana",
  }, {
    name: "Augusto de Lima",
  }, {
    name: "Aurelino Leal",
  }, {
    name: "Auriflama",
  }, {
    name: "Aurilândia",
  }, {
    name: "Aurora",
  }, {
    name: "Aurora do Pará",
  }, {
    name: "Aurora do Tocantins",
  }, {
    name: "Autazes",
  }, {
    name: "Avanhandava",
  }, {
    name: "Avaré",
  }, {
    name: "Avaí",
  }, {
    name: "Aveiro",
  }, {
    name: "Avelino Lopes",
  }, {
    name: "Avelinópolis",
  }, {
    name: "Axixá",
  }, {
    name: "Axixá do Tocantins",
  }, {
    name: "Açailândia",
  }, {
    name: "Açu",
  }, {
    name: "Açucena",
  }, {
    name: "Babaçulândia",
  }, {
    name: "Bacabal",
  }, {
    name: "Bacabeira",
  }, {
    name: "Bacuri",
  }, {
    name: "Bacurituba",
  }, {
    name: "Bady Bassitt",
  }, {
    name: "Baependi",
  }, {
    name: "Bagre",
  }, {
    name: "Bagé",
  }, {
    name: "Baianópolis",
  }, {
    name: "Baixa Grande",
  }, {
    name: "Baixa Grande do Ribeiro",
  }, {
    name: "Baixio",
  }, {
    name: "Baixo Guandu",
  }, {
    name: "Baião",
  }, {
    name: "Balbinos",
  }, {
    name: "Baldim",
  }, {
    name: "Baliza",
  }, {
    name: "Balneário Arroio do Silva",
  }, {
    name: "Balneário Barra do Sul",
  }, {
    name: "Balneário Camboriú",
  }, {
    name: "Balneário Gaivota",
  }, {
    name: "Balneário Pinhal",
  }, {
    name: "Balneário Piçarras",
  }, {
    name: "Balneário Rincão",
  }, {
    name: "Balsa Nova",
  }, {
    name: "Balsas",
  }, {
    name: "Bambuí",
  }, {
    name: "Banabuiú",
  }, {
    name: "Bananal",
  }, {
    name: "Bananeiras",
  }, {
    name: "Bandeira",
  }, {
    name: "Bandeira do Sul",
  }, {
    name: "Bandeirante",
  }, {
    name: "Bandeirantes",
  }, {
    name: "Bandeirantes do Tocantins",
  }, {
    name: "Bannach",
  }, {
    name: "Banzaê",
  }, {
    name: "Baraúna",
  }, {
    name: "Barbacena",
  }, {
    name: "Barbalha",
  }, {
    name: "Barbosa",
  }, {
    name: "Barbosa Ferraz",
  }, {
    name: "Barcarena",
  }, {
    name: "Barcelona",
  }, {
    name: "Barcelos",
  }, {
    name: "Bariri",
  }, {
    name: "Barra",
  }, {
    name: "Barra Bonita",
  }, {
    name: "Barra D'Alcântara",
  }, {
    name: "Barra Funda",
  }, {
    name: "Barra Longa",
  }, {
    name: "Barra Mansa",
  }, {
    name: "Barra Velha",
  }, {
    name: "Barra da Estiva",
  }, {
    name: "Barra de Guabiraba",
  }, {
    name: "Barra de Santa Rosa",
  }, {
    name: "Barra de Santana",
  }, {
    name: "Barra de Santo Antônio",
  }, {
    name: "Barra de São Francisco",
  }, {
    name: "Barra de São Miguel",
  }, {
    name: "Barra do Bugres",
  }, {
    name: "Barra do Chapéu",
  }, {
    name: "Barra do Choça",
  }, {
    name: "Barra do Corda",
  }, {
    name: "Barra do Garças",
  }, {
    name: "Barra do Guarita",
  }, {
    name: "Barra do Jacaré",
  }, {
    name: "Barra do Mendes",
  }, {
    name: "Barra do Ouro",
  }, {
    name: "Barra do Piraí",
  }, {
    name: "Barra do Quaraí",
  }, {
    name: "Barra do Ribeiro",
  }, {
    name: "Barra do Rio Azul",
  }, {
    name: "Barra do Rocha",
  }, {
    name: "Barra do Turvo",
  }, {
    name: "Barra dos Coqueiros",
  }, {
    name: "Barracão",
  }, {
    name: "Barras",
  }, {
    name: "Barreira",
  }, {
    name: "Barreiras",
  }, {
    name: "Barreiras do Piauí",
  }, {
    name: "Barreirinha",
  }, {
    name: "Barreirinhas",
  }, {
    name: "Barreiros",
  }, {
    name: "Barretos",
  }, {
    name: "Barrinha",
  }, {
    name: "Barro",
  }, {
    name: "Barro Alto",
  }, {
    name: "Barro Duro",
  }, {
    name: "Barro Preto",
  }, {
    name: "Barrocas",
  }, {
    name: "Barrolândia",
  }, {
    name: "Barroquinha",
  }, {
    name: "Barros Cassal",
  }, {
    name: "Barroso",
  }, {
    name: "Barueri",
  }, {
    name: "Barão",
  }, {
    name: "Barão de Antonina",
  }, {
    name: "Barão de Cocais",
  }, {
    name: "Barão de Cotegipe",
  }, {
    name: "Barão de Grajaú",
  }, {
    name: "Barão de Melgaço",
  }, {
    name: "Barão de Monte Alto",
  }, {
    name: "Barão do Triunfo",
  }, {
    name: "Bastos",
  }, {
    name: "Bataguassu",
  }, {
    name: "Batalha",
  }, {
    name: "Batatais",
  }, {
    name: "Batayporã",
  }, {
    name: "Baturité",
  }, {
    name: "Bauru",
  }, {
    name: "Bayeux",
  }, {
    name: "Baía Formosa",
  }, {
    name: "Baía da Traição",
  }, {
    name: "Bebedouro",
  }, {
    name: "Beberibe",
  }, {
    name: "Bela Cruz",
  }, {
    name: "Bela Vista",
  }, {
    name: "Bela Vista da Caroba",
  }, {
    name: "Bela Vista de Goiás",
  }, {
    name: "Bela Vista de Minas",
  }, {
    name: "Bela Vista do Maranhão",
  }, {
    name: "Bela Vista do Paraíso",
  }, {
    name: "Bela Vista do Piauí",
  }, {
    name: "Bela Vista do Toldo",
  }, {
    name: "Belford Roxo",
  }, {
    name: "Belmiro Braga",
  }, {
    name: "Belmonte",
  }, {
    name: "Belo Campo",
  }, {
    name: "Belo Horizonte",
  }, {
    name: "Belo Jardim",
  }, {
    name: "Belo Monte",
  }, {
    name: "Belo Oriente",
  }, {
    name: "Belo Vale",
  }, {
    name: "Belterra",
  }, {
    name: "Belágua",
  }, {
    name: "Belém",
  }, {
    name: "Belém de Maria",
  }, {
    name: "Belém do Brejo do Cruz",
  }, {
    name: "Belém do Piauí",
  }, {
    name: "Belém do São Francisco",
  }, {
    name: "Beneditinos",
  }, {
    name: "Benedito Leite",
  }, {
    name: "Benedito Novo",
  }, {
    name: "Benevides",
  }, {
    name: "Benjamin Constant",
  }, {
    name: "Benjamin Constant do Sul",
  }, {
    name: "Bento Fernandes",
  }, {
    name: "Bento Gonçalves",
  }, {
    name: "Bento de Abreu",
  }, {
    name: "Bequimão",
  }, {
    name: "Berilo",
  }, {
    name: "Berizal",
  }, {
    name: "Bernardino Batista",
  }, {
    name: "Bernardino de Campos",
  }, {
    name: "Bernardo Sayão",
  }, {
    name: "Bernardo do Mearim",
  }, {
    name: "Bertioga",
  }, {
    name: "Bertolínia",
  }, {
    name: "Bertópolis",
  }, {
    name: "Beruri",
  }, {
    name: "Betim",
  }, {
    name: "Betânia",
  }, {
    name: "Betânia do Piauí",
  }, {
    name: "Bezerros",
  }, {
    name: "Bias Fortes",
  }, {
    name: "Bicas",
  }, {
    name: "Biguaçu",
  }, {
    name: "Bilac",
  }, {
    name: "Biquinhas",
  }, {
    name: "Birigui",
  }, {
    name: "Biritiba Mirim",
  }, {
    name: "Biritinga",
  }, {
    name: "Bituruna",
  }, {
    name: "Blumenau",
  }, {
    name: "Boa Esperança",
  }, {
    name: "Boa Esperança do Iguaçu",
  }, {
    name: "Boa Esperança do Sul",
  }, {
    name: "Boa Hora",
  }, {
    name: "Boa Nova",
  }, {
    name: "Boa Ventura",
  }, {
    name: "Boa Ventura de São Roque",
  }, {
    name: "Boa Viagem",
  }, {
    name: "Boa Vista",
  }, {
    name: "Boa Vista da Aparecida",
  }, {
    name: "Boa Vista das Missões",
  }, {
    name: "Boa Vista do Buricá",
  }, {
    name: "Boa Vista do Cadeado",
  }, {
    name: "Boa Vista do Gurupi",
  }, {
    name: "Boa Vista do Incra",
  }, {
    name: "Boa Vista do Ramos",
  }, {
    name: "Boa Vista do Sul",
  }, {
    name: "Boa Vista do Tupim",
  }, {
    name: "Boca da Mata",
  }, {
    name: "Boca do Acre",
  }, {
    name: "Bocaina",
  }, {
    name: "Bocaina de Minas",
  }, {
    name: "Bocaina do Sul",
  }, {
    name: "Bocaiúva",
  }, {
    name: "Bocaiúva do Sul",
  }, {
    name: "Bodocó",
  }, {
    name: "Bodoquena",
  }, {
    name: "Bodó",
  }, {
    name: "Bofete",
  }, {
    name: "Boituva",
  }, {
    name: "Bom Conselho",
  }, {
    name: "Bom Despacho",
  }, {
    name: "Bom Jardim",
  }, {
    name: "Bom Jardim da Serra",
  }, {
    name: "Bom Jardim de Goiás",
  }, {
    name: "Bom Jardim de Minas",
  }, {
    name: "Bom Jesus",
  }, {
    name: "Bom Jesus da Lapa",
  }, {
    name: "Bom Jesus da Penha",
  }, {
    name: "Bom Jesus da Serra",
  }, {
    name: "Bom Jesus das Selvas",
  }, {
    name: "Bom Jesus de Goiás",
  }, {
    name: "Bom Jesus do Amparo",
  }, {
    name: "Bom Jesus do Araguaia",
  }, {
    name: "Bom Jesus do Galho",
  }, {
    name: "Bom Jesus do Itabapoana",
  }, {
    name: "Bom Jesus do Norte",
  }, {
    name: "Bom Jesus do Oeste",
  }, {
    name: "Bom Jesus do Sul",
  }, {
    name: "Bom Jesus do Tocantins",
  }, {
    name: "Bom Jesus dos Perdões",
  }, {
    name: "Bom Lugar",
  }, {
    name: "Bom Princípio",
  }, {
    name: "Bom Princípio do Piauí",
  }, {
    name: "Bom Progresso",
  }, {
    name: "Bom Repouso",
  }, {
    name: "Bom Retiro",
  }, {
    name: "Bom Retiro do Sul",
  }, {
    name: "Bom Sucesso",
  }, {
    name: "Bom Sucesso de Itararé",
  }, {
    name: "Bom Sucesso do Sul",
  }, {
    name: "Bombinhas",
  }, {
    name: "Bonfim",
  }, {
    name: "Bonfim do Piauí",
  }, {
    name: "Bonfinópolis",
  }, {
    name: "Bonfinópolis de Minas",
  }, {
    name: "Boninal",
  }, {
    name: "Bonito",
  }, {
    name: "Bonito de Minas",
  }, {
    name: "Bonito de Santa Fé",
  }, {
    name: "Bonópolis",
  }, {
    name: "Boqueirão",
  }, {
    name: "Boqueirão do Leão",
  }, {
    name: "Boqueirão do Piauí",
  }, {
    name: "Boquim",
  }, {
    name: "Boquira",
  }, {
    name: "Boracéia",
  }, {
    name: "Borba",
  }, {
    name: "Borborema",
  }, {
    name: "Borda da Mata",
  }, {
    name: "Borebi",
  }, {
    name: "Borrazópolis",
  }, {
    name: "Borá",
  }, {
    name: "Bossoroca",
  }, {
    name: "Botelhos",
  }, {
    name: "Botucatu",
  }, {
    name: "Botumirim",
  }, {
    name: "Botuporã",
  }, {
    name: "Botuverá",
  }, {
    name: "Bozano",
  }, {
    name: "Braga",
  }, {
    name: "Braganey",
  }, {
    name: "Bragança",
  }, {
    name: "Bragança Paulista",
  }, {
    name: "Branquinha",
  }, {
    name: "Brasil Novo",
  }, {
    name: "Brasileira",
  }, {
    name: "Brasilândia",
  }, {
    name: "Brasilândia de Minas",
  }, {
    name: "Brasilândia do Sul",
  }, {
    name: "Brasilândia do Tocantins",
  }, {
    name: "Brasiléia",
  }, {
    name: "Brasnorte",
  }, {
    name: "Brasília",
  }, {
    name: "Brasília de Minas",
  }, {
    name: "Brazabrantes",
  }, {
    name: "Brazópolis",
  }, {
    name: "Braço do Norte",
  }, {
    name: "Braço do Trombudo",
  }, {
    name: "Braúna",
  }, {
    name: "Braúnas",
  }, {
    name: "Brejetuba",
  }, {
    name: "Brejinho",
  }, {
    name: "Brejinho de Nazaré",
  }, {
    name: "Brejo",
  }, {
    name: "Brejo Alegre",
  }, {
    name: "Brejo Grande",
  }, {
    name: "Brejo Grande do Araguaia",
  }, {
    name: "Brejo Santo",
  }, {
    name: "Brejo da Madre de Deus",
  }, {
    name: "Brejo de Areia",
  }, {
    name: "Brejo do Cruz",
  }, {
    name: "Brejo do Piauí",
  }, {
    name: "Brejo dos Santos",
  }, {
    name: "Brejolândia",
  }, {
    name: "Brejão",
  }, {
    name: "Brejões",
  }, {
    name: "Breu Branco",
  }, {
    name: "Breves",
  }, {
    name: "Britânia",
  }, {
    name: "Brochier",
  }, {
    name: "Brodowski",
  }, {
    name: "Brotas",
  }, {
    name: "Brotas de Macaúbas",
  }, {
    name: "Brumadinho",
  }, {
    name: "Brumado",
  }, {
    name: "Brunópolis",
  }, {
    name: "Brusque",
  }, {
    name: "Brás Pires",
  }, {
    name: "Bueno Brandão",
  }, {
    name: "Buenos Aires",
  }, {
    name: "Buenópolis",
  }, {
    name: "Buerarema",
  }, {
    name: "Bugre",
  }, {
    name: "Bujari",
  }, {
    name: "Bujaru",
  }, {
    name: "Buri",
  }, {
    name: "Buritama",
  }, {
    name: "Buriti",
  }, {
    name: "Buriti Alegre",
  }, {
    name: "Buriti Bravo",
  }, {
    name: "Buriti de Goiás",
  }, {
    name: "Buriti do Tocantins",
  }, {
    name: "Buriti dos Lopes",
  }, {
    name: "Buriti dos Montes",
  }, {
    name: "Buriticupu",
  }, {
    name: "Buritinópolis",
  }, {
    name: "Buritirama",
  }, {
    name: "Buritirana",
  }, {
    name: "Buritis",
  }, {
    name: "Buritizal",
  }, {
    name: "Buritizeiro",
  }, {
    name: "Butiá",
  }, {
    name: "Buíque",
  }, {
    name: "Bálsamo",
  }, {
    name: "Caapiranga",
  }, {
    name: "Caaporã",
  }, {
    name: "Caarapó",
  }, {
    name: "Caatiba",
  }, {
    name: "Cabaceiras",
  }, {
    name: "Cabaceiras do Paraguaçu",
  }, {
    name: "Cabeceira Grande",
  }, {
    name: "Cabeceiras",
  }, {
    name: "Cabeceiras do Piauí",
  }, {
    name: "Cabedelo",
  }, {
    name: "Cabixi",
  }, {
    name: "Cabo Frio",
  }, {
    name: "Cabo Verde",
  }, {
    name: "Cabo de Santo Agostinho",
  }, {
    name: "Cabreúva",
  }, {
    name: "Cabrobó",
  }, {
    name: "Cabrália Paulista",
  }, {
    name: "Cacaulândia",
  }, {
    name: "Cacequi",
  }, {
    name: "Cachoeira",
  }, {
    name: "Cachoeira Alta",
  }, {
    name: "Cachoeira Dourada",
  }, {
    name: "Cachoeira Grande",
  }, {
    name: "Cachoeira Paulista",
  }, {
    name: "Cachoeira da Prata",
  }, {
    name: "Cachoeira de Goiás",
  }, {
    name: "Cachoeira de Minas",
  }, {
    name: "Cachoeira de Pajeú",
  }, {
    name: "Cachoeira do Arari",
  }, {
    name: "Cachoeira do Piriá",
  }, {
    name: "Cachoeira do Sul",
  }, {
    name: "Cachoeira dos Índios",
  }, {
    name: "Cachoeiras de Macacu",
  }, {
    name: "Cachoeirinha",
  }, {
    name: "Cachoeiro de Itapemirim",
  }, {
    name: "Cacimba de Areia",
  }, {
    name: "Cacimba de Dentro",
  }, {
    name: "Cacimbas",
  }, {
    name: "Cacimbinhas",
  }, {
    name: "Cacique Doble",
  }, {
    name: "Cacoal",
  }, {
    name: "Caconde",
  }, {
    name: "Caculé",
  }, {
    name: "Caetanos",
  }, {
    name: "Caetanópolis",
  }, {
    name: "Caetité",
  }, {
    name: "Caeté",
  }, {
    name: "Caetés",
  }, {
    name: "Cafarnaum",
  }, {
    name: "Cafeara",
  }, {
    name: "Cafelândia",
  }, {
    name: "Cafezal do Sul",
  }, {
    name: "Caiabu",
  }, {
    name: "Caiana",
  }, {
    name: "Caiapônia",
  }, {
    name: "Caibaté",
  }, {
    name: "Caibi",
  }, {
    name: "Caicó",
  }, {
    name: "Caieiras",
  }, {
    name: "Cairu",
  }, {
    name: "Caiuá",
  }, {
    name: "Caiçara",
  }, {
    name: "Caiçara do Norte",
  }, {
    name: "Caiçara do Rio do Vento",
  }, {
    name: "Cajamar",
  }, {
    name: "Cajapió",
  }, {
    name: "Cajari",
  }, {
    name: "Cajati",
  }, {
    name: "Cajazeiras",
  }, {
    name: "Cajazeiras do Piauí",
  }, {
    name: "Cajazeirinhas",
  }, {
    name: "Cajobi",
  }, {
    name: "Cajueiro",
  }, {
    name: "Cajueiro da Praia",
  }, {
    name: "Cajuri",
  }, {
    name: "Cajuru",
  }, {
    name: "Caldas",
  }, {
    name: "Caldas Brandão",
  }, {
    name: "Caldas Novas",
  }, {
    name: "Caldazinha",
  }, {
    name: "Caldeirão Grande",
  }, {
    name: "Caldeirão Grande do Piauí",
  }, {
    name: "Califórnia",
  }, {
    name: "Calmon",
  }, {
    name: "Calumbi",
  }, {
    name: "Calçado",
  }, {
    name: "Calçoene",
  }, {
    name: "Camacan",
  }, {
    name: "Camacho",
  }, {
    name: "Camalaú",
  }, {
    name: "Camamu",
  }, {
    name: "Camanducaia",
  }, {
    name: "Camapuã",
  }, {
    name: "Camaquã",
  }, {
    name: "Camaragibe",
  }, {
    name: "Camargo",
  }, {
    name: "Camaçari",
  }, {
    name: "Cambará",
  }, {
    name: "Cambará do Sul",
  }, {
    name: "Cambira",
  }, {
    name: "Camboriú",
  }, {
    name: "Cambuci",
  }, {
    name: "Cambuquira",
  }, {
    name: "Cambuí",
  }, {
    name: "Cambé",
  }, {
    name: "Cametá",
  }, {
    name: "Camocim",
  }, {
    name: "Camocim de São Félix",
  }, {
    name: "Campanha",
  }, {
    name: "Campanário",
  }, {
    name: "Campestre",
  }, {
    name: "Campestre da Serra",
  }, {
    name: "Campestre de Goiás",
  }, {
    name: "Campestre do Maranhão",
  }, {
    name: "Campina Grande",
  }, {
    name: "Campina Grande do Sul",
  }, {
    name: "Campina Verde",
  }, {
    name: "Campina da Lagoa",
  }, {
    name: "Campina das Missões",
  }, {
    name: "Campina do Monte Alegre",
  }, {
    name: "Campina do Simão",
  }, {
    name: "Campinas",
  }, {
    name: "Campinas do Piauí",
  }, {
    name: "Campinas do Sul",
  }, {
    name: "Campinaçu",
  }, {
    name: "Campinorte",
  }, {
    name: "Campinápolis",
  }, {
    name: "Campo Alegre",
  }, {
    name: "Campo Alegre de Goiás",
  }, {
    name: "Campo Alegre de Lourdes",
  }, {
    name: "Campo Alegre do Fidalgo",
  }, {
    name: "Campo Azul",
  }, {
    name: "Campo Belo",
  }, {
    name: "Campo Belo do Sul",
  }, {
    name: "Campo Bom",
  }, {
    name: "Campo Bonito",
  }, {
    name: "Campo Erê",
  }, {
    name: "Campo Florido",
  }, {
    name: "Campo Formoso",
  }, {
    name: "Campo Grande",
  }, {
    name: "Campo Grande do Piauí",
  }, {
    name: "Campo Largo",
  }, {
    name: "Campo Largo do Piauí",
  }, {
    name: "Campo Limpo Paulista",
  }, {
    name: "Campo Limpo de Goiás",
  }, {
    name: "Campo Magro",
  }, {
    name: "Campo Maior",
  }, {
    name: "Campo Mourão",
  }, {
    name: "Campo Novo",
  }, {
    name: "Campo Novo de Rondônia",
  }, {
    name: "Campo Novo do Parecis",
  }, {
    name: "Campo Redondo",
  }, {
    name: "Campo Verde",
  }, {
    name: "Campo do Brito",
  }, {
    name: "Campo do Meio",
  }, {
    name: "Campo do Tenente",
  }, {
    name: "Campos Altos",
  }, {
    name: "Campos Belos",
  }, {
    name: "Campos Borges",
  }, {
    name: "Campos Gerais",
  }, {
    name: "Campos Lindos",
  }, {
    name: "Campos Novos",
  }, {
    name: "Campos Novos Paulista",
  }, {
    name: "Campos Sales",
  }, {
    name: "Campos Verdes",
  }, {
    name: "Campos de Júlio",
  }, {
    name: "Campos do Jordão",
  }, {
    name: "Campos dos Goytacazes",
  }, {
    name: "Camutanga",
  }, {
    name: "Cana Verde",
  }, {
    name: "Canabrava do Norte",
  }, {
    name: "Cananéia",
  }, {
    name: "Canapi",
  }, {
    name: "Canarana",
  }, {
    name: "Canas",
  }, {
    name: "Canavieira",
  }, {
    name: "Canavieiras",
  }, {
    name: "Canaã",
  }, {
    name: "Canaã dos Carajás",
  }, {
    name: "Candeal",
  }, {
    name: "Candeias",
  }, {
    name: "Candeias do Jamari",
  }, {
    name: "Candelária",
  }, {
    name: "Candiba",
  }, {
    name: "Candiota",
  }, {
    name: "Candói",
  }, {
    name: "Canela",
  }, {
    name: "Canelinha",
  }, {
    name: "Canguaretama",
  }, {
    name: "Canguçu",
  }, {
    name: "Canhoba",
  }, {
    name: "Canhotinho",
  }, {
    name: "Canindé",
  }, {
    name: "Canindé de São Francisco",
  }, {
    name: "Canitar",
  }, {
    name: "Canoas",
  }, {
    name: "Canoinhas",
  }, {
    name: "Cansanção",
  }, {
    name: "Cantagalo",
  }, {
    name: "Cantanhede",
  }, {
    name: "Canto do Buriti",
  }, {
    name: "Cantá",
  }, {
    name: "Canudos",
  }, {
    name: "Canudos do Vale",
  }, {
    name: "Canutama",
  }, {
    name: "Canápolis",
  }, {
    name: "Capanema",
  }, {
    name: "Caparaó",
  }, {
    name: "Capela",
  }, {
    name: "Capela Nova",
  }, {
    name: "Capela de Santana",
  }, {
    name: "Capela do Alto",
  }, {
    name: "Capela do Alto Alegre",
  }, {
    name: "Capelinha",
  }, {
    name: "Capetinga",
  }, {
    name: "Capim",
  }, {
    name: "Capim Branco",
  }, {
    name: "Capim Grosso",
  }, {
    name: "Capinzal",
  }, {
    name: "Capinzal do Norte",
  }, {
    name: "Capinópolis",
  }, {
    name: "Capistrano",
  }, {
    name: "Capitão",
  }, {
    name: "Capitão Andrade",
  }, {
    name: "Capitão Enéas",
  }, {
    name: "Capitão Gervásio Oliveira",
  }, {
    name: "Capitão Leônidas Marques",
  }, {
    name: "Capitão Poço",
  }, {
    name: "Capitão de Campos",
  }, {
    name: "Capitólio",
  }, {
    name: "Capivari",
  }, {
    name: "Capivari de Baixo",
  }, {
    name: "Capivari do Sul",
  }, {
    name: "Capixaba",
  }, {
    name: "Capoeiras",
  }, {
    name: "Caputira",
  }, {
    name: "Capão Alto",
  }, {
    name: "Capão Bonito",
  }, {
    name: "Capão Bonito do Sul",
  }, {
    name: "Capão da Canoa",
  }, {
    name: "Capão do Cipó",
  }, {
    name: "Capão do Leão",
  }, {
    name: "Caracaraí",
  }, {
    name: "Caracol",
  }, {
    name: "Caraguatatuba",
  }, {
    name: "Carambeí",
  }, {
    name: "Caranaíba",
  }, {
    name: "Carandaí",
  }, {
    name: "Carangola",
  }, {
    name: "Carapebus",
  }, {
    name: "Carapicuíba",
  }, {
    name: "Caratinga",
  }, {
    name: "Carauari",
  }, {
    name: "Caravelas",
  }, {
    name: "Carazinho",
  }, {
    name: "Caraá",
  }, {
    name: "Caraí",
  }, {
    name: "Caraíbas",
  }, {
    name: "Caraúbas",
  }, {
    name: "Caraúbas do Piauí",
  }, {
    name: "Carbonita",
  }, {
    name: "Cardeal da Silva",
  }, {
    name: "Cardoso",
  }, {
    name: "Cardoso Moreira",
  }, {
    name: "Careaçu",
  }, {
    name: "Careiro",
  }, {
    name: "Careiro da Várzea",
  }, {
    name: "Cariacica",
  }, {
    name: "Caridade",
  }, {
    name: "Caridade do Piauí",
  }, {
    name: "Carinhanha",
  }, {
    name: "Carira",
  }, {
    name: "Cariri do Tocantins",
  }, {
    name: "Caririaçu",
  }, {
    name: "Cariré",
  }, {
    name: "Cariús",
  }, {
    name: "Carlinda",
  }, {
    name: "Carlos Barbosa",
  }, {
    name: "Carlos Chagas",
  }, {
    name: "Carlos Gomes",
  }, {
    name: "Carlópolis",
  }, {
    name: "Carmo",
  }, {
    name: "Carmo da Cachoeira",
  }, {
    name: "Carmo da Mata",
  }, {
    name: "Carmo de Minas",
  }, {
    name: "Carmo do Cajuru",
  }, {
    name: "Carmo do Paranaíba",
  }, {
    name: "Carmo do Rio Claro",
  }, {
    name: "Carmo do Rio Verde",
  }, {
    name: "Carmolândia",
  }, {
    name: "Carmésia",
  }, {
    name: "Carmópolis",
  }, {
    name: "Carmópolis de Minas",
  }, {
    name: "Carnaubais",
  }, {
    name: "Carnaubal",
  }, {
    name: "Carnaubeira da Penha",
  }, {
    name: "Carnaíba",
  }, {
    name: "Carnaúba dos Dantas",
  }, {
    name: "Carneirinho",
  }, {
    name: "Carneiros",
  }, {
    name: "Caroebe",
  }, {
    name: "Carolina",
  }, {
    name: "Carpina",
  }, {
    name: "Carrancas",
  }, {
    name: "Carrapateira",
  }, {
    name: "Carrasco Bonito",
  }, {
    name: "Caruaru",
  }, {
    name: "Carutapera",
  }, {
    name: "Carvalhos",
  }, {
    name: "Carvalhópolis",
  }, {
    name: "Casa Branca",
  }, {
    name: "Casa Grande",
  }, {
    name: "Casa Nova",
  }, {
    name: "Casca",
  }, {
    name: "Cascalho Rico",
  }, {
    name: "Cascavel",
  }, {
    name: "Caseara",
  }, {
    name: "Caseiros",
  }, {
    name: "Casimiro de Abreu",
  }, {
    name: "Casinhas",
  }, {
    name: "Casserengue",
  }, {
    name: "Cassilândia",
  }, {
    name: "Castanhal",
  }, {
    name: "Castanheira",
  }, {
    name: "Castanheiras",
  }, {
    name: "Castelo",
  }, {
    name: "Castelo do Piauí",
  }, {
    name: "Castelândia",
  }, {
    name: "Castilho",
  }, {
    name: "Castro",
  }, {
    name: "Castro Alves",
  }, {
    name: "Cataguases",
  }, {
    name: "Catalão",
  }, {
    name: "Catanduva",
  }, {
    name: "Catanduvas",
  }, {
    name: "Catarina",
  }, {
    name: "Catas Altas",
  }, {
    name: "Catas Altas da Noruega",
  }, {
    name: "Catende",
  }, {
    name: "Catiguá",
  }, {
    name: "Catingueira",
  }, {
    name: "Catolândia",
  }, {
    name: "Catolé do Rocha",
  }, {
    name: "Catu",
  }, {
    name: "Catuji",
  }, {
    name: "Catunda",
  }, {
    name: "Caturama",
  }, {
    name: "Caturaí",
  }, {
    name: "Caturité",
  }, {
    name: "Catuti",
  }, {
    name: "Catuípe",
  }, {
    name: "Caucaia",
  }, {
    name: "Cavalcante",
  }, {
    name: "Caxambu",
  }, {
    name: "Caxambu do Sul",
  }, {
    name: "Caxias",
  }, {
    name: "Caxias do Sul",
  }, {
    name: "Caxingó",
  }, {
    name: "Caçador",
  }, {
    name: "Caçapava",
  }, {
    name: "Caçapava do Sul",
  }, {
    name: "Caçu",
  }, {
    name: "Caém",
  }, {
    name: "Ceará-Mirim",
  }, {
    name: "Cedral",
  }, {
    name: "Cedro",
  }, {
    name: "Cedro de São João",
  }, {
    name: "Cedro do Abaeté",
  }, {
    name: "Celso Ramos",
  }, {
    name: "Centenário",
  }, {
    name: "Centenário do Sul",
  }, {
    name: "Central",
  }, {
    name: "Central de Minas",
  }, {
    name: "Central do Maranhão",
  }, {
    name: "Centralina",
  }, {
    name: "Centro Novo do Maranhão",
  }, {
    name: "Centro do Guilherme",
  }, {
    name: "Cerejeiras",
  }, {
    name: "Ceres",
  }, {
    name: "Cerqueira César",
  }, {
    name: "Cerquilho",
  }, {
    name: "Cerrito",
  }, {
    name: "Cerro Azul",
  }, {
    name: "Cerro Branco",
  }, {
    name: "Cerro Corá",
  }, {
    name: "Cerro Grande",
  }, {
    name: "Cerro Grande do Sul",
  }, {
    name: "Cerro Largo",
  }, {
    name: "Cerro Negro",
  }, {
    name: "Cesário Lange",
  }, {
    name: "Cezarina",
  }, {
    name: "Chalé",
  }, {
    name: "Chapada",
  }, {
    name: "Chapada Gaúcha",
  }, {
    name: "Chapada da Natividade",
  }, {
    name: "Chapada de Areia",
  }, {
    name: "Chapada do Norte",
  }, {
    name: "Chapada dos Guimarães",
  }, {
    name: "Chapadinha",
  }, {
    name: "Chapadão do Céu",
  }, {
    name: "Chapadão do Lageado",
  }, {
    name: "Chapadão do Sul",
  }, {
    name: "Chapecó",
  }, {
    name: "Charqueada",
  }, {
    name: "Charqueadas",
  }, {
    name: "Charrua",
  }, {
    name: "Chaval",
  }, {
    name: "Chavantes",
  }, {
    name: "Chaves",
  }, {
    name: "Chiador",
  }, {
    name: "Chiapetta",
  }, {
    name: "Chopinzinho",
  }, {
    name: "Chorozinho",
  }, {
    name: "Chorrochó",
  }, {
    name: "Choró",
  }, {
    name: "Chupinguaia",
  }, {
    name: "Chuvisca",
  }, {
    name: "Chuí",
  }, {
    name: "Chácara",
  }, {
    name: "Chã Grande",
  }, {
    name: "Chã Preta",
  }, {
    name: "Chã de Alegria",
  }, {
    name: "Cianorte",
  }, {
    name: "Cidade Gaúcha",
  }, {
    name: "Cidade Ocidental",
  }, {
    name: "Cidelândia",
  }, {
    name: "Cidreira",
  }, {
    name: "Cipotânea",
  }, {
    name: "Cipó",
  }, {
    name: "Ciríaco",
  }, {
    name: "Claraval",
  }, {
    name: "Claro dos Poções",
  }, {
    name: "Clementina",
  }, {
    name: "Clevelândia",
  }, {
    name: "Cláudia",
  }, {
    name: "Cláudio",
  }, {
    name: "Coaraci",
  }, {
    name: "Coari",
  }, {
    name: "Cocal",
  }, {
    name: "Cocal de Telha",
  }, {
    name: "Cocal do Sul",
  }, {
    name: "Cocal dos Alves",
  }, {
    name: "Cocalinho",
  }, {
    name: "Cocalzinho de Goiás",
  }, {
    name: "Cocos",
  }, {
    name: "Codajás",
  }, {
    name: "Codó",
  }, {
    name: "Coelho Neto",
  }, {
    name: "Coimbra",
  }, {
    name: "Coité do Nóia",
  }, {
    name: "Coivaras",
  }, {
    name: "Colares",
  }, {
    name: "Colatina",
  }, {
    name: "Colina",
  }, {
    name: "Colinas",
  }, {
    name: "Colinas do Sul",
  }, {
    name: "Colinas do Tocantins",
  }, {
    name: "Colméia",
  }, {
    name: "Colniza",
  }, {
    name: "Colombo",
  }, {
    name: "Colorado",
  }, {
    name: "Colorado do Oeste",
  }, {
    name: "Coluna",
  }, {
    name: "Colíder",
  }, {
    name: "Colômbia",
  }, {
    name: "Colônia Leopoldina",
  }, {
    name: "Colônia do Gurguéia",
  }, {
    name: "Colônia do Piauí",
  }, {
    name: "Combinado",
  }, {
    name: "Comendador Gomes",
  }, {
    name: "Comendador Levy Gasparian",
  }, {
    name: "Comercinho",
  }, {
    name: "Comodoro",
  }, {
    name: "Conceição",
  }, {
    name: "Conceição da Aparecida",
  }, {
    name: "Conceição da Barra",
  }, {
    name: "Conceição da Barra de Minas",
  }, {
    name: "Conceição da Feira",
  }, {
    name: "Conceição das Alagoas",
  }, {
    name: "Conceição das Pedras",
  }, {
    name: "Conceição de Ipanema",
  }, {
    name: "Conceição de Macabu",
  }, {
    name: "Conceição do Almeida",
  }, {
    name: "Conceição do Araguaia",
  }, {
    name: "Conceição do Canindé",
  }, {
    name: "Conceição do Castelo",
  }, {
    name: "Conceição do Coité",
  }, {
    name: "Conceição do Jacuípe",
  }, {
    name: "Conceição do Lago-Açu",
  }, {
    name: "Conceição do Mato Dentro",
  }, {
    name: "Conceição do Pará",
  }, {
    name: "Conceição do Rio Verde",
  }, {
    name: "Conceição do Tocantins",
  }, {
    name: "Conceição dos Ouros",
  }, {
    name: "Conchal",
  }, {
    name: "Conchas",
  }, {
    name: "Concórdia",
  }, {
    name: "Concórdia do Pará",
  }, {
    name: "Condado",
  }, {
    name: "Conde",
  }, {
    name: "Condeúba",
  }, {
    name: "Condor",
  }, {
    name: "Confins",
  }, {
    name: "Confresa",
  }, {
    name: "Congo",
  }, {
    name: "Congonhal",
  }, {
    name: "Congonhas",
  }, {
    name: "Congonhas do Norte",
  }, {
    name: "Congonhinhas",
  }, {
    name: "Conquista",
  }, {
    name: "Conquista D'Oeste",
  }, {
    name: "Conselheiro Lafaiete",
  }, {
    name: "Conselheiro Mairinck",
  }, {
    name: "Conselheiro Pena",
  }, {
    name: "Consolação",
  }, {
    name: "Constantina",
  }, {
    name: "Contagem",
  }, {
    name: "Contenda",
  }, {
    name: "Contendas do Sincorá",
  }, {
    name: "Coqueiral",
  }, {
    name: "Coqueiro Baixo",
  }, {
    name: "Coqueiro Seco",
  }, {
    name: "Coqueiros do Sul",
  }, {
    name: "Coração de Jesus",
  }, {
    name: "Coração de Maria",
  }, {
    name: "Corbélia",
  }, {
    name: "Cordeiro",
  }, {
    name: "Cordeiros",
  }, {
    name: "Cordeirópolis",
  }, {
    name: "Cordilheira Alta",
  }, {
    name: "Cordisburgo",
  }, {
    name: "Cordislândia",
  }, {
    name: "Coreaú",
  }, {
    name: "Coremas",
  }, {
    name: "Corguinho",
  }, {
    name: "Coribe",
  }, {
    name: "Corinto",
  }, {
    name: "Cornélio Procópio",
  }, {
    name: "Coroaci",
  }, {
    name: "Coroados",
  }, {
    name: "Coroatá",
  }, {
    name: "Coromandel",
  }, {
    name: "Coronel Barros",
  }, {
    name: "Coronel Bicaco",
  }, {
    name: "Coronel Domingos Soares",
  }, {
    name: "Coronel Ezequiel",
  }, {
    name: "Coronel Fabriciano",
  }, {
    name: "Coronel Freitas",
  }, {
    name: "Coronel José Dias",
  }, {
    name: "Coronel João Pessoa",
  }, {
    name: "Coronel João Sá",
  }, {
    name: "Coronel Macedo",
  }, {
    name: "Coronel Martins",
  }, {
    name: "Coronel Murta",
  }, {
    name: "Coronel Pacheco",
  }, {
    name: "Coronel Pilar",
  }, {
    name: "Coronel Sapucaia",
  }, {
    name: "Coronel Vivida",
  }, {
    name: "Coronel Xavier Chaves",
  }, {
    name: "Correia Pinto",
  }, {
    name: "Corrente",
  }, {
    name: "Correntes",
  }, {
    name: "Correntina",
  }, {
    name: "Cortês",
  }, {
    name: "Corumbataí",
  }, {
    name: "Corumbataí do Sul",
  }, {
    name: "Corumbaíba",
  }, {
    name: "Corumbiara",
  }, {
    name: "Corumbá",
  }, {
    name: "Corumbá de Goiás",
  }, {
    name: "Corupá",
  }, {
    name: "Coruripe",
  }, {
    name: "Cosmorama",
  }, {
    name: "Cosmópolis",
  }, {
    name: "Costa Marques",
  }, {
    name: "Costa Rica",
  }, {
    name: "Cotegipe",
  }, {
    name: "Cotia",
  }, {
    name: "Cotiporã",
  }, {
    name: "Cotriguaçu",
  }, {
    name: "Couto Magalhães",
  }, {
    name: "Couto de Magalhães de Minas",
  }, {
    name: "Coxilha",
  }, {
    name: "Coxim",
  }, {
    name: "Coxixola",
  }, {
    name: "Crateús",
  }, {
    name: "Crato",
  }, {
    name: "Cravinhos",
  }, {
    name: "Cravolândia",
  }, {
    name: "Craíbas",
  }, {
    name: "Criciúma",
  }, {
    name: "Crissiumal",
  }, {
    name: "Cristais",
  }, {
    name: "Cristais Paulista",
  }, {
    name: "Cristal",
  }, {
    name: "Cristal do Sul",
  }, {
    name: "Cristalina",
  }, {
    name: "Cristalândia",
  }, {
    name: "Cristalândia do Piauí",
  }, {
    name: "Cristiano Otoni",
  }, {
    name: "Cristianópolis",
  }, {
    name: "Cristina",
  }, {
    name: "Cristino Castro",
  }, {
    name: "Cristinápolis",
  }, {
    name: "Cristália",
  }, {
    name: "Cristópolis",
  }, {
    name: "Crisólita",
  }, {
    name: "Crisópolis",
  }, {
    name: "Crixás",
  }, {
    name: "Crixás do Tocantins",
  }, {
    name: "Croatá",
  }, {
    name: "Cromínia",
  }, {
    name: "Crucilândia",
  }, {
    name: "Cruz",
  }, {
    name: "Cruz Alta",
  }, {
    name: "Cruz Machado",
  }, {
    name: "Cruz das Almas",
  }, {
    name: "Cruz do Espírito Santo",
  }, {
    name: "Cruzaltense",
  }, {
    name: "Cruzeiro",
  }, {
    name: "Cruzeiro da Fortaleza",
  }, {
    name: "Cruzeiro do Iguaçu",
  }, {
    name: "Cruzeiro do Oeste",
  }, {
    name: "Cruzeiro do Sul",
  }, {
    name: "Cruzeta",
  }, {
    name: "Cruzmaltina",
  }, {
    name: "Cruzália",
  }, {
    name: "Cruzília",
  }, {
    name: "Cubati",
  }, {
    name: "Cubatão",
  }, {
    name: "Cuiabá",
  }, {
    name: "Cuitegi",
  }, {
    name: "Cuité",
  }, {
    name: "Cuité de Mamanguape",
  }, {
    name: "Cujubim",
  }, {
    name: "Cumari",
  }, {
    name: "Cumaru",
  }, {
    name: "Cumaru do Norte",
  }, {
    name: "Cumbe",
  }, {
    name: "Cunha",
  }, {
    name: "Cunha Porã",
  }, {
    name: "Cunhataí",
  }, {
    name: "Cuparaque",
  }, {
    name: "Cupira",
  }, {
    name: "Curaçá",
  }, {
    name: "Curimatá",
  }, {
    name: "Curionópolis",
  }, {
    name: "Curitiba",
  }, {
    name: "Curitibanos",
  }, {
    name: "Curiúva",
  }, {
    name: "Currais",
  }, {
    name: "Currais Novos",
  }, {
    name: "Curral Novo do Piauí",
  }, {
    name: "Curral Velho",
  }, {
    name: "Curral de Cima",
  }, {
    name: "Curral de Dentro",
  }, {
    name: "Curralinho",
  }, {
    name: "Curralinhos",
  }, {
    name: "Cururupu",
  }, {
    name: "Curuá",
  }, {
    name: "Curuçá",
  }, {
    name: "Curvelo",
  }, {
    name: "Curvelândia",
  }, {
    name: "Custódia",
  }, {
    name: "Cutias",
  }, {
    name: "Cáceres",
  }, {
    name: "Cássia",
  }, {
    name: "Cássia dos Coqueiros",
  }, {
    name: "Cândido Godói",
  }, {
    name: "Cândido Mendes",
  }, {
    name: "Cândido Mota",
  }, {
    name: "Cândido Rodrigues",
  }, {
    name: "Cândido Sales",
  }, {
    name: "Cândido de Abreu",
  }, {
    name: "Céu Azul",
  }, {
    name: "Cícero Dantas",
  }, {
    name: "Córrego Danta",
  }, {
    name: "Córrego Fundo",
  }, {
    name: "Córrego Novo",
  }, {
    name: "Córrego do Bom Jesus",
  }, {
    name: "Córrego do Ouro",
  }, {
    name: "Cônego Marinho",
  }, {
    name: "Damianópolis",
  }, {
    name: "Damião",
  }, {
    name: "Damolândia",
  }, {
    name: "Darcinópolis",
  }, {
    name: "Datas",
  }, {
    name: "David Canabarro",
  }, {
    name: "Davinópolis",
  }, {
    name: "Delfim Moreira",
  }, {
    name: "Delfinópolis",
  }, {
    name: "Delmiro Gouveia",
  }, {
    name: "Delta",
  }, {
    name: "Demerval Lobão",
  }, {
    name: "Denise",
  }, {
    name: "Deodápolis",
  }, {
    name: "Deputado Irapuan Pinheiro",
  }, {
    name: "Derrubadas",
  }, {
    name: "Descalvado",
  }, {
    name: "Descanso",
  }, {
    name: "Descoberto",
  }, {
    name: "Desterro",
  }, {
    name: "Desterro de Entre Rios",
  }, {
    name: "Desterro do Melo",
  }, {
    name: "Dezesseis de Novembro",
  }, {
    name: "Diadema",
  }, {
    name: "Diamante",
  }, {
    name: "Diamante D'Oeste",
  }, {
    name: "Diamante do Norte",
  }, {
    name: "Diamante do Sul",
  }, {
    name: "Diamantina",
  }, {
    name: "Diamantino",
  }, {
    name: "Dianópolis",
  }, {
    name: "Dias d'Ávila",
  }, {
    name: "Dilermando de Aguiar",
  }, {
    name: "Diogo de Vasconcelos",
  }, {
    name: "Dionísio",
  }, {
    name: "Dionísio Cerqueira",
  }, {
    name: "Diorama",
  }, {
    name: "Dirce Reis",
  }, {
    name: "Dirceu Arcoverde",
  }, {
    name: "Divina Pastora",
  }, {
    name: "Divino",
  }, {
    name: "Divino das Laranjeiras",
  }, {
    name: "Divino de São Lourenço",
  }, {
    name: "Divinolândia",
  }, {
    name: "Divinolândia de Minas",
  }, {
    name: "Divinésia",
  }, {
    name: "Divinópolis",
  }, {
    name: "Divinópolis de Goiás",
  }, {
    name: "Divinópolis do Tocantins",
  }, {
    name: "Divisa Alegre",
  }, {
    name: "Divisa Nova",
  }, {
    name: "Divisópolis",
  }, {
    name: "Dobrada",
  }, {
    name: "Dois Córregos",
  }, {
    name: "Dois Irmãos",
  }, {
    name: "Dois Irmãos das Missões",
  }, {
    name: "Dois Irmãos do Buriti",
  }, {
    name: "Dois Irmãos do Tocantins",
  }, {
    name: "Dois Lajeados",
  }, {
    name: "Dois Riachos",
  }, {
    name: "Dois Vizinhos",
  }, {
    name: "Dolcinópolis",
  }, {
    name: "Dom Aquino",
  }, {
    name: "Dom Basílio",
  }, {
    name: "Dom Bosco",
  }, {
    name: "Dom Cavati",
  }, {
    name: "Dom Eliseu",
  }, {
    name: "Dom Expedito Lopes",
  }, {
    name: "Dom Feliciano",
  }, {
    name: "Dom Inocêncio",
  }, {
    name: "Dom Joaquim",
  }, {
    name: "Dom Macedo Costa",
  }, {
    name: "Dom Pedrito",
  }, {
    name: "Dom Pedro",
  }, {
    name: "Dom Pedro de Alcântara",
  }, {
    name: "Dom Silvério",
  }, {
    name: "Dom Viçoso",
  }, {
    name: "Domingos Martins",
  }, {
    name: "Domingos Mourão",
  }, {
    name: "Dona Emma",
  }, {
    name: "Dona Euzébia",
  }, {
    name: "Dona Francisca",
  }, {
    name: "Dona Inês",
  }, {
    name: "Dores de Campos",
  }, {
    name: "Dores de Guanhães",
  }, {
    name: "Dores do Indaiá",
  }, {
    name: "Dores do Rio Preto",
  }, {
    name: "Dores do Turvo",
  }, {
    name: "Doresópolis",
  }, {
    name: "Dormentes",
  }, {
    name: "Douradina",
  }, {
    name: "Dourado",
  }, {
    name: "Douradoquara",
  }, {
    name: "Dourados",
  }, {
    name: "Doutor Camargo",
  }, {
    name: "Doutor Maurício Cardoso",
  }, {
    name: "Doutor Pedrinho",
  }, {
    name: "Doutor Ricardo",
  }, {
    name: "Doutor Severiano",
  }, {
    name: "Doutor Ulysses",
  }, {
    name: "Doverlândia",
  }, {
    name: "Dracena",
  }, {
    name: "Duartina",
  }, {
    name: "Duas Barras",
  }, {
    name: "Duas Estradas",
  }, {
    name: "Dueré",
  }, {
    name: "Dumont",
  }, {
    name: "Duque Bacelar",
  }, {
    name: "Duque de Caxias",
  }, {
    name: "Durandé",
  }, {
    name: "Dário Meira",
  }, {
    name: "Echaporã",
  }, {
    name: "Ecoporanga",
  }, {
    name: "Edealina",
  }, {
    name: "Edéia",
  }, {
    name: "Eirunepé",
  }, {
    name: "Eldorado",
  }, {
    name: "Eldorado do Carajás",
  }, {
    name: "Eldorado do Sul",
  }, {
    name: "Elesbão Veloso",
  }, {
    name: "Elias Fausto",
  }, {
    name: "Eliseu Martins",
  }, {
    name: "Elisiário",
  }, {
    name: "Elísio Medrado",
  }, {
    name: "Elói Mendes",
  }, {
    name: "Emas",
  }, {
    name: "Embaúba",
  }, {
    name: "Embu das Artes",
  }, {
    name: "Embu-Guaçu",
  }, {
    name: "Emilianópolis",
  }, {
    name: "Encantado",
  }, {
    name: "Encanto",
  }, {
    name: "Encruzilhada",
  }, {
    name: "Encruzilhada do Sul",
  }, {
    name: "Engenheiro Beltrão",
  }, {
    name: "Engenheiro Caldas",
  }, {
    name: "Engenheiro Coelho",
  }, {
    name: "Engenheiro Navarro",
  }, {
    name: "Engenheiro Paulo de Frontin",
  }, {
    name: "Engenho Velho",
  }, {
    name: "Entre Folhas",
  }, {
    name: "Entre Rios",
  }, {
    name: "Entre Rios de Minas",
  }, {
    name: "Entre Rios do Oeste",
  }, {
    name: "Entre Rios do Sul",
  }, {
    name: "Entre-Ijuís",
  }, {
    name: "Envira",
  }, {
    name: "Enéas Marques",
  }, {
    name: "Epitaciolândia",
  }, {
    name: "Equador",
  }, {
    name: "Erebango",
  }, {
    name: "Erechim",
  }, {
    name: "Ereré",
  }, {
    name: "Ermo",
  }, {
    name: "Ernestina",
  }, {
    name: "Erval Grande",
  }, {
    name: "Erval Seco",
  }, {
    name: "Erval Velho",
  }, {
    name: "Ervália",
  }, {
    name: "Escada",
  }, {
    name: "Esmeralda",
  }, {
    name: "Esmeraldas",
  }, {
    name: "Espera Feliz",
  }, {
    name: "Esperantina",
  }, {
    name: "Esperantinópolis",
  }, {
    name: "Esperança",
  }, {
    name: "Esperança Nova",
  }, {
    name: "Esperança do Sul",
  }, {
    name: "Espigão Alto do Iguaçu",
  }, {
    name: "Espigão D'Oeste",
  }, {
    name: "Espinosa",
  }, {
    name: "Esplanada",
  }, {
    name: "Espumoso",
  }, {
    name: "Espírito Santo",
  }, {
    name: "Espírito Santo do Dourado",
  }, {
    name: "Espírito Santo do Pinhal",
  }, {
    name: "Espírito Santo do Turvo",
  }, {
    name: "Estação",
  }, {
    name: "Esteio",
  }, {
    name: "Estiva",
  }, {
    name: "Estiva Gerbi",
  }, {
    name: "Estreito",
  }, {
    name: "Estrela",
  }, {
    name: "Estrela Dalva",
  }, {
    name: "Estrela Velha",
  }, {
    name: "Estrela d'Oeste",
  }, {
    name: "Estrela de Alagoas",
  }, {
    name: "Estrela do Indaiá",
  }, {
    name: "Estrela do Norte",
  }, {
    name: "Estrela do Sul",
  }, {
    name: "Estância",
  }, {
    name: "Estância Velha",
  }, {
    name: "Euclides da Cunha",
  }, {
    name: "Euclides da Cunha Paulista",
  }, {
    name: "Eugenópolis",
  }, {
    name: "Eugênio de Castro",
  }, {
    name: "Eunápolis",
  }, {
    name: "Eusébio",
  }, {
    name: "Ewbank da Câmara",
  }, {
    name: "Extrema",
  }, {
    name: "Extremoz",
  }, {
    name: "Exu",
  }, {
    name: "Fagundes",
  }, {
    name: "Fagundes Varela",
  }, {
    name: "Faina",
  }, {
    name: "Fama",
  }, {
    name: "Faria Lemos",
  }, {
    name: "Farias Brito",
  }, {
    name: "Faro",
  }, {
    name: "Farol",
  }, {
    name: "Farroupilha",
  }, {
    name: "Fartura",
  }, {
    name: "Fartura do Piauí",
  }, {
    name: "Faxinal",
  }, {
    name: "Faxinal do Soturno",
  }, {
    name: "Faxinal dos Guedes",
  }, {
    name: "Faxinalzinho",
  }, {
    name: "Fazenda Nova",
  }, {
    name: "Fazenda Rio Grande",
  }, {
    name: "Fazenda Vilanova",
  }, {
    name: "Feijó",
  }, {
    name: "Feira Grande",
  }, {
    name: "Feira Nova",
  }, {
    name: "Feira Nova do Maranhão",
  }, {
    name: "Feira da Mata",
  }, {
    name: "Feira de Santana",
  }, {
    name: "Felipe Guerra",
  }, {
    name: "Felisburgo",
  }, {
    name: "Felixlândia",
  }, {
    name: "Feliz",
  }, {
    name: "Feliz Deserto",
  }, {
    name: "Feliz Natal",
  }, {
    name: "Felício dos Santos",
  }, {
    name: "Fernandes Pinheiro",
  }, {
    name: "Fernandes Tourinho",
  }, {
    name: "Fernando Falcão",
  }, {
    name: "Fernando Pedroza",
  }, {
    name: "Fernando Prestes",
  }, {
    name: "Fernando de Noronha",
  }, {
    name: "Fernandópolis",
  }, {
    name: "Fernão",
  }, {
    name: "Ferraz de Vasconcelos",
  }, {
    name: "Ferreira Gomes",
  }, {
    name: "Ferreiros",
  }, {
    name: "Ferros",
  }, {
    name: "Fervedouro",
  }, {
    name: "Figueira",
  }, {
    name: "Figueirão",
  }, {
    name: "Figueirópolis",
  }, {
    name: "Figueirópolis D'Oeste",
  }, {
    name: "Filadélfia",
  }, {
    name: "Firmino Alves",
  }, {
    name: "Firminópolis",
  }, {
    name: "Flexeiras",
  }, {
    name: "Flor da Serra do Sul",
  }, {
    name: "Flor do Sertão",
  }, {
    name: "Flora Rica",
  }, {
    name: "Floraí",
  }, {
    name: "Floreal",
  }, {
    name: "Flores",
  }, {
    name: "Flores da Cunha",
  }, {
    name: "Flores de Goiás",
  }, {
    name: "Flores do Piauí",
  }, {
    name: "Floresta",
  }, {
    name: "Floresta Azul",
  }, {
    name: "Floresta do Araguaia",
  }, {
    name: "Floresta do Piauí",
  }, {
    name: "Florestal",
  }, {
    name: "Florestópolis",
  }, {
    name: "Floriano",
  }, {
    name: "Floriano Peixoto",
  }, {
    name: "Florianópolis",
  }, {
    name: "Florânia",
  }, {
    name: "Florínea",
  }, {
    name: "Flórida",
  }, {
    name: "Flórida Paulista",
  }, {
    name: "Fonte Boa",
  }, {
    name: "Fontoura Xavier",
  }, {
    name: "Formiga",
  }, {
    name: "Formigueiro",
  }, {
    name: "Formosa",
  }, {
    name: "Formosa da Serra Negra",
  }, {
    name: "Formosa do Oeste",
  }, {
    name: "Formosa do Rio Preto",
  }, {
    name: "Formosa do Sul",
  }, {
    name: "Formoso",
  }, {
    name: "Formoso do Araguaia",
  }, {
    name: "Forquetinha",
  }, {
    name: "Forquilha",
  }, {
    name: "Forquilhinha",
  }, {
    name: "Fortaleza",
  }, {
    name: "Fortaleza de Minas",
  }, {
    name: "Fortaleza dos Nogueiras",
  }, {
    name: "Fortaleza dos Valos",
  }, {
    name: "Fortim",
  }, {
    name: "Fortuna",
  }, {
    name: "Fortuna de Minas",
  }, {
    name: "Foz do Iguaçu",
  }, {
    name: "Foz do Jordão",
  }, {
    name: "Fraiburgo",
  }, {
    name: "Franca",
  }, {
    name: "Francinópolis",
  }, {
    name: "Francisco Alves",
  }, {
    name: "Francisco Ayres",
  }, {
    name: "Francisco Badaró",
  }, {
    name: "Francisco Beltrão",
  }, {
    name: "Francisco Dantas",
  }, {
    name: "Francisco Dumont",
  }, {
    name: "Francisco Macedo",
  }, {
    name: "Francisco Morato",
  }, {
    name: "Francisco Santos",
  }, {
    name: "Francisco Sá",
  }, {
    name: "Franciscópolis",
  }, {
    name: "Franco da Rocha",
  }, {
    name: "Frecheirinha",
  }, {
    name: "Frederico Westphalen",
  }, {
    name: "Frei Gaspar",
  }, {
    name: "Frei Inocêncio",
  }, {
    name: "Frei Lagonegro",
  }, {
    name: "Frei Martinho",
  }, {
    name: "Frei Miguelinho",
  }, {
    name: "Frei Paulo",
  }, {
    name: "Frei Rogério",
  }, {
    name: "Fronteira",
  }, {
    name: "Fronteira dos Vales",
  }, {
    name: "Fronteiras",
  }, {
    name: "Fruta de Leite",
  }, {
    name: "Frutal",
  }, {
    name: "Frutuoso Gomes",
  }, {
    name: "Fundão",
  }, {
    name: "Funilândia",
  }, {
    name: "Fátima",
  }, {
    name: "Fátima do Sul",
  }, {
    name: "Fênix",
  }, {
    name: "Gabriel Monteiro",
  }, {
    name: "Gado Bravo",
  }, {
    name: "Galiléia",
  }, {
    name: "Galinhos",
  }, {
    name: "Galvão",
  }, {
    name: "Gameleira",
  }, {
    name: "Gameleira de Goiás",
  }, {
    name: "Gameleiras",
  }, {
    name: "Gandu",
  }, {
    name: "Garanhuns",
  }, {
    name: "Gararu",
  }, {
    name: "Garibaldi",
  }, {
    name: "Garopaba",
  }, {
    name: "Garrafão do Norte",
  }, {
    name: "Garruchos",
  }, {
    name: "Garuva",
  }, {
    name: "Garça",
  }, {
    name: "Gaspar",
  }, {
    name: "Gastão Vidigal",
  }, {
    name: "Gaurama",
  }, {
    name: "Gavião",
  }, {
    name: "Gavião Peixoto",
  }, {
    name: "Gaúcha do Norte",
  }, {
    name: "Geminiano",
  }, {
    name: "General Carneiro",
  }, {
    name: "General Câmara",
  }, {
    name: "General Maynard",
  }, {
    name: "General Salgado",
  }, {
    name: "General Sampaio",
  }, {
    name: "Gentil",
  }, {
    name: "Gentio do Ouro",
  }, {
    name: "Getulina",
  }, {
    name: "Getúlio Vargas",
  }, {
    name: "Gilbués",
  }, {
    name: "Girau do Ponciano",
  }, {
    name: "Giruá",
  }, {
    name: "Glaucilândia",
  }, {
    name: "Glicério",
  }, {
    name: "Glorinha",
  }, {
    name: "Glória",
  }, {
    name: "Glória D'Oeste",
  }, {
    name: "Glória de Dourados",
  }, {
    name: "Glória do Goitá",
  }, {
    name: "Godofredo Viana",
  }, {
    name: "Godoy Moreira",
  }, {
    name: "Goiabeira",
  }, {
    name: "Goiana",
  }, {
    name: "Goiandira",
  }, {
    name: "Goianinha",
  }, {
    name: "Goianira",
  }, {
    name: "Goianorte",
  }, {
    name: "Goianá",
  }, {
    name: "Goianápolis",
  }, {
    name: "Goianésia",
  }, {
    name: "Goianésia do Pará",
  }, {
    name: "Goiatins",
  }, {
    name: "Goiatuba",
  }, {
    name: "Goioerê",
  }, {
    name: "Goioxim",
  }, {
    name: "Goiás",
  }, {
    name: "Goiânia",
  }, {
    name: "Gongogi",
  }, {
    name: "Gonzaga",
  }, {
    name: "Gonçalves",
  }, {
    name: "Gonçalves Dias",
  }, {
    name: "Gouveia",
  }, {
    name: "Gouvelândia",
  }, {
    name: "Governador Archer",
  }, {
    name: "Governador Celso Ramos",
  }, {
    name: "Governador Dix-Sept Rosado",
  }, {
    name: "Governador Edison Lobão",
  }, {
    name: "Governador Eugênio Barros",
  }, {
    name: "Governador Jorge Teixeira",
  }, {
    name: "Governador Lindenberg",
  }, {
    name: "Governador Luiz Rocha",
  }, {
    name: "Governador Mangabeira",
  }, {
    name: "Governador Newton Bello",
  }, {
    name: "Governador Nunes Freire",
  }, {
    name: "Governador Valadares",
  }, {
    name: "Gracho Cardoso",
  }, {
    name: "Grajaú",
  }, {
    name: "Gramado",
  }, {
    name: "Gramado Xavier",
  }, {
    name: "Gramado dos Loureiros",
  }, {
    name: "Grandes Rios",
  }, {
    name: "Granito",
  }, {
    name: "Granja",
  }, {
    name: "Granjeiro",
  }, {
    name: "Gravatal",
  }, {
    name: "Gravataí",
  }, {
    name: "Gravatá",
  }, {
    name: "Graça",
  }, {
    name: "Graça Aranha",
  }, {
    name: "Groaíras",
  }, {
    name: "Grossos",
  }, {
    name: "Grupiara",
  }, {
    name: "Grão Mogol",
  }, {
    name: "Grão Pará",
  }, {
    name: "Guabiju",
  }, {
    name: "Guabiruba",
  }, {
    name: "Guadalupe",
  }, {
    name: "Guaimbê",
  }, {
    name: "Guairaçá",
  }, {
    name: "Guaiçara",
  }, {
    name: "Guaiúba",
  }, {
    name: "Guajará",
  }, {
    name: "Guajará-Mirim",
  }, {
    name: "Guajeru",
  }, {
    name: "Guamaré",
  }, {
    name: "Guamiranga",
  }, {
    name: "Guanambi",
  }, {
    name: "Guanhães",
  }, {
    name: "Guapiara",
  }, {
    name: "Guapiaçu",
  }, {
    name: "Guapimirim",
  }, {
    name: "Guapirama",
  }, {
    name: "Guaporema",
  }, {
    name: "Guaporé",
  }, {
    name: "Guapé",
  }, {
    name: "Guapó",
  }, {
    name: "Guarabira",
  }, {
    name: "Guaraci",
  }, {
    name: "Guaraciaba",
  }, {
    name: "Guaraciaba do Norte",
  }, {
    name: "Guaraciama",
  }, {
    name: "Guaramiranga",
  }, {
    name: "Guaramirim",
  }, {
    name: "Guarani",
  }, {
    name: "Guarani d'Oeste",
  }, {
    name: "Guarani das Missões",
  }, {
    name: "Guarani de Goiás",
  }, {
    name: "Guaraniaçu",
  }, {
    name: "Guarantã",
  }, {
    name: "Guarantã do Norte",
  }, {
    name: "Guaranésia",
  }, {
    name: "Guarapari",
  }, {
    name: "Guarapuava",
  }, {
    name: "Guaraqueçaba",
  }, {
    name: "Guararapes",
  }, {
    name: "Guararema",
  }, {
    name: "Guarará",
  }, {
    name: "Guaratinga",
  }, {
    name: "Guaratinguetá",
  }, {
    name: "Guaratuba",
  }, {
    name: "Guaraçaí",
  }, {
    name: "Guaraí",
  }, {
    name: "Guaraíta",
  }, {
    name: "Guarda-Mor",
  }, {
    name: "Guareí",
  }, {
    name: "Guariba",
  }, {
    name: "Guaribas",
  }, {
    name: "Guarinos",
  }, {
    name: "Guarujá",
  }, {
    name: "Guarujá do Sul",
  }, {
    name: "Guarulhos",
  }, {
    name: "Guará",
  }, {
    name: "Guatambú",
  }, {
    name: "Guatapará",
  }, {
    name: "Guaxupé",
  }, {
    name: "Guaçuí",
  }, {
    name: "Guaíba",
  }, {
    name: "Guaíra",
  }, {
    name: "Guia Lopes da Laguna",
  }, {
    name: "Guidoval",
  }, {
    name: "Guimarânia",
  }, {
    name: "Guimarães",
  }, {
    name: "Guiratinga",
  }, {
    name: "Guiricema",
  }, {
    name: "Gurinhatã",
  }, {
    name: "Gurinhém",
  }, {
    name: "Gurjão",
  }, {
    name: "Gurupi",
  }, {
    name: "Gurupá",
  }, {
    name: "Guzolândia",
  }, {
    name: "Gália",
  }, {
    name: "Harmonia",
  }, {
    name: "Heitoraí",
  }, {
    name: "Heliodora",
  }, {
    name: "Heliópolis",
  }, {
    name: "Herculândia",
  }, {
    name: "Herval",
  }, {
    name: "Herval d'Oeste",
  }, {
    name: "Herveiras",
  }, {
    name: "Hidrolina",
  }, {
    name: "Hidrolândia",
  }, {
    name: "Holambra",
  }, {
    name: "Honório Serpa",
  }, {
    name: "Horizonte",
  }, {
    name: "Horizontina",
  }, {
    name: "Hortolândia",
  }, {
    name: "Hugo Napoleão",
  }, {
    name: "Hulha Negra",
  }, {
    name: "Humaitá",
  }, {
    name: "Humberto de Campos",
  }, {
    name: "Iacanga",
  }, {
    name: "Iaciara",
  }, {
    name: "Iacri",
  }, {
    name: "Iapu",
  }, {
    name: "Iaras",
  }, {
    name: "Iati",
  }, {
    name: "Iaçu",
  }, {
    name: "Ibaiti",
  }, {
    name: "Ibarama",
  }, {
    name: "Ibaretama",
  }, {
    name: "Ibateguara",
  }, {
    name: "Ibatiba",
  }, {
    name: "Ibaté",
  }, {
    name: "Ibema",
  }, {
    name: "Ibertioga",
  }, {
    name: "Ibiam",
  }, {
    name: "Ibiapina",
  }, {
    name: "Ibiara",
  }, {
    name: "Ibiassucê",
  }, {
    name: "Ibiaçá",
  }, {
    name: "Ibiaí",
  }, {
    name: "Ibicaraí",
  }, {
    name: "Ibicaré",
  }, {
    name: "Ibicoara",
  }, {
    name: "Ibicuitinga",
  }, {
    name: "Ibicuí",
  }, {
    name: "Ibimirim",
  }, {
    name: "Ibipeba",
  }, {
    name: "Ibipitanga",
  }, {
    name: "Ibiporã",
  }, {
    name: "Ibiquera",
  }, {
    name: "Ibiracatu",
  }, {
    name: "Ibiraci",
  }, {
    name: "Ibiraiaras",
  }, {
    name: "Ibirajuba",
  }, {
    name: "Ibirama",
  }, {
    name: "Ibirapitanga",
  }, {
    name: "Ibirapuitã",
  }, {
    name: "Ibirapuã",
  }, {
    name: "Ibirarema",
  }, {
    name: "Ibirataia",
  }, {
    name: "Ibiraçu",
  }, {
    name: "Ibirité",
  }, {
    name: "Ibirubá",
  }, {
    name: "Ibirá",
  }, {
    name: "Ibitiara",
  }, {
    name: "Ibitinga",
  }, {
    name: "Ibitirama",
  }, {
    name: "Ibititá",
  }, {
    name: "Ibitiúra de Minas",
  }, {
    name: "Ibituruna",
  }, {
    name: "Ibiá",
  }, {
    name: "Ibiúna",
  }, {
    name: "Ibotirama",
  }, {
    name: "Icapuí",
  }, {
    name: "Icaraí de Minas",
  }, {
    name: "Icaraíma",
  }, {
    name: "Icatu",
  }, {
    name: "Ichu",
  }, {
    name: "Iconha",
  }, {
    name: "Icém",
  }, {
    name: "Icó",
  }, {
    name: "Ielmo Marinho",
  }, {
    name: "Iepê",
  }, {
    name: "Igaci",
  }, {
    name: "Igaporã",
  }, {
    name: "Igaracy",
  }, {
    name: "Igarapava",
  }, {
    name: "Igarapé",
  }, {
    name: "Igarapé Grande",
  }, {
    name: "Igarapé do Meio",
  }, {
    name: "Igarapé-Açu",
  }, {
    name: "Igarapé-Miri",
  }, {
    name: "Igarassu",
  }, {
    name: "Igaratinga",
  }, {
    name: "Igaratá",
  }, {
    name: "Igaraçu do Tietê",
  }, {
    name: "Igrapiúna",
  }, {
    name: "Igreja Nova",
  }, {
    name: "Igrejinha",
  }, {
    name: "Iguaba Grande",
  }, {
    name: "Iguape",
  }, {
    name: "Iguaracy",
  }, {
    name: "Iguaraçu",
  }, {
    name: "Iguatama",
  }, {
    name: "Iguatemi",
  }, {
    name: "Iguatu",
  }, {
    name: "Iguaí",
  }, {
    name: "Ijaci",
  }, {
    name: "Ijuí",
  }, {
    name: "Ilha Comprida",
  }, {
    name: "Ilha Grande",
  }, {
    name: "Ilha Solteira",
  }, {
    name: "Ilha das Flores",
  }, {
    name: "Ilha de Itamaracá",
  }, {
    name: "Ilhabela",
  }, {
    name: "Ilhota",
  }, {
    name: "Ilhéus",
  }, {
    name: "Ilicínea",
  }, {
    name: "Ilópolis",
  }, {
    name: "Imaculada",
  }, {
    name: "Imaruí",
  }, {
    name: "Imbaú",
  }, {
    name: "Imbituba",
  }, {
    name: "Imbituva",
  }, {
    name: "Imbuia",
  }, {
    name: "Imbé",
  }, {
    name: "Imbé de Minas",
  }, {
    name: "Imigrante",
  }, {
    name: "Imperatriz",
  }, {
    name: "Inaciolândia",
  }, {
    name: "Inajá",
  }, {
    name: "Inconfidentes",
  }, {
    name: "Indaiabira",
  }, {
    name: "Indaial",
  }, {
    name: "Indaiatuba",
  }, {
    name: "Independência",
  }, {
    name: "Indiana",
  }, {
    name: "Indianópolis",
  }, {
    name: "Indiaporã",
  }, {
    name: "Indiara",
  }, {
    name: "Indiaroba",
  }, {
    name: "Indiavaí",
  }, {
    name: "Ingazeira",
  }, {
    name: "Ingaí",
  }, {
    name: "Ingá",
  }, {
    name: "Inhacorá",
  }, {
    name: "Inhambupe",
  }, {
    name: "Inhangapi",
  }, {
    name: "Inhapi",
  }, {
    name: "Inhapim",
  }, {
    name: "Inhaúma",
  }, {
    name: "Inhuma",
  }, {
    name: "Inhumas",
  }, {
    name: "Inimutaba",
  }, {
    name: "Inocência",
  }, {
    name: "Inácio Martins",
  }, {
    name: "Inúbia Paulista",
  }, {
    name: "Iomerê",
  }, {
    name: "Ipaba",
  }, {
    name: "Ipameri",
  }, {
    name: "Ipanema",
  }, {
    name: "Ipanguaçu",
  }, {
    name: "Ipaporanga",
  }, {
    name: "Ipatinga",
  }, {
    name: "Ipaumirim",
  }, {
    name: "Ipaussu",
  }, {
    name: "Ipecaetá",
  }, {
    name: "Iperó",
  }, {
    name: "Ipeúna",
  }, {
    name: "Ipiaçu",
  }, {
    name: "Ipiaú",
  }, {
    name: "Ipiguá",
  }, {
    name: "Ipira",
  }, {
    name: "Ipiranga",
  }, {
    name: "Ipiranga de Goiás",
  }, {
    name: "Ipiranga do Norte",
  }, {
    name: "Ipiranga do Piauí",
  }, {
    name: "Ipiranga do Sul",
  }, {
    name: "Ipirá",
  }, {
    name: "Ipixuna",
  }, {
    name: "Ipixuna do Pará",
  }, {
    name: "Ipojuca",
  }, {
    name: "Iporanga",
  }, {
    name: "Iporá",
  }, {
    name: "Iporã",
  }, {
    name: "Iporã do Oeste",
  }, {
    name: "Ipu",
  }, {
    name: "Ipuaçu",
  }, {
    name: "Ipubi",
  }, {
    name: "Ipueira",
  }, {
    name: "Ipueiras",
  }, {
    name: "Ipuiúna",
  }, {
    name: "Ipumirim",
  }, {
    name: "Ipupiara",
  }, {
    name: "Ipuã",
  }, {
    name: "Ipê",
  }, {
    name: "Iracema",
  }, {
    name: "Iracema do Oeste",
  }, {
    name: "Iraceminha",
  }, {
    name: "Iracemápolis",
  }, {
    name: "Irajuba",
  }, {
    name: "Iramaia",
  }, {
    name: "Iranduba",
  }, {
    name: "Irani",
  }, {
    name: "Irapuru",
  }, {
    name: "Irapuã",
  }, {
    name: "Iraquara",
  }, {
    name: "Irará",
  }, {
    name: "Irati",
  }, {
    name: "Irauçuba",
  }, {
    name: "Iraí",
  }, {
    name: "Iraí de Minas",
  }, {
    name: "Irecê",
  }, {
    name: "Iretama",
  }, {
    name: "Irineópolis",
  }, {
    name: "Irituia",
  }, {
    name: "Irupi",
  }, {
    name: "Isaías Coelho",
  }, {
    name: "Israelândia",
  }, {
    name: "Itaara",
  }, {
    name: "Itabaiana",
  }, {
    name: "Itabaianinha",
  }, {
    name: "Itabela",
  }, {
    name: "Itaberaba",
  }, {
    name: "Itaberaí",
  }, {
    name: "Itaberá",
  }, {
    name: "Itabi",
  }, {
    name: "Itabira",
  }, {
    name: "Itabirinha",
  }, {
    name: "Itabirito",
  }, {
    name: "Itaboraí",
  }, {
    name: "Itabuna",
  }, {
    name: "Itacajá",
  }, {
    name: "Itacambira",
  }, {
    name: "Itacarambi",
  }, {
    name: "Itacaré",
  }, {
    name: "Itacoatiara",
  }, {
    name: "Itacuruba",
  }, {
    name: "Itacurubi",
  }, {
    name: "Itaeté",
  }, {
    name: "Itagi",
  }, {
    name: "Itagibá",
  }, {
    name: "Itagimirim",
  }, {
    name: "Itaguajé",
  }, {
    name: "Itaguara",
  }, {
    name: "Itaguari",
  }, {
    name: "Itaguaru",
  }, {
    name: "Itaguatins",
  }, {
    name: "Itaguaçu",
  }, {
    name: "Itaguaçu da Bahia",
  }, {
    name: "Itaguaí",
  }, {
    name: "Itainópolis",
  }, {
    name: "Itaipava do Grajaú",
  }, {
    name: "Itaipulândia",
  }, {
    name: "Itaipé",
  }, {
    name: "Itaitinga",
  }, {
    name: "Itaituba",
  }, {
    name: "Itaiçaba",
  }, {
    name: "Itaiópolis",
  }, {
    name: "Itajaí",
  }, {
    name: "Itajobi",
  }, {
    name: "Itaju",
  }, {
    name: "Itaju do Colônia",
  }, {
    name: "Itajubá",
  }, {
    name: "Itajuípe",
  }, {
    name: "Itajá",
  }, {
    name: "Italva",
  }, {
    name: "Itamaraju",
  }, {
    name: "Itamarandiba",
  }, {
    name: "Itamarati",
  }, {
    name: "Itamarati de Minas",
  }, {
    name: "Itamari",
  }, {
    name: "Itambacuri",
  }, {
    name: "Itambaracá",
  }, {
    name: "Itambé",
  }, {
    name: "Itambé do Mato Dentro",
  }, {
    name: "Itamogi",
  }, {
    name: "Itamonte",
  }, {
    name: "Itanagra",
  }, {
    name: "Itanhandu",
  }, {
    name: "Itanhangá",
  }, {
    name: "Itanhaém",
  }, {
    name: "Itanhomi",
  }, {
    name: "Itanhém",
  }, {
    name: "Itaobim",
  }, {
    name: "Itaoca",
  }, {
    name: "Itaocara",
  }, {
    name: "Itapaci",
  }, {
    name: "Itapagipe",
  }, {
    name: "Itapajé",
  }, {
    name: "Itaparica",
  }, {
    name: "Itapebi",
  }, {
    name: "Itapecerica",
  }, {
    name: "Itapecerica da Serra",
  }, {
    name: "Itapecuru Mirim",
  }, {
    name: "Itapejara d'Oeste",
  }, {
    name: "Itapema",
  }, {
    name: "Itapemirim",
  }, {
    name: "Itaperuna",
  }, {
    name: "Itaperuçu",
  }, {
    name: "Itapetim",
  }, {
    name: "Itapetinga",
  }, {
    name: "Itapetininga",
  }, {
    name: "Itapeva",
  }, {
    name: "Itapevi",
  }, {
    name: "Itapicuru",
  }, {
    name: "Itapipoca",
  }, {
    name: "Itapira",
  }, {
    name: "Itapiranga",
  }, {
    name: "Itapirapuã",
  }, {
    name: "Itapirapuã Paulista",
  }, {
    name: "Itapiratins",
  }, {
    name: "Itapissuma",
  }, {
    name: "Itapitanga",
  }, {
    name: "Itapiúna",
  }, {
    name: "Itaporanga",
  }, {
    name: "Itaporanga d'Ajuda",
  }, {
    name: "Itapororoca",
  }, {
    name: "Itaporã",
  }, {
    name: "Itaporã do Tocantins",
  }, {
    name: "Itapoá",
  }, {
    name: "Itapuca",
  }, {
    name: "Itapura",
  }, {
    name: "Itapuranga",
  }, {
    name: "Itapuã do Oeste",
  }, {
    name: "Itapuí",
  }, {
    name: "Itapé",
  }, {
    name: "Itaquaquecetuba",
  }, {
    name: "Itaquara",
  }, {
    name: "Itaqui",
  }, {
    name: "Itaquiraí",
  }, {
    name: "Itaquitinga",
  }, {
    name: "Itarana",
  }, {
    name: "Itarantim",
  }, {
    name: "Itararé",
  }, {
    name: "Itarema",
  }, {
    name: "Itariri",
  }, {
    name: "Itarumã",
  }, {
    name: "Itati",
  }, {
    name: "Itatiaia",
  }, {
    name: "Itatiaiuçu",
  }, {
    name: "Itatiba",
  }, {
    name: "Itatiba do Sul",
  }, {
    name: "Itatim",
  }, {
    name: "Itatinga",
  }, {
    name: "Itatira",
  }, {
    name: "Itatuba",
  }, {
    name: "Itaubal",
  }, {
    name: "Itaueira",
  }, {
    name: "Itauçu",
  }, {
    name: "Itaverava",
  }, {
    name: "Itaí",
  }, {
    name: "Itaíba",
  }, {
    name: "Itaú",
  }, {
    name: "Itaú de Minas",
  }, {
    name: "Itaúba",
  }, {
    name: "Itaúna",
  }, {
    name: "Itaúna do Sul",
  }, {
    name: "Itinga",
  }, {
    name: "Itinga do Maranhão",
  }, {
    name: "Itiquira",
  }, {
    name: "Itirapina",
  }, {
    name: "Itirapuã",
  }, {
    name: "Itiruçu",
  }, {
    name: "Itiúba",
  }, {
    name: "Itobi",
  }, {
    name: "Itororó",
  }, {
    name: "Itu",
  }, {
    name: "Ituaçu",
  }, {
    name: "Ituberá",
  }, {
    name: "Itueta",
  }, {
    name: "Ituiutaba",
  }, {
    name: "Itumbiara",
  }, {
    name: "Itumirim",
  }, {
    name: "Itupeva",
  }, {
    name: "Itupiranga",
  }, {
    name: "Ituporanga",
  }, {
    name: "Iturama",
  }, {
    name: "Itutinga",
  }, {
    name: "Ituverava",
  }, {
    name: "Itá",
  }, {
    name: "Itápolis",
  }, {
    name: "Iuiu",
  }, {
    name: "Ivaiporã",
  }, {
    name: "Ivatuba",
  }, {
    name: "Ivaté",
  }, {
    name: "Ivaí",
  }, {
    name: "Ivinhema",
  }, {
    name: "Ivolândia",
  }, {
    name: "Ivorá",
  }, {
    name: "Ivoti",
  }, {
    name: "Içara",
  }, {
    name: "Iúna",
  }, {
    name: "Jaboatão dos Guararapes",
  }, {
    name: "Jaborandi",
  }, {
    name: "Jaborá",
  }, {
    name: "Jaboti",
  }, {
    name: "Jaboticaba",
  }, {
    name: "Jaboticabal",
  }, {
    name: "Jaboticatubas",
  }, {
    name: "Jacaraci",
  }, {
    name: "Jacaraú",
  }, {
    name: "Jacareacanga",
  }, {
    name: "Jacarezinho",
  }, {
    name: "Jacareí",
  }, {
    name: "Jacaré dos Homens",
  }, {
    name: "Jaci",
  }, {
    name: "Jaciara",
  }, {
    name: "Jacinto",
  }, {
    name: "Jacinto Machado",
  }, {
    name: "Jacobina",
  }, {
    name: "Jacobina do Piauí",
  }, {
    name: "Jacuizinho",
  }, {
    name: "Jacundá",
  }, {
    name: "Jacupiranga",
  }, {
    name: "Jacutinga",
  }, {
    name: "Jacuí",
  }, {
    name: "Jacuípe",
  }, {
    name: "Jaguapitã",
  }, {
    name: "Jaguaquara",
  }, {
    name: "Jaguarari",
  }, {
    name: "Jaguaraçu",
  }, {
    name: "Jaguaretama",
  }, {
    name: "Jaguari",
  }, {
    name: "Jaguariaíva",
  }, {
    name: "Jaguaribara",
  }, {
    name: "Jaguaribe",
  }, {
    name: "Jaguaripe",
  }, {
    name: "Jaguariúna",
  }, {
    name: "Jaguaruana",
  }, {
    name: "Jaguaruna",
  }, {
    name: "Jaguarão",
  }, {
    name: "Jaguaré",
  }, {
    name: "Jaicós",
  }, {
    name: "Jales",
  }, {
    name: "Jambeiro",
  }, {
    name: "Jampruca",
  }, {
    name: "Janaúba",
  }, {
    name: "Jandaia",
  }, {
    name: "Jandaia do Sul",
  }, {
    name: "Jandaíra",
  }, {
    name: "Jandira",
  }, {
    name: "Janduís",
  }, {
    name: "Jangada",
  }, {
    name: "Janiópolis",
  }, {
    name: "Januária",
  }, {
    name: "Januário Cicco",
  }, {
    name: "Japaratinga",
  }, {
    name: "Japaratuba",
  }, {
    name: "Japaraíba",
  }, {
    name: "Japeri",
  }, {
    name: "Japi",
  }, {
    name: "Japira",
  }, {
    name: "Japoatã",
  }, {
    name: "Japonvar",
  }, {
    name: "Japorã",
  }, {
    name: "Japurá",
  }, {
    name: "Jaqueira",
  }, {
    name: "Jaquirana",
  }, {
    name: "Jaraguari",
  }, {
    name: "Jaraguá",
  }, {
    name: "Jaraguá do Sul",
  }, {
    name: "Jaramataia",
  }, {
    name: "Jardim",
  }, {
    name: "Jardim Alegre",
  }, {
    name: "Jardim Olinda",
  }, {
    name: "Jardim de Angicos",
  }, {
    name: "Jardim de Piranhas",
  }, {
    name: "Jardim do Mulato",
  }, {
    name: "Jardim do Seridó",
  }, {
    name: "Jardinópolis",
  }, {
    name: "Jari",
  }, {
    name: "Jarinu",
  }, {
    name: "Jaru",
  }, {
    name: "Jataizinho",
  }, {
    name: "Jataí",
  }, {
    name: "Jataúba",
  }, {
    name: "Jateí",
  }, {
    name: "Jati",
  }, {
    name: "Jatobá",
  }, {
    name: "Jatobá do Piauí",
  }, {
    name: "Jaupaci",
  }, {
    name: "Jauru",
  }, {
    name: "Jaçanã",
  }, {
    name: "Jaíba",
  }, {
    name: "Jaú",
  }, {
    name: "Jaú do Tocantins",
  }, {
    name: "Jeceaba",
  }, {
    name: "Jenipapo de Minas",
  }, {
    name: "Jenipapo dos Vieiras",
  }, {
    name: "Jequeri",
  }, {
    name: "Jequitaí",
  }, {
    name: "Jequitibá",
  }, {
    name: "Jequitinhonha",
  }, {
    name: "Jequiá da Praia",
  }, {
    name: "Jequié",
  }, {
    name: "Jeremoabo",
  }, {
    name: "Jericó",
  }, {
    name: "Jeriquara",
  }, {
    name: "Jerumenha",
  }, {
    name: "Jerônimo Monteiro",
  }, {
    name: "Jesuânia",
  }, {
    name: "Jesuítas",
  }, {
    name: "Jesúpolis",
  }, {
    name: "Ji-Paraná",
  }, {
    name: "Jijoca de Jericoacoara",
  }, {
    name: "Jiquiriçá",
  }, {
    name: "Jitaúna",
  }, {
    name: "Joanésia",
  }, {
    name: "Joanópolis",
  }, {
    name: "Joaquim Felício",
  }, {
    name: "Joaquim Gomes",
  }, {
    name: "Joaquim Nabuco",
  }, {
    name: "Joaquim Pires",
  }, {
    name: "Joaquim Távora",
  }, {
    name: "Joaçaba",
  }, {
    name: "Joaíma",
  }, {
    name: "Joca Claudino",
  }, {
    name: "Joca Marques",
  }, {
    name: "Joinville",
  }, {
    name: "Jordânia",
  }, {
    name: "Jordão",
  }, {
    name: "Joselândia",
  }, {
    name: "Josenópolis",
  }, {
    name: "José Boiteux",
  }, {
    name: "José Bonifácio",
  }, {
    name: "José Gonçalves de Minas",
  }, {
    name: "José Raydan",
  }, {
    name: "José da Penha",
  }, {
    name: "José de Freitas",
  }, {
    name: "Joviânia",
  }, {
    name: "João Alfredo",
  }, {
    name: "João Costa",
  }, {
    name: "João Câmara",
  }, {
    name: "João Dias",
  }, {
    name: "João Dourado",
  }, {
    name: "João Lisboa",
  }, {
    name: "João Monlevade",
  }, {
    name: "João Neiva",
  }, {
    name: "João Pessoa",
  }, {
    name: "João Pinheiro",
  }, {
    name: "João Ramalho",
  }, {
    name: "Juara",
  }, {
    name: "Juarez Távora",
  }, {
    name: "Juarina",
  }, {
    name: "Juatuba",
  }, {
    name: "Juazeirinho",
  }, {
    name: "Juazeiro",
  }, {
    name: "Juazeiro do Norte",
  }, {
    name: "Juazeiro do Piauí",
  }, {
    name: "Jucati",
  }, {
    name: "Jucurutu",
  }, {
    name: "Jucuruçu",
  }, {
    name: "Jucás",
  }, {
    name: "Juiz de Fora",
  }, {
    name: "Jumirim",
  }, {
    name: "Junco do Maranhão",
  }, {
    name: "Junco do Seridó",
  }, {
    name: "Jundiaí",
  }, {
    name: "Jundiaí do Sul",
  }, {
    name: "Jundiá",
  }, {
    name: "Junqueiro",
  }, {
    name: "Junqueirópolis",
  }, {
    name: "Jupi",
  }, {
    name: "Jupiá",
  }, {
    name: "Juquitiba",
  }, {
    name: "Juquiá",
  }, {
    name: "Juramento",
  }, {
    name: "Juranda",
  }, {
    name: "Jurema",
  }, {
    name: "Juripiranga",
  }, {
    name: "Juru",
  }, {
    name: "Juruaia",
  }, {
    name: "Juruena",
  }, {
    name: "Juruti",
  }, {
    name: "Juruá",
  }, {
    name: "Juscimeira",
  }, {
    name: "Jussara",
  }, {
    name: "Jussari",
  }, {
    name: "Jussiape",
  }, {
    name: "Jutaí",
  }, {
    name: "Juti",
  }, {
    name: "Juvenília",
  }, {
    name: "Juína",
  }, {
    name: "Jóia",
  }, {
    name: "Júlio Borges",
  }, {
    name: "Júlio Mesquita",
  }, {
    name: "Júlio de Castilhos",
  }, {
    name: "Kaloré",
  }, {
    name: "Lacerdópolis",
  }, {
    name: "Ladainha",
  }, {
    name: "Ladário",
  }, {
    name: "Lafaiete Coutinho",
  }, {
    name: "Lagamar",
  }, {
    name: "Lagarto",
  }, {
    name: "Lages",
  }, {
    name: "Lago Verde",
  }, {
    name: "Lago da Pedra",
  }, {
    name: "Lago do Junco",
  }, {
    name: "Lago dos Rodrigues",
  }, {
    name: "Lagoa",
  }, {
    name: "Lagoa Alegre",
  }, {
    name: "Lagoa Bonita do Sul",
  }, {
    name: "Lagoa Dourada",
  }, {
    name: "Lagoa Formosa",
  }, {
    name: "Lagoa Grande",
  }, {
    name: "Lagoa Grande do Maranhão",
  }, {
    name: "Lagoa Nova",
  }, {
    name: "Lagoa Real",
  }, {
    name: "Lagoa Salgada",
  }, {
    name: "Lagoa Santa",
  }, {
    name: "Lagoa Seca",
  }, {
    name: "Lagoa Vermelha",
  }, {
    name: "Lagoa d'Anta",
  }, {
    name: "Lagoa da Canoa",
  }, {
    name: "Lagoa da Confusão",
  }, {
    name: "Lagoa da Prata",
  }, {
    name: "Lagoa de Dentro",
  }, {
    name: "Lagoa de Itaenga",
  }, {
    name: "Lagoa de Pedras",
  }, {
    name: "Lagoa de São Francisco",
  }, {
    name: "Lagoa de Velhos",
  }, {
    name: "Lagoa do Barro do Piauí",
  }, {
    name: "Lagoa do Carro",
  }, {
    name: "Lagoa do Mato",
  }, {
    name: "Lagoa do Ouro",
  }, {
    name: "Lagoa do Piauí",
  }, {
    name: "Lagoa do Sítio",
  }, {
    name: "Lagoa do Tocantins",
  }, {
    name: "Lagoa dos Gatos",
  }, {
    name: "Lagoa dos Patos",
  }, {
    name: "Lagoa dos Três Cantos",
  }, {
    name: "Lagoinha",
  }, {
    name: "Lagoinha do Piauí",
  }, {
    name: "Lagoão",
  }, {
    name: "Laguna",
  }, {
    name: "Laguna Carapã",
  }, {
    name: "Laje",
  }, {
    name: "Laje do Muriaé",
  }, {
    name: "Lajeado",
  }, {
    name: "Lajeado Grande",
  }, {
    name: "Lajeado Novo",
  }, {
    name: "Lajeado do Bugre",
  }, {
    name: "Lajedinho",
  }, {
    name: "Lajedo",
  }, {
    name: "Lajedo do Tabocal",
  }, {
    name: "Lajedão",
  }, {
    name: "Lajes",
  }, {
    name: "Lajes Pintadas",
  }, {
    name: "Lajinha",
  }, {
    name: "Lamarão",
  }, {
    name: "Lambari",
  }, {
    name: "Lambari D'Oeste",
  }, {
    name: "Lamim",
  }, {
    name: "Landri Sales",
  }, {
    name: "Lapa",
  }, {
    name: "Lapão",
  }, {
    name: "Laranja da Terra",
  }, {
    name: "Laranjal",
  }, {
    name: "Laranjal Paulista",
  }, {
    name: "Laranjal do Jari",
  }, {
    name: "Laranjeiras",
  }, {
    name: "Laranjeiras do Sul",
  }, {
    name: "Lassance",
  }, {
    name: "Lastro",
  }, {
    name: "Laurentino",
  }, {
    name: "Lauro Müller",
  }, {
    name: "Lauro de Freitas",
  }, {
    name: "Lavandeira",
  }, {
    name: "Lavras",
  }, {
    name: "Lavras da Mangabeira",
  }, {
    name: "Lavras do Sul",
  }, {
    name: "Lavrinhas",
  }, {
    name: "Lavínia",
  }, {
    name: "Leandro Ferreira",
  }, {
    name: "Lebon Régis",
  }, {
    name: "Leme",
  }, {
    name: "Leme do Prado",
  }, {
    name: "Lençóis",
  }, {
    name: "Lençóis Paulista",
  }, {
    name: "Leoberto Leal",
  }, {
    name: "Leopoldina",
  }, {
    name: "Leopoldo de Bulhões",
  }, {
    name: "Leópolis",
  }, {
    name: "Liberato Salzano",
  }, {
    name: "Liberdade",
  }, {
    name: "Licínio de Almeida",
  }, {
    name: "Lidianópolis",
  }, {
    name: "Lima Campos",
  }, {
    name: "Lima Duarte",
  }, {
    name: "Limeira",
  }, {
    name: "Limeira do Oeste",
  }, {
    name: "Limoeiro",
  }, {
    name: "Limoeiro de Anadia",
  }, {
    name: "Limoeiro do Ajuru",
  }, {
    name: "Limoeiro do Norte",
  }, {
    name: "Lindoeste",
  }, {
    name: "Lindolfo Collor",
  }, {
    name: "Lindóia",
  }, {
    name: "Lindóia do Sul",
  }, {
    name: "Linha Nova",
  }, {
    name: "Linhares",
  }, {
    name: "Lins",
  }, {
    name: "Livramento",
  }, {
    name: "Livramento de Nossa Senhora",
  }, {
    name: "Lizarda",
  }, {
    name: "Loanda",
  }, {
    name: "Lobato",
  }, {
    name: "Logradouro",
  }, {
    name: "Londrina",
  }, {
    name: "Lontra",
  }, {
    name: "Lontras",
  }, {
    name: "Lorena",
  }, {
    name: "Loreto",
  }, {
    name: "Lourdes",
  }, {
    name: "Louveira",
  }, {
    name: "Lucas do Rio Verde",
  }, {
    name: "Lucena",
  }, {
    name: "Lucianópolis",
  }, {
    name: "Luciara",
  }, {
    name: "Lucrécia",
  }, {
    name: "Lucélia",
  }, {
    name: "Luisburgo",
  }, {
    name: "Luislândia",
  }, {
    name: "Luiz Alves",
  }, {
    name: "Luiziana",
  }, {
    name: "Luiziânia",
  }, {
    name: "Luminárias",
  }, {
    name: "Lunardelli",
  }, {
    name: "Lupionópolis",
  }, {
    name: "Lupércio",
  }, {
    name: "Lutécia",
  }, {
    name: "Luz",
  }, {
    name: "Luzerna",
  }, {
    name: "Luzilândia",
  }, {
    name: "Luzinópolis",
  }, {
    name: "Luziânia",
  }, {
    name: "Luís Antônio",
  }, {
    name: "Luís Correia",
  }, {
    name: "Luís Domingues",
  }, {
    name: "Luís Eduardo Magalhães",
  }, {
    name: "Luís Gomes",
  }, {
    name: "Lábrea",
  }, {
    name: "Macajuba",
  }, {
    name: "Macambira",
  }, {
    name: "Macaparana",
  }, {
    name: "Macapá",
  }, {
    name: "Macarani",
  }, {
    name: "Macatuba",
  }, {
    name: "Macau",
  }, {
    name: "Macaubal",
  }, {
    name: "Macaé",
  }, {
    name: "Macaíba",
  }, {
    name: "Macaúbas",
  }, {
    name: "Macedônia",
  }, {
    name: "Maceió",
  }, {
    name: "Machacalis",
  }, {
    name: "Machadinho",
  }, {
    name: "Machadinho D'Oeste",
  }, {
    name: "Machado",
  }, {
    name: "Machados",
  }, {
    name: "Macieira",
  }, {
    name: "Macuco",
  }, {
    name: "Macururé",
  }, {
    name: "Madalena",
  }, {
    name: "Madeiro",
  }, {
    name: "Madre de Deus",
  }, {
    name: "Madre de Deus de Minas",
  }, {
    name: "Maetinga",
  }, {
    name: "Mafra",
  }, {
    name: "Magalhães Barata",
  }, {
    name: "Magalhães de Almeida",
  }, {
    name: "Magda",
  }, {
    name: "Magé",
  }, {
    name: "Maiquinique",
  }, {
    name: "Mairi",
  }, {
    name: "Mairinque",
  }, {
    name: "Mairiporã",
  }, {
    name: "Mairipotaba",
  }, {
    name: "Major Gercino",
  }, {
    name: "Major Isidoro",
  }, {
    name: "Major Sales",
  }, {
    name: "Major Vieira",
  }, {
    name: "Malacacheta",
  }, {
    name: "Malhada",
  }, {
    name: "Malhada de Pedras",
  }, {
    name: "Malhada dos Bois",
  }, {
    name: "Malhador",
  }, {
    name: "Mallet",
  }, {
    name: "Malta",
  }, {
    name: "Mamanguape",
  }, {
    name: "Mambaí",
  }, {
    name: "Mamborê",
  }, {
    name: "Mamonas",
  }, {
    name: "Mampituba",
  }, {
    name: "Manacapuru",
  }, {
    name: "Manaquiri",
  }, {
    name: "Manari",
  }, {
    name: "Manaus",
  }, {
    name: "Manaíra",
  }, {
    name: "Mandaguari",
  }, {
    name: "Mandaguaçu",
  }, {
    name: "Mandirituba",
  }, {
    name: "Manduri",
  }, {
    name: "Manfrinópolis",
  }, {
    name: "Manga",
  }, {
    name: "Mangaratiba",
  }, {
    name: "Mangueirinha",
  }, {
    name: "Manhuaçu",
  }, {
    name: "Manhumirim",
  }, {
    name: "Manicoré",
  }, {
    name: "Manoel Emídio",
  }, {
    name: "Manoel Ribas",
  }, {
    name: "Manoel Urbano",
  }, {
    name: "Manoel Viana",
  }, {
    name: "Manoel Vitorino",
  }, {
    name: "Mansidão",
  }, {
    name: "Mantena",
  }, {
    name: "Mantenópolis",
  }, {
    name: "Maquiné",
  }, {
    name: "Mar Vermelho",
  }, {
    name: "Mar de Espanha",
  }, {
    name: "Mara Rosa",
  }, {
    name: "Marabá",
  }, {
    name: "Marabá Paulista",
  }, {
    name: "Maracaju",
  }, {
    name: "Maracajá",
  }, {
    name: "Maracanaú",
  }, {
    name: "Maracanã",
  }, {
    name: "Maracaçumé",
  }, {
    name: "Maracaí",
  }, {
    name: "Maracás",
  }, {
    name: "Maragogi",
  }, {
    name: "Maragogipe",
  }, {
    name: "Maraial",
  }, {
    name: "Marajá do Sena",
  }, {
    name: "Maranguape",
  }, {
    name: "Maranhãozinho",
  }, {
    name: "Marapanim",
  }, {
    name: "Marapoama",
  }, {
    name: "Marataízes",
  }, {
    name: "Maratá",
  }, {
    name: "Marau",
  }, {
    name: "Maravilha",
  }, {
    name: "Maravilhas",
  }, {
    name: "Maraã",
  }, {
    name: "Maraú",
  }, {
    name: "Marcação",
  }, {
    name: "Marcelino Ramos",
  }, {
    name: "Marcelino Vieira",
  }, {
    name: "Marcelândia",
  }, {
    name: "Marcionílio Souza",
  }, {
    name: "Marco",
  }, {
    name: "Marcolândia",
  }, {
    name: "Marcos Parente",
  }, {
    name: "Marechal Cândido Rondon",
  }, {
    name: "Marechal Deodoro",
  }, {
    name: "Marechal Floriano",
  }, {
    name: "Marechal Thaumaturgo",
  }, {
    name: "Marema",
  }, {
    name: "Mari",
  }, {
    name: "Maria Helena",
  }, {
    name: "Maria da Fé",
  }, {
    name: "Marialva",
  }, {
    name: "Mariana",
  }, {
    name: "Mariana Pimentel",
  }, {
    name: "Mariano Moro",
  }, {
    name: "Marianópolis do Tocantins",
  }, {
    name: "Maribondo",
  }, {
    name: "Maricá",
  }, {
    name: "Marilac",
  }, {
    name: "Marilena",
  }, {
    name: "Mariluz",
  }, {
    name: "Marilândia",
  }, {
    name: "Marilândia do Sul",
  }, {
    name: "Maringá",
  }, {
    name: "Marinópolis",
  }, {
    name: "Maripá",
  }, {
    name: "Maripá de Minas",
  }, {
    name: "Marituba",
  }, {
    name: "Marizópolis",
  }, {
    name: "Mariápolis",
  }, {
    name: "Mariópolis",
  }, {
    name: "Marliéria",
  }, {
    name: "Marmeleiro",
  }, {
    name: "Marmelópolis",
  }, {
    name: "Marques de Souza",
  }, {
    name: "Marquinho",
  }, {
    name: "Martinho Campos",
  }, {
    name: "Martins",
  }, {
    name: "Martins Soares",
  }, {
    name: "Martinópole",
  }, {
    name: "Martinópolis",
  }, {
    name: "Maruim",
  }, {
    name: "Marumbi",
  }, {
    name: "Marzagão",
  }, {
    name: "Marília",
  }, {
    name: "Mascote",
  }, {
    name: "Massapê",
  }, {
    name: "Massapê do Piauí",
  }, {
    name: "Massaranduba",
  }, {
    name: "Mata",
  }, {
    name: "Mata Grande",
  }, {
    name: "Mata Roma",
  }, {
    name: "Mata Verde",
  }, {
    name: "Mata de São João",
  }, {
    name: "Mataraca",
  }, {
    name: "Mateiros",
  }, {
    name: "Matelândia",
  }, {
    name: "Materlândia",
  }, {
    name: "Mateus Leme",
  }, {
    name: "Mathias Lobato",
  }, {
    name: "Matias Barbosa",
  }, {
    name: "Matias Cardoso",
  }, {
    name: "Matias Olímpio",
  }, {
    name: "Matina",
  }, {
    name: "Matinha",
  }, {
    name: "Matinhas",
  }, {
    name: "Matinhos",
  }, {
    name: "Matipó",
  }, {
    name: "Mato Castelhano",
  }, {
    name: "Mato Grosso",
  }, {
    name: "Mato Leitão",
  }, {
    name: "Mato Queimado",
  }, {
    name: "Mato Rico",
  }, {
    name: "Mato Verde",
  }, {
    name: "Matos Costa",
  }, {
    name: "Matozinhos",
  }, {
    name: "Matrinchã",
  }, {
    name: "Matriz de Camaragibe",
  }, {
    name: "Matupá",
  }, {
    name: "Maturéia",
  }, {
    name: "Matutina",
  }, {
    name: "Matão",
  }, {
    name: "Matões",
  }, {
    name: "Matões do Norte",
  }, {
    name: "Maurilândia",
  }, {
    name: "Maurilândia do Tocantins",
  }, {
    name: "Mauriti",
  }, {
    name: "Mauá",
  }, {
    name: "Mauá da Serra",
  }, {
    name: "Maués",
  }, {
    name: "Maxaranguape",
  }, {
    name: "Maximiliano de Almeida",
  }, {
    name: "Mazagão",
  }, {
    name: "Maçambará",
  }, {
    name: "Medeiros",
  }, {
    name: "Medeiros Neto",
  }, {
    name: "Medianeira",
  }, {
    name: "Medicilândia",
  }, {
    name: "Medina",
  }, {
    name: "Meleiro",
  }, {
    name: "Melgaço",
  }, {
    name: "Mendes",
  }, {
    name: "Mendes Pimentel",
  }, {
    name: "Mendonça",
  }, {
    name: "Mercedes",
  }, {
    name: "Mercês",
  }, {
    name: "Meridiano",
  }, {
    name: "Meruoca",
  }, {
    name: "Mesquita",
  }, {
    name: "Messias",
  }, {
    name: "Messias Targino",
  }, {
    name: "Mesópolis",
  }, {
    name: "Miguel Alves",
  }, {
    name: "Miguel Calmon",
  }, {
    name: "Miguel Leão",
  }, {
    name: "Miguel Pereira",
  }, {
    name: "Miguelópolis",
  }, {
    name: "Milagres",
  }, {
    name: "Milagres do Maranhão",
  }, {
    name: "Milhã",
  }, {
    name: "Milton Brandão",
  }, {
    name: "Mimoso de Goiás",
  }, {
    name: "Mimoso do Sul",
  }, {
    name: "Minador do Negrão",
  }, {
    name: "Minas Novas",
  }, {
    name: "Minas do Leão",
  }, {
    name: "Minaçu",
  }, {
    name: "Minduri",
  }, {
    name: "Mineiros",
  }, {
    name: "Mineiros do Tietê",
  }, {
    name: "Ministro Andreazza",
  }, {
    name: "Mira Estrela",
  }, {
    name: "Mirabela",
  }, {
    name: "Miracatu",
  }, {
    name: "Miracema",
  }, {
    name: "Miracema do Tocantins",
  }, {
    name: "Mirador",
  }, {
    name: "Miradouro",
  }, {
    name: "Miraguaí",
  }, {
    name: "Miranda",
  }, {
    name: "Miranda do Norte",
  }, {
    name: "Mirandiba",
  }, {
    name: "Mirandópolis",
  }, {
    name: "Mirangaba",
  }, {
    name: "Miranorte",
  }, {
    name: "Mirante",
  }, {
    name: "Mirante da Serra",
  }, {
    name: "Mirante do Paranapanema",
  }, {
    name: "Miraselva",
  }, {
    name: "Mirassol",
  }, {
    name: "Mirassol d'Oeste",
  }, {
    name: "Mirassolândia",
  }, {
    name: "Miravânia",
  }, {
    name: "Miraí",
  }, {
    name: "Miraíma",
  }, {
    name: "Mirim Doce",
  }, {
    name: "Mirinzal",
  }, {
    name: "Missal",
  }, {
    name: "Missão Velha",
  }, {
    name: "Mocajuba",
  }, {
    name: "Mococa",
  }, {
    name: "Modelo",
  }, {
    name: "Moeda",
  }, {
    name: "Moema",
  }, {
    name: "Mogeiro",
  }, {
    name: "Mogi Guaçu",
  }, {
    name: "Mogi Mirim",
  }, {
    name: "Mogi das Cruzes",
  }, {
    name: "Moiporá",
  }, {
    name: "Moita Bonita",
  }, {
    name: "Moju",
  }, {
    name: "Mojuí dos Campos",
  }, {
    name: "Mombaça",
  }, {
    name: "Mombuca",
  }, {
    name: "Mondaí",
  }, {
    name: "Mongaguá",
  }, {
    name: "Monjolos",
  }, {
    name: "Monsenhor Gil",
  }, {
    name: "Monsenhor Hipólito",
  }, {
    name: "Monsenhor Paulo",
  }, {
    name: "Monsenhor Tabosa",
  }, {
    name: "Montadas",
  }, {
    name: "Montalvânia",
  }, {
    name: "Montanha",
  }, {
    name: "Montanhas",
  }, {
    name: "Montauri",
  }, {
    name: "Monte Alegre",
  }, {
    name: "Monte Alegre de Goiás",
  }, {
    name: "Monte Alegre de Minas",
  }, {
    name: "Monte Alegre de Sergipe",
  }, {
    name: "Monte Alegre do Piauí",
  }, {
    name: "Monte Alegre do Sul",
  }, {
    name: "Monte Alegre dos Campos",
  }, {
    name: "Monte Alto",
  }, {
    name: "Monte Aprazível",
  }, {
    name: "Monte Azul",
  }, {
    name: "Monte Azul Paulista",
  }, {
    name: "Monte Belo",
  }, {
    name: "Monte Belo do Sul",
  }, {
    name: "Monte Carlo",
  }, {
    name: "Monte Carmelo",
  }, {
    name: "Monte Castelo",
  }, {
    name: "Monte Formoso",
  }, {
    name: "Monte Horebe",
  }, {
    name: "Monte Mor",
  }, {
    name: "Monte Negro",
  }, {
    name: "Monte Santo",
  }, {
    name: "Monte Santo de Minas",
  }, {
    name: "Monte Santo do Tocantins",
  }, {
    name: "Monte Sião",
  }, {
    name: "Monte das Gameleiras",
  }, {
    name: "Monte do Carmo",
  }, {
    name: "Monteiro",
  }, {
    name: "Monteiro Lobato",
  }, {
    name: "Monteirópolis",
  }, {
    name: "Montenegro",
  }, {
    name: "Montes Altos",
  }, {
    name: "Montes Claros",
  }, {
    name: "Montes Claros de Goiás",
  }, {
    name: "Montezuma",
  }, {
    name: "Montividiu",
  }, {
    name: "Montividiu do Norte",
  }, {
    name: "Monção",
  }, {
    name: "Monções",
  }, {
    name: "Morada Nova",
  }, {
    name: "Morada Nova de Minas",
  }, {
    name: "Moraújo",
  }, {
    name: "Moreilândia",
  }, {
    name: "Moreira Sales",
  }, {
    name: "Moreno",
  }, {
    name: "Mormaço",
  }, {
    name: "Morpará",
  }, {
    name: "Morretes",
  }, {
    name: "Morrinhos",
  }, {
    name: "Morrinhos do Sul",
  }, {
    name: "Morro Agudo",
  }, {
    name: "Morro Agudo de Goiás",
  }, {
    name: "Morro Cabeça no Tempo",
  }, {
    name: "Morro Grande",
  }, {
    name: "Morro Redondo",
  }, {
    name: "Morro Reuter",
  }, {
    name: "Morro da Fumaça",
  }, {
    name: "Morro da Garça",
  }, {
    name: "Morro do Chapéu",
  }, {
    name: "Morro do Chapéu do Piauí",
  }, {
    name: "Morro do Pilar",
  }, {
    name: "Morros",
  }, {
    name: "Mortugaba",
  }, {
    name: "Morungaba",
  }, {
    name: "Mossoró",
  }, {
    name: "Mossâmedes",
  }, {
    name: "Mostardas",
  }, {
    name: "Motuca",
  }, {
    name: "Mozarlândia",
  }, {
    name: "Muaná",
  }, {
    name: "Mucajaí",
  }, {
    name: "Mucambo",
  }, {
    name: "Mucugê",
  }, {
    name: "Mucuri",
  }, {
    name: "Mucurici",
  }, {
    name: "Muitos Capões",
  }, {
    name: "Muliterno",
  }, {
    name: "Mulungu",
  }, {
    name: "Mulungu do Morro",
  }, {
    name: "Mundo Novo",
  }, {
    name: "Munhoz",
  }, {
    name: "Munhoz de Melo",
  }, {
    name: "Muniz Ferreira",
  }, {
    name: "Muniz Freire",
  }, {
    name: "Muqui",
  }, {
    name: "Muquém do São Francisco",
  }, {
    name: "Muriaé",
  }, {
    name: "Muribeca",
  }, {
    name: "Murici",
  }, {
    name: "Murici dos Portelas",
  }, {
    name: "Muricilândia",
  }, {
    name: "Muritiba",
  }, {
    name: "Murutinga do Sul",
  }, {
    name: "Mutum",
  }, {
    name: "Mutunópolis",
  }, {
    name: "Mutuípe",
  }, {
    name: "Muzambinho",
  }, {
    name: "Muçum",
  }, {
    name: "Mário Campos",
  }, {
    name: "Mâncio Lima",
  }, {
    name: "Mãe d'Água",
  }, {
    name: "Mãe do Rio",
  }, {
    name: "Nacip Raydan",
  }, {
    name: "Nantes",
  }, {
    name: "Nanuque",
  }, {
    name: "Naque",
  }, {
    name: "Narandiba",
  }, {
    name: "Natal",
  }, {
    name: "Natalândia",
  }, {
    name: "Natividade",
  }, {
    name: "Natividade da Serra",
  }, {
    name: "Natuba",
  }, {
    name: "Natércia",
  }, {
    name: "Navegantes",
  }, {
    name: "Naviraí",
  }, {
    name: "Nazareno",
  }, {
    name: "Nazarezinho",
  }, {
    name: "Nazaré",
  }, {
    name: "Nazaré Paulista",
  }, {
    name: "Nazaré da Mata",
  }, {
    name: "Nazaré do Piauí",
  }, {
    name: "Nazária",
  }, {
    name: "Nazário",
  }, {
    name: "Nepomuceno",
  }, {
    name: "Nerópolis",
  }, {
    name: "Neves Paulista",
  }, {
    name: "Neópolis",
  }, {
    name: "Nhamundá",
  }, {
    name: "Nhandeara",
  }, {
    name: "Nicolau Vergueiro",
  }, {
    name: "Nilo Peçanha",
  }, {
    name: "Nilópolis",
  }, {
    name: "Nina Rodrigues",
  }, {
    name: "Ninheira",
  }, {
    name: "Nioaque",
  }, {
    name: "Nipoã",
  }, {
    name: "Niquelândia",
  }, {
    name: "Niterói",
  }, {
    name: "Nobres",
  }, {
    name: "Nonoai",
  }, {
    name: "Nordestina",
  }, {
    name: "Normandia",
  }, {
    name: "Nortelândia",
  }, {
    name: "Nossa Senhora Aparecida",
  }, {
    name: "Nossa Senhora da Glória",
  }, {
    name: "Nossa Senhora das Dores",
  }, {
    name: "Nossa Senhora das Graças",
  }, {
    name: "Nossa Senhora de Lourdes",
  }, {
    name: "Nossa Senhora de Nazaré",
  }, {
    name: "Nossa Senhora do Livramento",
  }, {
    name: "Nossa Senhora do Socorro",
  }, {
    name: "Nossa Senhora dos Remédios",
  }, {
    name: "Nova Aliança",
  }, {
    name: "Nova Aliança do Ivaí",
  }, {
    name: "Nova Alvorada",
  }, {
    name: "Nova Alvorada do Sul",
  }, {
    name: "Nova América",
  }, {
    name: "Nova América da Colina",
  }, {
    name: "Nova Andradina",
  }, {
    name: "Nova Araçá",
  }, {
    name: "Nova Aurora",
  }, {
    name: "Nova Bandeirantes",
  }, {
    name: "Nova Bassano",
  }, {
    name: "Nova Belém",
  }, {
    name: "Nova Boa Vista",
  }, {
    name: "Nova Brasilândia",
  }, {
    name: "Nova Brasilândia D'Oeste",
  }, {
    name: "Nova Bréscia",
  }, {
    name: "Nova Campina",
  }, {
    name: "Nova Canaã",
  }, {
    name: "Nova Canaã Paulista",
  }, {
    name: "Nova Canaã do Norte",
  }, {
    name: "Nova Candelária",
  }, {
    name: "Nova Cantu",
  }, {
    name: "Nova Castilho",
  }, {
    name: "Nova Colinas",
  }, {
    name: "Nova Crixás",
  }, {
    name: "Nova Cruz",
  }, {
    name: "Nova Era",
  }, {
    name: "Nova Erechim",
  }, {
    name: "Nova Esperança",
  }, {
    name: "Nova Esperança do Piriá",
  }, {
    name: "Nova Esperança do Sudoeste",
  }, {
    name: "Nova Esperança do Sul",
  }, {
    name: "Nova Europa",
  }, {
    name: "Nova Floresta",
  }, {
    name: "Nova Friburgo",
  }, {
    name: "Nova Fátima",
  }, {
    name: "Nova Glória",
  }, {
    name: "Nova Granada",
  }, {
    name: "Nova Guarita",
  }, {
    name: "Nova Guataporanga",
  }, {
    name: "Nova Hartz",
  }, {
    name: "Nova Ibiá",
  }, {
    name: "Nova Iguaçu",
  }, {
    name: "Nova Iguaçu de Goiás",
  }, {
    name: "Nova Independência",
  }, {
    name: "Nova Iorque",
  }, {
    name: "Nova Ipixuna",
  }, {
    name: "Nova Itaberaba",
  }, {
    name: "Nova Itarana",
  }, {
    name: "Nova Lacerda",
  }, {
    name: "Nova Laranjeiras",
  }, {
    name: "Nova Lima",
  }, {
    name: "Nova Londrina",
  }, {
    name: "Nova Luzitânia",
  }, {
    name: "Nova Mamoré",
  }, {
    name: "Nova Marilândia",
  }, {
    name: "Nova Maringá",
  }, {
    name: "Nova Monte Verde",
  }, {
    name: "Nova Mutum",
  }, {
    name: "Nova Módica",
  }, {
    name: "Nova Nazaré",
  }, {
    name: "Nova Odessa",
  }, {
    name: "Nova Olinda",
  }, {
    name: "Nova Olinda do Maranhão",
  }, {
    name: "Nova Olinda do Norte",
  }, {
    name: "Nova Olímpia",
  }, {
    name: "Nova Palma",
  }, {
    name: "Nova Palmeira",
  }, {
    name: "Nova Petrópolis",
  }, {
    name: "Nova Ponte",
  }, {
    name: "Nova Porteirinha",
  }, {
    name: "Nova Prata",
  }, {
    name: "Nova Prata do Iguaçu",
  }, {
    name: "Nova Pádua",
  }, {
    name: "Nova Ramada",
  }, {
    name: "Nova Redenção",
  }, {
    name: "Nova Resende",
  }, {
    name: "Nova Roma",
  }, {
    name: "Nova Roma do Sul",
  }, {
    name: "Nova Rosalândia",
  }, {
    name: "Nova Russas",
  }, {
    name: "Nova Santa Bárbara",
  }, {
    name: "Nova Santa Helena",
  }, {
    name: "Nova Santa Rita",
  }, {
    name: "Nova Santa Rosa",
  }, {
    name: "Nova Serrana",
  }, {
    name: "Nova Soure",
  }, {
    name: "Nova Tebas",
  }, {
    name: "Nova Timboteua",
  }, {
    name: "Nova Trento",
  }, {
    name: "Nova Ubiratã",
  }, {
    name: "Nova União",
  }, {
    name: "Nova Veneza",
  }, {
    name: "Nova Venécia",
  }, {
    name: "Nova Viçosa",
  }, {
    name: "Nova Xavantina",
  }, {
    name: "Novais",
  }, {
    name: "Novo Acordo",
  }, {
    name: "Novo Airão",
  }, {
    name: "Novo Alegre",
  }, {
    name: "Novo Aripuanã",
  }, {
    name: "Novo Barreiro",
  }, {
    name: "Novo Brasil",
  }, {
    name: "Novo Cabrais",
  }, {
    name: "Novo Cruzeiro",
  }, {
    name: "Novo Gama",
  }, {
    name: "Novo Hamburgo",
  }, {
    name: "Novo Horizonte",
  }, {
    name: "Novo Horizonte do Norte",
  }, {
    name: "Novo Horizonte do Oeste",
  }, {
    name: "Novo Horizonte do Sul",
  }, {
    name: "Novo Itacolomi",
  }, {
    name: "Novo Jardim",
  }, {
    name: "Novo Lino",
  }, {
    name: "Novo Machado",
  }, {
    name: "Novo Mundo",
  }, {
    name: "Novo Oriente",
  }, {
    name: "Novo Oriente de Minas",
  }, {
    name: "Novo Oriente do Piauí",
  }, {
    name: "Novo Planalto",
  }, {
    name: "Novo Progresso",
  }, {
    name: "Novo Repartimento",
  }, {
    name: "Novo Santo Antônio",
  }, {
    name: "Novo São Joaquim",
  }, {
    name: "Novo Tiradentes",
  }, {
    name: "Novo Triunfo",
  }, {
    name: "Novo Xingu",
  }, {
    name: "Novorizonte",
  }, {
    name: "Nuporanga",
  }, {
    name: "Não-Me-Toque",
  }, {
    name: "Nísia Floresta",
  }, {
    name: "Ocara",
  }, {
    name: "Ocauçu",
  }, {
    name: "Oeiras",
  }, {
    name: "Oeiras do Pará",
  }, {
    name: "Oiapoque",
  }, {
    name: "Olaria",
  }, {
    name: "Olho D'Água do Piauí",
  }, {
    name: "Olho d'Água",
  }, {
    name: "Olho d'Água Grande",
  }, {
    name: "Olho d'Água das Cunhãs",
  }, {
    name: "Olho d'Água das Flores",
  }, {
    name: "Olho d'Água do Borges",
  }, {
    name: "Olho d'Água do Casado",
  }, {
    name: "Olhos-d'Água",
  }, {
    name: "Olinda",
  }, {
    name: "Olinda Nova do Maranhão",
  }, {
    name: "Olindina",
  }, {
    name: "Olivedos",
  }, {
    name: "Oliveira",
  }, {
    name: "Oliveira Fortes",
  }, {
    name: "Oliveira de Fátima",
  }, {
    name: "Oliveira dos Brejinhos",
  }, {
    name: "Olivença",
  }, {
    name: "Olímpia",
  }, {
    name: "Olímpio Noronha",
  }, {
    name: "Onda Verde",
  }, {
    name: "Onça de Pitangui",
  }, {
    name: "Oratórios",
  }, {
    name: "Oriente",
  }, {
    name: "Orindiúva",
  }, {
    name: "Oriximiná",
  }, {
    name: "Orizona",
  }, {
    name: "Orizânia",
  }, {
    name: "Orleans",
  }, {
    name: "Orlândia",
  }, {
    name: "Orobó",
  }, {
    name: "Orocó",
  }, {
    name: "Ortigueira",
  }, {
    name: "Orós",
  }, {
    name: "Osasco",
  }, {
    name: "Oscar Bressane",
  }, {
    name: "Osvaldo Cruz",
  }, {
    name: "Osório",
  }, {
    name: "Otacílio Costa",
  }, {
    name: "Ouricuri",
  }, {
    name: "Ourilândia do Norte",
  }, {
    name: "Ourinhos",
  }, {
    name: "Ourizona",
  }, {
    name: "Ouriçangas",
  }, {
    name: "Ouro",
  }, {
    name: "Ouro Branco",
  }, {
    name: "Ouro Fino",
  }, {
    name: "Ouro Preto",
  }, {
    name: "Ouro Preto do Oeste",
  }, {
    name: "Ouro Velho",
  }, {
    name: "Ouro Verde",
  }, {
    name: "Ouro Verde de Goiás",
  }, {
    name: "Ouro Verde de Minas",
  }, {
    name: "Ouro Verde do Oeste",
  }, {
    name: "Ouroeste",
  }, {
    name: "Ourolândia",
  }, {
    name: "Ourém",
  }, {
    name: "Ouvidor",
  }, {
    name: "Pacaembu",
  }, {
    name: "Pacajus",
  }, {
    name: "Pacajá",
  }, {
    name: "Pacaraima",
  }, {
    name: "Pacatuba",
  }, {
    name: "Pacoti",
  }, {
    name: "Pacujá",
  }, {
    name: "Padre Bernardo",
  }, {
    name: "Padre Carvalho",
  }, {
    name: "Padre Marcos",
  }, {
    name: "Padre Paraíso",
  }, {
    name: "Paes Landim",
  }, {
    name: "Pai Pedro",
  }, {
    name: "Paial",
  }, {
    name: "Paim Filho",
  }, {
    name: "Paineiras",
  }, {
    name: "Painel",
  }, {
    name: "Pains",
  }, {
    name: "Paiva",
  }, {
    name: "Paiçandu",
  }, {
    name: "Pajeú do Piauí",
  }, {
    name: "Palestina",
  }, {
    name: "Palestina de Goiás",
  }, {
    name: "Palestina do Pará",
  }, {
    name: "Palhano",
  }, {
    name: "Palhoça",
  }, {
    name: "Palma",
  }, {
    name: "Palma Sola",
  }, {
    name: "Palmares",
  }, {
    name: "Palmares Paulista",
  }, {
    name: "Palmares do Sul",
  }, {
    name: "Palmas",
  }, {
    name: "Palmas de Monte Alto",
  }, {
    name: "Palmeira",
  }, {
    name: "Palmeira d'Oeste",
  }, {
    name: "Palmeira das Missões",
  }, {
    name: "Palmeira do Piauí",
  }, {
    name: "Palmeira dos Índios",
  }, {
    name: "Palmeirais",
  }, {
    name: "Palmeirante",
  }, {
    name: "Palmeiras",
  }, {
    name: "Palmeiras de Goiás",
  }, {
    name: "Palmeiras do Tocantins",
  }, {
    name: "Palmeirina",
  }, {
    name: "Palmeirândia",
  }, {
    name: "Palmeirópolis",
  }, {
    name: "Palmelo",
  }, {
    name: "Palminópolis",
  }, {
    name: "Palmital",
  }, {
    name: "Palmitinho",
  }, {
    name: "Palmitos",
  }, {
    name: "Palmácia",
  }, {
    name: "Palmópolis",
  }, {
    name: "Palotina",
  }, {
    name: "Panambi",
  }, {
    name: "Panamá",
  }, {
    name: "Pancas",
  }, {
    name: "Panelas",
  }, {
    name: "Panorama",
  }, {
    name: "Pantano Grande",
  }, {
    name: "Papagaios",
  }, {
    name: "Papanduva",
  }, {
    name: "Paquetá",
  }, {
    name: "Paracambi",
  }, {
    name: "Paracatu",
  }, {
    name: "Paracuru",
  }, {
    name: "Paragominas",
  }, {
    name: "Paraguaçu",
  }, {
    name: "Paraguaçu Paulista",
  }, {
    name: "Paraibano",
  }, {
    name: "Paraibuna",
  }, {
    name: "Paraipaba",
  }, {
    name: "Paraisópolis",
  }, {
    name: "Parambu",
  }, {
    name: "Paramirim",
  }, {
    name: "Paramoti",
  }, {
    name: "Paranacity",
  }, {
    name: "Paranaguá",
  }, {
    name: "Paranaiguara",
  }, {
    name: "Paranapanema",
  }, {
    name: "Paranapoema",
  }, {
    name: "Paranapuã",
  }, {
    name: "Paranatama",
  }, {
    name: "Paranatinga",
  }, {
    name: "Paranavaí",
  }, {
    name: "Paranaíba",
  }, {
    name: "Paranaíta",
  }, {
    name: "Paranhos",
  }, {
    name: "Paraná",
  }, {
    name: "Paranã",
  }, {
    name: "Paraopeba",
  }, {
    name: "Parapuã",
  }, {
    name: "Parari",
  }, {
    name: "Paratinga",
  }, {
    name: "Paraty",
  }, {
    name: "Parauapebas",
  }, {
    name: "Parazinho",
  }, {
    name: "Paraí",
  }, {
    name: "Paraíba do Sul",
  }, {
    name: "Paraíso",
  }, {
    name: "Paraíso das Águas",
  }, {
    name: "Paraíso do Norte",
  }, {
    name: "Paraíso do Sul",
  }, {
    name: "Paraíso do Tocantins",
  }, {
    name: "Paraú",
  }, {
    name: "Paraúna",
  }, {
    name: "Pardinho",
  }, {
    name: "Pareci Novo",
  }, {
    name: "Parecis",
  }, {
    name: "Parelhas",
  }, {
    name: "Pariconha",
  }, {
    name: "Parintins",
  }, {
    name: "Paripiranga",
  }, {
    name: "Paripueira",
  }, {
    name: "Pariquera-Açu",
  }, {
    name: "Parisi",
  }, {
    name: "Parnaguá",
  }, {
    name: "Parnamirim",
  }, {
    name: "Parnarama",
  }, {
    name: "Parnaíba",
  }, {
    name: "Parobé",
  }, {
    name: "Pará de Minas",
  }, {
    name: "Passa Quatro",
  }, {
    name: "Passa Sete",
  }, {
    name: "Passa Tempo",
  }, {
    name: "Passa Vinte",
  }, {
    name: "Passa e Fica",
  }, {
    name: "Passabém",
  }, {
    name: "Passagem",
  }, {
    name: "Passagem Franca",
  }, {
    name: "Passagem Franca do Piauí",
  }, {
    name: "Passira",
  }, {
    name: "Passo Fundo",
  }, {
    name: "Passo de Camaragibe",
  }, {
    name: "Passo de Torres",
  }, {
    name: "Passo do Sobrado",
  }, {
    name: "Passos",
  }, {
    name: "Passos Maia",
  }, {
    name: "Pastos Bons",
  }, {
    name: "Patis",
  }, {
    name: "Pato Bragado",
  }, {
    name: "Pato Branco",
  }, {
    name: "Patos",
  }, {
    name: "Patos de Minas",
  }, {
    name: "Patos do Piauí",
  }, {
    name: "Patrocínio",
  }, {
    name: "Patrocínio Paulista",
  }, {
    name: "Patrocínio do Muriaé",
  }, {
    name: "Patu",
  }, {
    name: "Paty do Alferes",
  }, {
    name: "Pau Brasil",
  }, {
    name: "Pau D'Arco",
  }, {
    name: "Pau D'Arco do Piauí",
  }, {
    name: "Pau dos Ferros",
  }, {
    name: "Paudalho",
  }, {
    name: "Pauini",
  }, {
    name: "Paula Cândido",
  }, {
    name: "Paula Freitas",
  }, {
    name: "Paulicéia",
  }, {
    name: "Paulino Neves",
  }, {
    name: "Paulista",
  }, {
    name: "Paulistana",
  }, {
    name: "Paulistas",
  }, {
    name: "Paulistânia",
  }, {
    name: "Paulo Afonso",
  }, {
    name: "Paulo Bento",
  }, {
    name: "Paulo Frontin",
  }, {
    name: "Paulo Jacinto",
  }, {
    name: "Paulo Lopes",
  }, {
    name: "Paulo Ramos",
  }, {
    name: "Paulo de Faria",
  }, {
    name: "Paulínia",
  }, {
    name: "Paverama",
  }, {
    name: "Pavussu",
  }, {
    name: "Pavão",
  }, {
    name: "Paço do Lumiar",
  }, {
    name: "Peabiru",
  }, {
    name: "Pederneiras",
  }, {
    name: "Pedra",
  }, {
    name: "Pedra Azul",
  }, {
    name: "Pedra Bela",
  }, {
    name: "Pedra Bonita",
  }, {
    name: "Pedra Branca",
  }, {
    name: "Pedra Branca do Amapari",
  }, {
    name: "Pedra Dourada",
  }, {
    name: "Pedra Grande",
  }, {
    name: "Pedra Lavrada",
  }, {
    name: "Pedra Mole",
  }, {
    name: "Pedra Preta",
  }, {
    name: "Pedra do Anta",
  }, {
    name: "Pedra do Indaiá",
  }, {
    name: "Pedralva",
  }, {
    name: "Pedranópolis",
  }, {
    name: "Pedras Altas",
  }, {
    name: "Pedras Grandes",
  }, {
    name: "Pedras de Fogo",
  }, {
    name: "Pedras de Maria da Cruz",
  }, {
    name: "Pedregulho",
  }, {
    name: "Pedreira",
  }, {
    name: "Pedreiras",
  }, {
    name: "Pedrinhas",
  }, {
    name: "Pedrinhas Paulista",
  }, {
    name: "Pedrinópolis",
  }, {
    name: "Pedro Afonso",
  }, {
    name: "Pedro Alexandre",
  }, {
    name: "Pedro Avelino",
  }, {
    name: "Pedro Canário",
  }, {
    name: "Pedro Gomes",
  }, {
    name: "Pedro II",
  }, {
    name: "Pedro Laurentino",
  }, {
    name: "Pedro Leopoldo",
  }, {
    name: "Pedro Osório",
  }, {
    name: "Pedro Régis",
  }, {
    name: "Pedro Teixeira",
  }, {
    name: "Pedro Velho",
  }, {
    name: "Pedro de Toledo",
  }, {
    name: "Pedro do Rosário",
  }, {
    name: "Pedrão",
  }, {
    name: "Peixe",
  }, {
    name: "Peixe-Boi",
  }, {
    name: "Peixoto de Azevedo",
  }, {
    name: "Pejuçara",
  }, {
    name: "Pelotas",
  }, {
    name: "Penaforte",
  }, {
    name: "Penalva",
  }, {
    name: "Pendências",
  }, {
    name: "Penedo",
  }, {
    name: "Penha",
  }, {
    name: "Pentecoste",
  }, {
    name: "Penápolis",
  }, {
    name: "Pequeri",
  }, {
    name: "Pequi",
  }, {
    name: "Pequizeiro",
  }, {
    name: "Perdigão",
  }, {
    name: "Perdizes",
  }, {
    name: "Perdões",
  }, {
    name: "Pereira Barreto",
  }, {
    name: "Pereiras",
  }, {
    name: "Pereiro",
  }, {
    name: "Peri Mirim",
  }, {
    name: "Periquito",
  }, {
    name: "Peritiba",
  }, {
    name: "Peritoró",
  }, {
    name: "Perobal",
  }, {
    name: "Perolândia",
  }, {
    name: "Peruíbe",
  }, {
    name: "Pescador",
  }, {
    name: "Pescaria Brava",
  }, {
    name: "Pesqueira",
  }, {
    name: "Petrolina",
  }, {
    name: "Petrolina de Goiás",
  }, {
    name: "Petrolândia",
  }, {
    name: "Petrópolis",
  }, {
    name: "Peçanha",
  }, {
    name: "Piacatu",
  }, {
    name: "Piancó",
  }, {
    name: "Piatã",
  }, {
    name: "Piau",
  }, {
    name: "Piaçabuçu",
  }, {
    name: "Picada Café",
  }, {
    name: "Picos",
  }, {
    name: "Picuí",
  }, {
    name: "Piedade",
  }, {
    name: "Piedade de Caratinga",
  }, {
    name: "Piedade de Ponte Nova",
  }, {
    name: "Piedade do Rio Grande",
  }, {
    name: "Piedade dos Gerais",
  }, {
    name: "Pilar",
  }, {
    name: "Pilar de Goiás",
  }, {
    name: "Pilar do Sul",
  }, {
    name: "Pilão Arcado",
  }, {
    name: "Pilões",
  }, {
    name: "Pilõezinhos",
  }, {
    name: "Pimenta",
  }, {
    name: "Pimenta Bueno",
  }, {
    name: "Pimenteiras",
  }, {
    name: "Pimenteiras do Oeste",
  }, {
    name: "Pindamonhangaba",
  }, {
    name: "Pindaré-Mirim",
  }, {
    name: "Pindaí",
  }, {
    name: "Pindoba",
  }, {
    name: "Pindobaçu",
  }, {
    name: "Pindorama",
  }, {
    name: "Pindorama do Tocantins",
  }, {
    name: "Pindoretama",
  }, {
    name: "Pingo d'Água",
  }, {
    name: "Pinhais",
  }, {
    name: "Pinhal",
  }, {
    name: "Pinhal Grande",
  }, {
    name: "Pinhal da Serra",
  }, {
    name: "Pinhal de São Bento",
  }, {
    name: "Pinhalzinho",
  }, {
    name: "Pinhalão",
  }, {
    name: "Pinheiral",
  }, {
    name: "Pinheirinho do Vale",
  }, {
    name: "Pinheiro",
  }, {
    name: "Pinheiro Machado",
  }, {
    name: "Pinheiro Preto",
  }, {
    name: "Pinheiros",
  }, {
    name: "Pinhão",
  }, {
    name: "Pintadas",
  }, {
    name: "Pinto Bandeira",
  }, {
    name: "Pintópolis",
  }, {
    name: "Pio IX",
  }, {
    name: "Pio XII",
  }, {
    name: "Piquerobi",
  }, {
    name: "Piquet Carneiro",
  }, {
    name: "Piquete",
  }, {
    name: "Piracaia",
  }, {
    name: "Piracanjuba",
  }, {
    name: "Piracema",
  }, {
    name: "Piracicaba",
  }, {
    name: "Piracuruca",
  }, {
    name: "Piraju",
  }, {
    name: "Pirajuba",
  }, {
    name: "Pirajuí",
  }, {
    name: "Pirambu",
  }, {
    name: "Piranga",
  }, {
    name: "Pirangi",
  }, {
    name: "Piranguinho",
  }, {
    name: "Piranguçu",
  }, {
    name: "Piranhas",
  }, {
    name: "Pirapemas",
  }, {
    name: "Pirapetinga",
  }, {
    name: "Pirapora",
  }, {
    name: "Pirapora do Bom Jesus",
  }, {
    name: "Pirapozinho",
  }, {
    name: "Pirapó",
  }, {
    name: "Piraquara",
  }, {
    name: "Piraquê",
  }, {
    name: "Pirassununga",
  }, {
    name: "Piratini",
  }, {
    name: "Piratininga",
  }, {
    name: "Piratuba",
  }, {
    name: "Piraí",
  }, {
    name: "Piraí do Norte",
  }, {
    name: "Piraí do Sul",
  }, {
    name: "Piraúba",
  }, {
    name: "Pirenópolis",
  }, {
    name: "Pires Ferreira",
  }, {
    name: "Pires do Rio",
  }, {
    name: "Piripiri",
  }, {
    name: "Piripá",
  }, {
    name: "Piritiba",
  }, {
    name: "Pirpirituba",
  }, {
    name: "Pitanga",
  }, {
    name: "Pitangueiras",
  }, {
    name: "Pitangui",
  }, {
    name: "Pitimbu",
  }, {
    name: "Pium",
  }, {
    name: "Piumhi",
  }, {
    name: "Piçarra",
  }, {
    name: "Piên",
  }, {
    name: "Piúma",
  }, {
    name: "Placas",
  }, {
    name: "Planaltina",
  }, {
    name: "Planaltina do Paraná",
  }, {
    name: "Planaltino",
  }, {
    name: "Planalto",
  }, {
    name: "Planalto Alegre",
  }, {
    name: "Planalto da Serra",
  }, {
    name: "Planura",
  }, {
    name: "Platina",
  }, {
    name: "Plácido de Castro",
  }, {
    name: "Pocinhos",
  }, {
    name: "Poconé",
  }, {
    name: "Pocrane",
  }, {
    name: "Pojuca",
  }, {
    name: "Poloni",
  }, {
    name: "Pombal",
  }, {
    name: "Pombos",
  }, {
    name: "Pomerode",
  }, {
    name: "Pompéia",
  }, {
    name: "Pompéu",
  }, {
    name: "Pongaí",
  }, {
    name: "Ponta Grossa",
  }, {
    name: "Ponta Porã",
  }, {
    name: "Ponta de Pedras",
  }, {
    name: "Pontal",
  }, {
    name: "Pontal do Araguaia",
  }, {
    name: "Pontal do Paraná",
  }, {
    name: "Pontalina",
  }, {
    name: "Pontalinda",
  }, {
    name: "Ponte Alta",
  }, {
    name: "Ponte Alta do Bom Jesus",
  }, {
    name: "Ponte Alta do Norte",
  }, {
    name: "Ponte Alta do Tocantins",
  }, {
    name: "Ponte Branca",
  }, {
    name: "Ponte Nova",
  }, {
    name: "Ponte Preta",
  }, {
    name: "Ponte Serrada",
  }, {
    name: "Pontes Gestal",
  }, {
    name: "Pontes e Lacerda",
  }, {
    name: "Ponto Belo",
  }, {
    name: "Ponto Chique",
  }, {
    name: "Ponto Novo",
  }, {
    name: "Ponto dos Volantes",
  }, {
    name: "Pontão",
  }, {
    name: "Populina",
  }, {
    name: "Poranga",
  }, {
    name: "Porangaba",
  }, {
    name: "Porangatu",
  }, {
    name: "Porciúncula",
  }, {
    name: "Porecatu",
  }, {
    name: "Portalegre",
  }, {
    name: "Porteiras",
  }, {
    name: "Porteirinha",
  }, {
    name: "Porteirão",
  }, {
    name: "Portel",
  }, {
    name: "Portelândia",
  }, {
    name: "Porto",
  }, {
    name: "Porto Acre",
  }, {
    name: "Porto Alegre",
  }, {
    name: "Porto Alegre do Norte",
  }, {
    name: "Porto Alegre do Piauí",
  }, {
    name: "Porto Alegre do Tocantins",
  }, {
    name: "Porto Amazonas",
  }, {
    name: "Porto Barreiro",
  }, {
    name: "Porto Belo",
  }, {
    name: "Porto Calvo",
  }, {
    name: "Porto Esperidião",
  }, {
    name: "Porto Estrela",
  }, {
    name: "Porto Feliz",
  }, {
    name: "Porto Ferreira",
  }, {
    name: "Porto Firme",
  }, {
    name: "Porto Franco",
  }, {
    name: "Porto Grande",
  }, {
    name: "Porto Lucena",
  }, {
    name: "Porto Mauá",
  }, {
    name: "Porto Murtinho",
  }, {
    name: "Porto Nacional",
  }, {
    name: "Porto Real",
  }, {
    name: "Porto Real do Colégio",
  }, {
    name: "Porto Rico",
  }, {
    name: "Porto Rico do Maranhão",
  }, {
    name: "Porto Seguro",
  }, {
    name: "Porto União",
  }, {
    name: "Porto Velho",
  }, {
    name: "Porto Vera Cruz",
  }, {
    name: "Porto Vitória",
  }, {
    name: "Porto Walter",
  }, {
    name: "Porto Xavier",
  }, {
    name: "Porto da Folha",
  }, {
    name: "Porto de Moz",
  }, {
    name: "Porto de Pedras",
  }, {
    name: "Porto do Mangue",
  }, {
    name: "Porto dos Gaúchos",
  }, {
    name: "Portão",
  }, {
    name: "Posse",
  }, {
    name: "Potengi",
  }, {
    name: "Potim",
  }, {
    name: "Potiraguá",
  }, {
    name: "Potirendaba",
  }, {
    name: "Potiretama",
  }, {
    name: "Poté",
  }, {
    name: "Pouso Alegre",
  }, {
    name: "Pouso Alto",
  }, {
    name: "Pouso Novo",
  }, {
    name: "Pouso Redondo",
  }, {
    name: "Poxoréu",
  }, {
    name: "Poá",
  }, {
    name: "Poço Branco",
  }, {
    name: "Poço Dantas",
  }, {
    name: "Poço Fundo",
  }, {
    name: "Poço Redondo",
  }, {
    name: "Poço Verde",
  }, {
    name: "Poço das Antas",
  }, {
    name: "Poço das Trincheiras",
  }, {
    name: "Poço de José de Moura",
  }, {
    name: "Poços de Caldas",
  }, {
    name: "Poção",
  }, {
    name: "Poção de Pedras",
  }, {
    name: "Poções",
  }, {
    name: "Pracinha",
  }, {
    name: "Pracuúba",
  }, {
    name: "Prado",
  }, {
    name: "Prado Ferreira",
  }, {
    name: "Prados",
  }, {
    name: "Pradópolis",
  }, {
    name: "Praia Grande",
  }, {
    name: "Praia Norte",
  }, {
    name: "Prainha",
  }, {
    name: "Pranchita",
  }, {
    name: "Prata",
  }, {
    name: "Prata do Piauí",
  }, {
    name: "Pratinha",
  }, {
    name: "Pratápolis",
  }, {
    name: "Pratânia",
  }, {
    name: "Presidente Alves",
  }, {
    name: "Presidente Bernardes",
  }, {
    name: "Presidente Castello Branco",
  }, {
    name: "Presidente Castelo Branco",
  }, {
    name: "Presidente Dutra",
  }, {
    name: "Presidente Epitácio",
  }, {
    name: "Presidente Figueiredo",
  }, {
    name: "Presidente Getúlio",
  }, {
    name: "Presidente Juscelino",
  }, {
    name: "Presidente Jânio Quadros",
  }, {
    name: "Presidente Kennedy",
  }, {
    name: "Presidente Kubitschek",
  }, {
    name: "Presidente Lucena",
  }, {
    name: "Presidente Médici",
  }, {
    name: "Presidente Nereu",
  }, {
    name: "Presidente Olegário",
  }, {
    name: "Presidente Prudente",
  }, {
    name: "Presidente Sarney",
  }, {
    name: "Presidente Tancredo Neves",
  }, {
    name: "Presidente Vargas",
  }, {
    name: "Presidente Venceslau",
  }, {
    name: "Primavera",
  }, {
    name: "Primavera de Rondônia",
  }, {
    name: "Primavera do Leste",
  }, {
    name: "Primeira Cruz",
  }, {
    name: "Primeiro de Maio",
  }, {
    name: "Princesa",
  }, {
    name: "Princesa Isabel",
  }, {
    name: "Professor Jamil",
  }, {
    name: "Progresso",
  }, {
    name: "Promissão",
  }, {
    name: "Propriá",
  }, {
    name: "Protásio Alves",
  }, {
    name: "Prudente de Morais",
  }, {
    name: "Prudentópolis",
  }, {
    name: "Pugmil",
  }, {
    name: "Pureza",
  }, {
    name: "Putinga",
  }, {
    name: "Puxinanã",
  }, {
    name: "Pão de Açúcar",
  }, {
    name: "Pé de Serra",
  }, {
    name: "Pérola",
  }, {
    name: "Pérola d'Oeste",
  }, {
    name: "Quadra",
  }, {
    name: "Quaraí",
  }, {
    name: "Quartel Geral",
  }, {
    name: "Quarto Centenário",
  }, {
    name: "Quatiguá",
  }, {
    name: "Quatipuru",
  }, {
    name: "Quatis",
  }, {
    name: "Quatro Barras",
  }, {
    name: "Quatro Irmãos",
  }, {
    name: "Quatro Pontes",
  }, {
    name: "Quatá",
  }, {
    name: "Quebrangulo",
  }, {
    name: "Quedas do Iguaçu",
  }, {
    name: "Queimada Nova",
  }, {
    name: "Queimadas",
  }, {
    name: "Queimados",
  }, {
    name: "Queiroz",
  }, {
    name: "Queluz",
  }, {
    name: "Queluzito",
  }, {
    name: "Querência",
  }, {
    name: "Querência do Norte",
  }, {
    name: "Quevedos",
  }, {
    name: "Quijingue",
  }, {
    name: "Quilombo",
  }, {
    name: "Quinta do Sol",
  }, {
    name: "Quintana",
  }, {
    name: "Quinze de Novembro",
  }, {
    name: "Quipapá",
  }, {
    name: "Quirinópolis",
  }, {
    name: "Quissamã",
  }, {
    name: "Quitandinha",
  }, {
    name: "Quiterianópolis",
  }, {
    name: "Quixaba",
  }, {
    name: "Quixabeira",
  }, {
    name: "Quixadá",
  }, {
    name: "Quixelô",
  }, {
    name: "Quixeramobim",
  }, {
    name: "Quixeré",
  }, {
    name: "Rafael Fernandes",
  }, {
    name: "Rafael Godeiro",
  }, {
    name: "Rafael Jambeiro",
  }, {
    name: "Rafard",
  }, {
    name: "Ramilândia",
  }, {
    name: "Rancharia",
  }, {
    name: "Rancho Alegre",
  }, {
    name: "Rancho Alegre D'Oeste",
  }, {
    name: "Rancho Queimado",
  }, {
    name: "Raposa",
  }, {
    name: "Raposos",
  }, {
    name: "Raul Soares",
  }, {
    name: "Realeza",
  }, {
    name: "Rebouças",
  }, {
    name: "Recife",
  }, {
    name: "Recreio",
  }, {
    name: "Recursolândia",
  }, {
    name: "Redentora",
  }, {
    name: "Redenção",
  }, {
    name: "Redenção da Serra",
  }, {
    name: "Redenção do Gurguéia",
  }, {
    name: "Reduto",
  }, {
    name: "Regeneração",
  }, {
    name: "Regente Feijó",
  }, {
    name: "Reginópolis",
  }, {
    name: "Registro",
  }, {
    name: "Relvado",
  }, {
    name: "Remanso",
  }, {
    name: "Remígio",
  }, {
    name: "Renascença",
  }, {
    name: "Reriutaba",
  }, {
    name: "Resende",
  }, {
    name: "Resende Costa",
  }, {
    name: "Reserva",
  }, {
    name: "Reserva do Cabaçal",
  }, {
    name: "Reserva do Iguaçu",
  }, {
    name: "Resplendor",
  }, {
    name: "Ressaquinha",
  }, {
    name: "Restinga",
  }, {
    name: "Restinga Sêca",
  }, {
    name: "Retirolândia",
  }, {
    name: "Riachinho",
  }, {
    name: "Riacho Frio",
  }, {
    name: "Riacho da Cruz",
  }, {
    name: "Riacho das Almas",
  }, {
    name: "Riacho de Santana",
  }, {
    name: "Riacho de Santo Antônio",
  }, {
    name: "Riacho dos Cavalos",
  }, {
    name: "Riacho dos Machados",
  }, {
    name: "Riachuelo",
  }, {
    name: "Riachão",
  }, {
    name: "Riachão das Neves",
  }, {
    name: "Riachão do Bacamarte",
  }, {
    name: "Riachão do Dantas",
  }, {
    name: "Riachão do Jacuípe",
  }, {
    name: "Riachão do Poço",
  }, {
    name: "Rialma",
  }, {
    name: "Rianápolis",
  }, {
    name: "Ribamar Fiquene",
  }, {
    name: "Ribas do Rio Pardo",
  }, {
    name: "Ribeira",
  }, {
    name: "Ribeira do Amparo",
  }, {
    name: "Ribeira do Piauí",
  }, {
    name: "Ribeira do Pombal",
  }, {
    name: "Ribeiro Gonçalves",
  }, {
    name: "Ribeirão",
  }, {
    name: "Ribeirão Bonito",
  }, {
    name: "Ribeirão Branco",
  }, {
    name: "Ribeirão Cascalheira",
  }, {
    name: "Ribeirão Claro",
  }, {
    name: "Ribeirão Corrente",
  }, {
    name: "Ribeirão Grande",
  }, {
    name: "Ribeirão Pires",
  }, {
    name: "Ribeirão Preto",
  }, {
    name: "Ribeirão Vermelho",
  }, {
    name: "Ribeirão das Neves",
  }, {
    name: "Ribeirão do Largo",
  }, {
    name: "Ribeirão do Pinhal",
  }, {
    name: "Ribeirão do Sul",
  }, {
    name: "Ribeirão dos Índios",
  }, {
    name: "Ribeirãozinho",
  }, {
    name: "Ribeirópolis",
  }, {
    name: "Rifaina",
  }, {
    name: "Rincão",
  }, {
    name: "Rinópolis",
  }, {
    name: "Rio Acima",
  }, {
    name: "Rio Azul",
  }, {
    name: "Rio Bananal",
  }, {
    name: "Rio Bom",
  }, {
    name: "Rio Bonito",
  }, {
    name: "Rio Bonito do Iguaçu",
  }, {
    name: "Rio Branco",
  }, {
    name: "Rio Branco do Ivaí",
  }, {
    name: "Rio Branco do Sul",
  }, {
    name: "Rio Brilhante",
  }, {
    name: "Rio Casca",
  }, {
    name: "Rio Claro",
  }, {
    name: "Rio Crespo",
  }, {
    name: "Rio Doce",
  }, {
    name: "Rio Espera",
  }, {
    name: "Rio Formoso",
  }, {
    name: "Rio Fortuna",
  }, {
    name: "Rio Grande",
  }, {
    name: "Rio Grande da Serra",
  }, {
    name: "Rio Grande do Piauí",
  }, {
    name: "Rio Largo",
  }, {
    name: "Rio Manso",
  }, {
    name: "Rio Maria",
  }, {
    name: "Rio Negrinho",
  }, {
    name: "Rio Negro",
  }, {
    name: "Rio Novo",
  }, {
    name: "Rio Novo do Sul",
  }, {
    name: "Rio Paranaíba",
  }, {
    name: "Rio Pardo",
  }, {
    name: "Rio Pardo de Minas",
  }, {
    name: "Rio Piracicaba",
  }, {
    name: "Rio Pomba",
  }, {
    name: "Rio Preto",
  }, {
    name: "Rio Preto da Eva",
  }, {
    name: "Rio Quente",
  }, {
    name: "Rio Real",
  }, {
    name: "Rio Rufino",
  }, {
    name: "Rio Sono",
  }, {
    name: "Rio Tinto",
  }, {
    name: "Rio Verde",
  }, {
    name: "Rio Verde de Mato Grosso",
  }, {
    name: "Rio Vermelho",
  }, {
    name: "Rio da Conceição",
  }, {
    name: "Rio das Antas",
  }, {
    name: "Rio das Flores",
  }, {
    name: "Rio das Ostras",
  }, {
    name: "Rio das Pedras",
  }, {
    name: "Rio de Contas",
  }, {
    name: "Rio de Janeiro",
  }, {
    name: "Rio do Antônio",
  }, {
    name: "Rio do Campo",
  }, {
    name: "Rio do Fogo",
  }, {
    name: "Rio do Oeste",
  }, {
    name: "Rio do Pires",
  }, {
    name: "Rio do Prado",
  }, {
    name: "Rio do Sul",
  }, {
    name: "Rio dos Bois",
  }, {
    name: "Rio dos Cedros",
  }, {
    name: "Rio dos Índios",
  }, {
    name: "Riolândia",
  }, {
    name: "Riozinho",
  }, {
    name: "Riqueza",
  }, {
    name: "Ritápolis",
  }, {
    name: "Riversul",
  }, {
    name: "Roca Sales",
  }, {
    name: "Rochedo",
  }, {
    name: "Rochedo de Minas",
  }, {
    name: "Rodeio",
  }, {
    name: "Rodeio Bonito",
  }, {
    name: "Rodeiro",
  }, {
    name: "Rodelas",
  }, {
    name: "Rodolfo Fernandes",
  }, {
    name: "Rodrigues Alves",
  }, {
    name: "Rolador",
  }, {
    name: "Rolante",
  }, {
    name: "Rolim de Moura",
  }, {
    name: "Rolândia",
  }, {
    name: "Romaria",
  }, {
    name: "Romelândia",
  }, {
    name: "Roncador",
  }, {
    name: "Ronda Alta",
  }, {
    name: "Rondinha",
  }, {
    name: "Rondolândia",
  }, {
    name: "Rondon",
  }, {
    name: "Rondon do Pará",
  }, {
    name: "Rondonópolis",
  }, {
    name: "Roque Gonzales",
  }, {
    name: "Rorainópolis",
  }, {
    name: "Rosana",
  }, {
    name: "Roseira",
  }, {
    name: "Rosário",
  }, {
    name: "Rosário Oeste",
  }, {
    name: "Rosário da Limeira",
  }, {
    name: "Rosário do Catete",
  }, {
    name: "Rosário do Ivaí",
  }, {
    name: "Rosário do Sul",
  }, {
    name: "Roteiro",
  }, {
    name: "Rubelita",
  }, {
    name: "Rubiataba",
  }, {
    name: "Rubim",
  }, {
    name: "Rubinéia",
  }, {
    name: "Rubiácea",
  }, {
    name: "Rurópolis",
  }, {
    name: "Russas",
  }, {
    name: "Ruy Barbosa",
  }, {
    name: "Sabará",
  }, {
    name: "Sabino",
  }, {
    name: "Sabinópolis",
  }, {
    name: "Saboeiro",
  }, {
    name: "Sabáudia",
  }, {
    name: "Sacramento",
  }, {
    name: "Sagrada Família",
  }, {
    name: "Sagres",
  }, {
    name: "Sairé",
  }, {
    name: "Saldanha Marinho",
  }, {
    name: "Sales",
  }, {
    name: "Sales Oliveira",
  }, {
    name: "Salesópolis",
  }, {
    name: "Salete",
  }, {
    name: "Salgadinho",
  }, {
    name: "Salgado",
  }, {
    name: "Salgado Filho",
  }, {
    name: "Salgado de São Félix",
  }, {
    name: "Salgueiro",
  }, {
    name: "Salinas",
  }, {
    name: "Salinas da Margarida",
  }, {
    name: "Salinópolis",
  }, {
    name: "Salitre",
  }, {
    name: "Salmourão",
  }, {
    name: "Saloá",
  }, {
    name: "Saltinho",
  }, {
    name: "Salto",
  }, {
    name: "Salto Grande",
  }, {
    name: "Salto Veloso",
  }, {
    name: "Salto da Divisa",
  }, {
    name: "Salto de Pirapora",
  }, {
    name: "Salto do Céu",
  }, {
    name: "Salto do Itararé",
  }, {
    name: "Salto do Jacuí",
  }, {
    name: "Salto do Lontra",
  }, {
    name: "Salvador",
  }, {
    name: "Salvador das Missões",
  }, {
    name: "Salvador do Sul",
  }, {
    name: "Salvaterra",
  }, {
    name: "Sambaíba",
  }, {
    name: "Sampaio",
  }, {
    name: "Sananduva",
  }, {
    name: "Sanclerlândia",
  }, {
    name: "Sandolândia",
  }, {
    name: "Sandovalina",
  }, {
    name: "Sangão",
  }, {
    name: "Sanharó",
  }, {
    name: "Sant'Ana do Livramento",
  }, {
    name: "Santa Adélia",
  }, {
    name: "Santa Albertina",
  }, {
    name: "Santa Amélia",
  }, {
    name: "Santa Branca",
  }, {
    name: "Santa Brígida",
  }, {
    name: "Santa Bárbara",
  }, {
    name: "Santa Bárbara d'Oeste",
  }, {
    name: "Santa Bárbara de Goiás",
  }, {
    name: "Santa Bárbara do Leste",
  }, {
    name: "Santa Bárbara do Monte Verde",
  }, {
    name: "Santa Bárbara do Pará",
  }, {
    name: "Santa Bárbara do Sul",
  }, {
    name: "Santa Bárbara do Tugúrio",
  }, {
    name: "Santa Carmem",
  }, {
    name: "Santa Cecília",
  }, {
    name: "Santa Cecília do Pavão",
  }, {
    name: "Santa Cecília do Sul",
  }, {
    name: "Santa Clara d'Oeste",
  }, {
    name: "Santa Clara do Sul",
  }, {
    name: "Santa Cruz",
  }, {
    name: "Santa Cruz Cabrália",
  }, {
    name: "Santa Cruz da Baixa Verde",
  }, {
    name: "Santa Cruz da Conceição",
  }, {
    name: "Santa Cruz da Esperança",
  }, {
    name: "Santa Cruz da Vitória",
  }, {
    name: "Santa Cruz das Palmeiras",
  }, {
    name: "Santa Cruz de Goiás",
  }, {
    name: "Santa Cruz de Minas",
  }, {
    name: "Santa Cruz de Monte Castelo",
  }, {
    name: "Santa Cruz de Salinas",
  }, {
    name: "Santa Cruz do Arari",
  }, {
    name: "Santa Cruz do Capibaribe",
  }, {
    name: "Santa Cruz do Escalvado",
  }, {
    name: "Santa Cruz do Piauí",
  }, {
    name: "Santa Cruz do Rio Pardo",
  }, {
    name: "Santa Cruz do Sul",
  }, {
    name: "Santa Cruz do Xingu",
  }, {
    name: "Santa Cruz dos Milagres",
  }, {
    name: "Santa Efigênia de Minas",
  }, {
    name: "Santa Ernestina",
  }, {
    name: "Santa Filomena",
  }, {
    name: "Santa Filomena do Maranhão",
  }, {
    name: "Santa Fé",
  }, {
    name: "Santa Fé de Goiás",
  }, {
    name: "Santa Fé de Minas",
  }, {
    name: "Santa Fé do Araguaia",
  }, {
    name: "Santa Fé do Sul",
  }, {
    name: "Santa Gertrudes",
  }, {
    name: "Santa Helena",
  }, {
    name: "Santa Helena de Goiás",
  }, {
    name: "Santa Helena de Minas",
  }, {
    name: "Santa Inês",
  }, {
    name: "Santa Isabel",
  }, {
    name: "Santa Isabel do Ivaí",
  }, {
    name: "Santa Isabel do Rio Negro",
  }, {
    name: "Santa Izabel do Oeste",
  }, {
    name: "Santa Izabel do Pará",
  }, {
    name: "Santa Juliana",
  }, {
    name: "Santa Leopoldina",
  }, {
    name: "Santa Luz",
  }, {
    name: "Santa Luzia",
  }, {
    name: "Santa Luzia D'Oeste",
  }, {
    name: "Santa Luzia do Itanhy",
  }, {
    name: "Santa Luzia do Norte",
  }, {
    name: "Santa Luzia do Paruá",
  }, {
    name: "Santa Luzia do Pará",
  }, {
    name: "Santa Lúcia",
  }, {
    name: "Santa Margarida",
  }, {
    name: "Santa Margarida do Sul",
  }, {
    name: "Santa Maria",
  }, {
    name: "Santa Maria Madalena",
  }, {
    name: "Santa Maria da Boa Vista",
  }, {
    name: "Santa Maria da Serra",
  }, {
    name: "Santa Maria da Vitória",
  }, {
    name: "Santa Maria das Barreiras",
  }, {
    name: "Santa Maria de Itabira",
  }, {
    name: "Santa Maria de Jetibá",
  }, {
    name: "Santa Maria do Cambucá",
  }, {
    name: "Santa Maria do Herval",
  }, {
    name: "Santa Maria do Oeste",
  }, {
    name: "Santa Maria do Pará",
  }, {
    name: "Santa Maria do Salto",
  }, {
    name: "Santa Maria do Suaçuí",
  }, {
    name: "Santa Maria do Tocantins",
  }, {
    name: "Santa Mariana",
  }, {
    name: "Santa Mercedes",
  }, {
    name: "Santa Mônica",
  }, {
    name: "Santa Quitéria",
  }, {
    name: "Santa Quitéria do Maranhão",
  }, {
    name: "Santa Rita",
  }, {
    name: "Santa Rita d'Oeste",
  }, {
    name: "Santa Rita de Caldas",
  }, {
    name: "Santa Rita de Cássia",
  }, {
    name: "Santa Rita de Ibitipoca",
  }, {
    name: "Santa Rita de Jacutinga",
  }, {
    name: "Santa Rita de Minas",
  }, {
    name: "Santa Rita do Araguaia",
  }, {
    name: "Santa Rita do Itueto",
  }, {
    name: "Santa Rita do Novo Destino",
  }, {
    name: "Santa Rita do Pardo",
  }, {
    name: "Santa Rita do Passa Quatro",
  }, {
    name: "Santa Rita do Sapucaí",
  }, {
    name: "Santa Rita do Tocantins",
  }, {
    name: "Santa Rita do Trivelato",
  }, {
    name: "Santa Rosa",
  }, {
    name: "Santa Rosa da Serra",
  }, {
    name: "Santa Rosa de Goiás",
  }, {
    name: "Santa Rosa de Lima",
  }, {
    name: "Santa Rosa de Viterbo",
  }, {
    name: "Santa Rosa do Piauí",
  }, {
    name: "Santa Rosa do Purus",
  }, {
    name: "Santa Rosa do Sul",
  }, {
    name: "Santa Rosa do Tocantins",
  }, {
    name: "Santa Salete",
  }, {
    name: "Santa Teresa",
  }, {
    name: "Santa Teresinha",
  }, {
    name: "Santa Tereza",
  }, {
    name: "Santa Tereza de Goiás",
  }, {
    name: "Santa Tereza do Oeste",
  }, {
    name: "Santa Tereza do Tocantins",
  }, {
    name: "Santa Terezinha",
  }, {
    name: "Santa Terezinha de Goiás",
  }, {
    name: "Santa Terezinha de Itaipu",
  }, {
    name: "Santa Terezinha do Progresso",
  }, {
    name: "Santa Terezinha do Tocantins",
  }, {
    name: "Santa Vitória",
  }, {
    name: "Santa Vitória do Palmar",
  }, {
    name: "Santaluz",
  }, {
    name: "Santana",
  }, {
    name: "Santana da Boa Vista",
  }, {
    name: "Santana da Ponte Pensa",
  }, {
    name: "Santana da Vargem",
  }, {
    name: "Santana de Cataguases",
  }, {
    name: "Santana de Mangueira",
  }, {
    name: "Santana de Parnaíba",
  }, {
    name: "Santana de Pirapama",
  }, {
    name: "Santana do Acaraú",
  }, {
    name: "Santana do Araguaia",
  }, {
    name: "Santana do Cariri",
  }, {
    name: "Santana do Deserto",
  }, {
    name: "Santana do Garambéu",
  }, {
    name: "Santana do Ipanema",
  }, {
    name: "Santana do Itararé",
  }, {
    name: "Santana do Jacaré",
  }, {
    name: "Santana do Manhuaçu",
  }, {
    name: "Santana do Maranhão",
  }, {
    name: "Santana do Matos",
  }, {
    name: "Santana do Mundaú",
  }, {
    name: "Santana do Paraíso",
  }, {
    name: "Santana do Piauí",
  }, {
    name: "Santana do Riacho",
  }, {
    name: "Santana do Seridó",
  }, {
    name: "Santana do São Francisco",
  }, {
    name: "Santana dos Garrotes",
  }, {
    name: "Santana dos Montes",
  }, {
    name: "Santanópolis",
  }, {
    name: "Santarém",
  }, {
    name: "Santarém Novo",
  }, {
    name: "Santiago",
  }, {
    name: "Santiago do Sul",
  }, {
    name: "Santo Afonso",
  }, {
    name: "Santo Amaro",
  }, {
    name: "Santo Amaro da Imperatriz",
  }, {
    name: "Santo Amaro das Brotas",
  }, {
    name: "Santo Amaro do Maranhão",
  }, {
    name: "Santo Anastácio",
  }, {
    name: "Santo André",
  }, {
    name: "Santo Antônio",
  }, {
    name: "Santo Antônio da Alegria",
  }, {
    name: "Santo Antônio da Barra",
  }, {
    name: "Santo Antônio da Patrulha",
  }, {
    name: "Santo Antônio da Platina",
  }, {
    name: "Santo Antônio das Missões",
  }, {
    name: "Santo Antônio de Goiás",
  }, {
    name: "Santo Antônio de Jesus",
  }, {
    name: "Santo Antônio de Lisboa",
  }, {
    name: "Santo Antônio de Posse",
  }, {
    name: "Santo Antônio de Pádua",
  }, {
    name: "Santo Antônio do Amparo",
  }, {
    name: "Santo Antônio do Aracanguá",
  }, {
    name: "Santo Antônio do Aventureiro",
  }, {
    name: "Santo Antônio do Caiuá",
  }, {
    name: "Santo Antônio do Descoberto",
  }, {
    name: "Santo Antônio do Grama",
  }, {
    name: "Santo Antônio do Itambé",
  }, {
    name: "Santo Antônio do Içá",
  }, {
    name: "Santo Antônio do Jacinto",
  }, {
    name: "Santo Antônio do Jardim",
  }, {
    name: "Santo Antônio do Leste",
  }, {
    name: "Santo Antônio do Leverger",
  }, {
    name: "Santo Antônio do Monte",
  }, {
    name: "Santo Antônio do Palma",
  }, {
    name: "Santo Antônio do Paraíso",
  }, {
    name: "Santo Antônio do Pinhal",
  }, {
    name: "Santo Antônio do Planalto",
  }, {
    name: "Santo Antônio do Retiro",
  }, {
    name: "Santo Antônio do Rio Abaixo",
  }, {
    name: "Santo Antônio do Sudoeste",
  }, {
    name: "Santo Antônio do Tauá",
  }, {
    name: "Santo Antônio dos Lopes",
  }, {
    name: "Santo Antônio dos Milagres",
  }, {
    name: "Santo Augusto",
  }, {
    name: "Santo Cristo",
  }, {
    name: "Santo Estêvão",
  }, {
    name: "Santo Expedito",
  }, {
    name: "Santo Expedito do Sul",
  }, {
    name: "Santo Hipólito",
  }, {
    name: "Santo Inácio",
  }, {
    name: "Santo Inácio do Piauí",
  }, {
    name: "Santo Ângelo",
  }, {
    name: "Santos",
  }, {
    name: "Santos Dumont",
  }, {
    name: "Santópolis do Aguapeí",
  }, {
    name: "Sapeaçu",
  }, {
    name: "Sapezal",
  }, {
    name: "Sapiranga",
  }, {
    name: "Sapopema",
  }, {
    name: "Sapucaia",
  }, {
    name: "Sapucaia do Sul",
  }, {
    name: "Sapucaí-Mirim",
  }, {
    name: "Sapé",
  }, {
    name: "Saquarema",
  }, {
    name: "Sarandi",
  }, {
    name: "Sarapuí",
  }, {
    name: "Sardoá",
  }, {
    name: "Sarutaiá",
  }, {
    name: "Sarzedo",
  }, {
    name: "Satuba",
  }, {
    name: "Satubinha",
  }, {
    name: "Saubara",
  }, {
    name: "Saudade do Iguaçu",
  }, {
    name: "Saudades",
  }, {
    name: "Saúde",
  }, {
    name: "Schroeder",
  }, {
    name: "Seabra",
  }, {
    name: "Seara",
  }, {
    name: "Sebastianópolis do Sul",
  }, {
    name: "Sebastião Barros",
  }, {
    name: "Sebastião Laranjeiras",
  }, {
    name: "Sebastião Leal",
  }, {
    name: "Seberi",
  }, {
    name: "Sede Nova",
  }, {
    name: "Segredo",
  }, {
    name: "Selbach",
  }, {
    name: "Selvíria",
  }, {
    name: "Sem-Peixe",
  }, {
    name: "Sena Madureira",
  }, {
    name: "Senador Alexandre Costa",
  }, {
    name: "Senador Amaral",
  }, {
    name: "Senador Canedo",
  }, {
    name: "Senador Cortes",
  }, {
    name: "Senador Elói de Souza",
  }, {
    name: "Senador Firmino",
  }, {
    name: "Senador Georgino Avelino",
  }, {
    name: "Senador Guiomard",
  }, {
    name: "Senador José Bento",
  }, {
    name: "Senador José Porfírio",
  }, {
    name: "Senador La Rocque",
  }, {
    name: "Senador Modestino Gonçalves",
  }, {
    name: "Senador Pompeu",
  }, {
    name: "Senador Rui Palmeira",
  }, {
    name: "Senador Salgado Filho",
  }, {
    name: "Senador Sá",
  }, {
    name: "Sengés",
  }, {
    name: "Senhor do Bonfim",
  }, {
    name: "Senhora de Oliveira",
  }, {
    name: "Senhora do Porto",
  }, {
    name: "Senhora dos Remédios",
  }, {
    name: "Sentinela do Sul",
  }, {
    name: "Sento Sé",
  }, {
    name: "Serafina Corrêa",
  }, {
    name: "Sericita",
  }, {
    name: "Seringueiras",
  }, {
    name: "Seritinga",
  }, {
    name: "Seropédica",
  }, {
    name: "Serra",
  }, {
    name: "Serra Alta",
  }, {
    name: "Serra Azul",
  }, {
    name: "Serra Azul de Minas",
  }, {
    name: "Serra Branca",
  }, {
    name: "Serra Caiada",
  }, {
    name: "Serra Dourada",
  }, {
    name: "Serra Grande",
  }, {
    name: "Serra Negra",
  }, {
    name: "Serra Negra do Norte",
  }, {
    name: "Serra Nova Dourada",
  }, {
    name: "Serra Preta",
  }, {
    name: "Serra Redonda",
  }, {
    name: "Serra Talhada",
  }, {
    name: "Serra da Raiz",
  }, {
    name: "Serra da Saudade",
  }, {
    name: "Serra de São Bento",
  }, {
    name: "Serra do Mel",
  }, {
    name: "Serra do Navio",
  }, {
    name: "Serra do Ramalho",
  }, {
    name: "Serra do Salitre",
  }, {
    name: "Serra dos Aimorés",
  }, {
    name: "Serrana",
  }, {
    name: "Serrania",
  }, {
    name: "Serrano do Maranhão",
  }, {
    name: "Serranos",
  }, {
    name: "Serranópolis",
  }, {
    name: "Serranópolis de Minas",
  }, {
    name: "Serranópolis do Iguaçu",
  }, {
    name: "Serraria",
  }, {
    name: "Serrinha",
  }, {
    name: "Serrinha dos Pintos",
  }, {
    name: "Serrita",
  }, {
    name: "Serro",
  }, {
    name: "Serrolândia",
  }, {
    name: "Sertaneja",
  }, {
    name: "Sertanópolis",
  }, {
    name: "Sertânia",
  }, {
    name: "Sertão",
  }, {
    name: "Sertão Santana",
  }, {
    name: "Sertãozinho",
  }, {
    name: "Sete Barras",
  }, {
    name: "Sete Lagoas",
  }, {
    name: "Sete Quedas",
  }, {
    name: "Sete de Setembro",
  }, {
    name: "Setubinha",
  }, {
    name: "Severiano Melo",
  }, {
    name: "Severiano de Almeida",
  }, {
    name: "Severínia",
  }, {
    name: "Siderópolis",
  }, {
    name: "Sidrolândia",
  }, {
    name: "Sigefredo Pacheco",
  }, {
    name: "Silva Jardim",
  }, {
    name: "Silvanópolis",
  }, {
    name: "Silveira Martins",
  }, {
    name: "Silveiras",
  }, {
    name: "Silveirânia",
  }, {
    name: "Silves",
  }, {
    name: "Silvianópolis",
  }, {
    name: "Silvânia",
  }, {
    name: "Simolândia",
  }, {
    name: "Simonésia",
  }, {
    name: "Simplício Mendes",
  }, {
    name: "Simão Dias",
  }, {
    name: "Simão Pereira",
  }, {
    name: "Simões",
  }, {
    name: "Simões Filho",
  }, {
    name: "Sinimbu",
  }, {
    name: "Sinop",
  }, {
    name: "Siqueira Campos",
  }, {
    name: "Sirinhaém",
  }, {
    name: "Siriri",
  }, {
    name: "Sobradinho",
  }, {
    name: "Sobrado",
  }, {
    name: "Sobral",
  }, {
    name: "Sobrália",
  }, {
    name: "Socorro",
  }, {
    name: "Socorro do Piauí",
  }, {
    name: "Soledade",
  }, {
    name: "Soledade de Minas",
  }, {
    name: "Solidão",
  }, {
    name: "Solonópole",
  }, {
    name: "Solânea",
  }, {
    name: "Sombrio",
  }, {
    name: "Sonora",
  }, {
    name: "Sooretama",
  }, {
    name: "Sorocaba",
  }, {
    name: "Sorriso",
  }, {
    name: "Sossêgo",
  }, {
    name: "Soure",
  }, {
    name: "Sousa",
  }, {
    name: "Souto Soares",
  }, {
    name: "Sucupira",
  }, {
    name: "Sucupira do Norte",
  }, {
    name: "Sucupira do Riachão",
  }, {
    name: "Sud Mennucci",
  }, {
    name: "Sul Brasil",
  }, {
    name: "Sulina",
  }, {
    name: "Sumaré",
  }, {
    name: "Sumidouro",
  }, {
    name: "Sumé",
  }, {
    name: "Surubim",
  }, {
    name: "Sussuapara",
  }, {
    name: "Suzano",
  }, {
    name: "Suzanápolis",
  }, {
    name: "Sátiro Dias",
  }, {
    name: "São Benedito",
  }, {
    name: "São Benedito do Rio Preto",
  }, {
    name: "São Benedito do Sul",
  }, {
    name: "São Bentinho",
  }, {
    name: "São Bento",
  }, {
    name: "São Bento Abade",
  }, {
    name: "São Bento do Norte",
  }, {
    name: "São Bento do Sapucaí",
  }, {
    name: "São Bento do Sul",
  }, {
    name: "São Bento do Tocantins",
  }, {
    name: "São Bento do Trairí",
  }, {
    name: "São Bento do Una",
  }, {
    name: "São Bernardino",
  }, {
    name: "São Bernardo",
  }, {
    name: "São Bernardo do Campo",
  }, {
    name: "São Bonifácio",
  }, {
    name: "São Borja",
  }, {
    name: "São Braz do Piauí",
  }, {
    name: "São Brás",
  }, {
    name: "São Brás do Suaçuí",
  }, {
    name: "São Caetano de Odivelas",
  }, {
    name: "São Caetano do Sul",
  }, {
    name: "São Caitano",
  }, {
    name: "São Carlos",
  }, {
    name: "São Carlos do Ivaí",
  }, {
    name: "São Cristóvão",
  }, {
    name: "São Cristóvão do Sul",
  }, {
    name: "São Desidério",
  }, {
    name: "São Domingos",
  }, {
    name: "São Domingos das Dores",
  }, {
    name: "São Domingos do Araguaia",
  }, {
    name: "São Domingos do Azeitão",
  }, {
    name: "São Domingos do Capim",
  }, {
    name: "São Domingos do Cariri",
  }, {
    name: "São Domingos do Maranhão",
  }, {
    name: "São Domingos do Norte",
  }, {
    name: "São Domingos do Prata",
  }, {
    name: "São Domingos do Sul",
  }, {
    name: "São Felipe",
  }, {
    name: "São Felipe D'Oeste",
  }, {
    name: "São Fernando",
  }, {
    name: "São Fidélis",
  }, {
    name: "São Francisco",
  }, {
    name: "São Francisco de Assis",
  }, {
    name: "São Francisco de Assis do Piauí",
  }, {
    name: "São Francisco de Goiás",
  }, {
    name: "São Francisco de Itabapoana",
  }, {
    name: "São Francisco de Paula",
  }, {
    name: "São Francisco de Sales",
  }, {
    name: "São Francisco do Brejão",
  }, {
    name: "São Francisco do Conde",
  }, {
    name: "São Francisco do Glória",
  }, {
    name: "São Francisco do Guaporé",
  }, {
    name: "São Francisco do Maranhão",
  }, {
    name: "São Francisco do Oeste",
  }, {
    name: "São Francisco do Pará",
  }, {
    name: "São Francisco do Piauí",
  }, {
    name: "São Francisco do Sul",
  }, {
    name: "São Félix",
  }, {
    name: "São Félix de Balsas",
  }, {
    name: "São Félix de Minas",
  }, {
    name: "São Félix do Araguaia",
  }, {
    name: "São Félix do Coribe",
  }, {
    name: "São Félix do Piauí",
  }, {
    name: "São Félix do Tocantins",
  }, {
    name: "São Félix do Xingu",
  }, {
    name: "São Gabriel",
  }, {
    name: "São Gabriel da Cachoeira",
  }, {
    name: "São Gabriel da Palha",
  }, {
    name: "São Gabriel do Oeste",
  }, {
    name: "São Geraldo",
  }, {
    name: "São Geraldo da Piedade",
  }, {
    name: "São Geraldo do Araguaia",
  }, {
    name: "São Geraldo do Baixio",
  }, {
    name: "São Gonçalo",
  }, {
    name: "São Gonçalo do Abaeté",
  }, {
    name: "São Gonçalo do Amarante",
  }, {
    name: "São Gonçalo do Gurguéia",
  }, {
    name: "São Gonçalo do Pará",
  }, {
    name: "São Gonçalo do Piauí",
  }, {
    name: "São Gonçalo do Rio Abaixo",
  }, {
    name: "São Gonçalo do Rio Preto",
  }, {
    name: "São Gonçalo do Sapucaí",
  }, {
    name: "São Gonçalo dos Campos",
  }, {
    name: "São Gotardo",
  }, {
    name: "São Jerônimo",
  }, {
    name: "São Jerônimo da Serra",
  }, {
    name: "São Joaquim",
  }, {
    name: "São Joaquim da Barra",
  }, {
    name: "São Joaquim de Bicas",
  }, {
    name: "São Joaquim do Monte",
  }, {
    name: "São Jorge",
  }, {
    name: "São Jorge d'Oeste",
  }, {
    name: "São Jorge do Ivaí",
  }, {
    name: "São Jorge do Patrocínio",
  }, {
    name: "São José",
  }, {
    name: "São José da Barra",
  }, {
    name: "São José da Bela Vista",
  }, {
    name: "São José da Boa Vista",
  }, {
    name: "São José da Coroa Grande",
  }, {
    name: "São José da Lagoa Tapada",
  }, {
    name: "São José da Laje",
  }, {
    name: "São José da Lapa",
  }, {
    name: "São José da Safira",
  }, {
    name: "São José da Tapera",
  }, {
    name: "São José da Varginha",
  }, {
    name: "São José da Vitória",
  }, {
    name: "São José das Missões",
  }, {
    name: "São José das Palmeiras",
  }, {
    name: "São José de Caiana",
  }, {
    name: "São José de Espinharas",
  }, {
    name: "São José de Mipibu",
  }, {
    name: "São José de Piranhas",
  }, {
    name: "São José de Princesa",
  }, {
    name: "São José de Ribamar",
  }, {
    name: "São José de Ubá",
  }, {
    name: "São José do Alegre",
  }, {
    name: "São José do Barreiro",
  }, {
    name: "São José do Belmonte",
  }, {
    name: "São José do Bonfim",
  }, {
    name: "São José do Brejo do Cruz",
  }, {
    name: "São José do Calçado",
  }, {
    name: "São José do Campestre",
  }, {
    name: "São José do Cedro",
  }, {
    name: "São José do Cerrito",
  }, {
    name: "São José do Divino",
  }, {
    name: "São José do Egito",
  }, {
    name: "São José do Goiabal",
  }, {
    name: "São José do Herval",
  }, {
    name: "São José do Hortêncio",
  }, {
    name: "São José do Inhacorá",
  }, {
    name: "São José do Jacuri",
  }, {
    name: "São José do Jacuípe",
  }, {
    name: "São José do Mantimento",
  }, {
    name: "São José do Norte",
  }, {
    name: "São José do Ouro",
  }, {
    name: "São José do Peixe",
  }, {
    name: "São José do Piauí",
  }, {
    name: "São José do Povo",
  }, {
    name: "São José do Rio Claro",
  }, {
    name: "São José do Rio Pardo",
  }, {
    name: "São José do Rio Preto",
  }, {
    name: "São José do Sabugi",
  }, {
    name: "São José do Seridó",
  }, {
    name: "São José do Sul",
  }, {
    name: "São José do Vale do Rio Preto",
  }, {
    name: "São José do Xingu",
  }, {
    name: "São José dos Ausentes",
  }, {
    name: "São José dos Basílios",
  }, {
    name: "São José dos Campos",
  }, {
    name: "São José dos Cordeiros",
  }, {
    name: "São José dos Pinhais",
  }, {
    name: "São José dos Quatro Marcos",
  }, {
    name: "São José dos Ramos",
  }, {
    name: "São João",
  }, {
    name: "São João Batista",
  }, {
    name: "São João Batista do Glória",
  }, {
    name: "São João Evangelista",
  }, {
    name: "São João Nepomuceno",
  }, {
    name: "São João d'Aliança",
  }, {
    name: "São João da Baliza",
  }, {
    name: "São João da Barra",
  }, {
    name: "São João da Boa Vista",
  }, {
    name: "São João da Canabrava",
  }, {
    name: "São João da Fronteira",
  }, {
    name: "São João da Lagoa",
  }, {
    name: "São João da Mata",
  }, {
    name: "São João da Paraúna",
  }, {
    name: "São João da Ponta",
  }, {
    name: "São João da Ponte",
  }, {
    name: "São João da Serra",
  }, {
    name: "São João da Urtiga",
  }, {
    name: "São João da Varjota",
  }, {
    name: "São João das Duas Pontes",
  }, {
    name: "São João das Missões",
  }, {
    name: "São João de Iracema",
  }, {
    name: "São João de Meriti",
  }, {
    name: "São João de Pirabas",
  }, {
    name: "São João del Rei",
  }, {
    name: "São João do Araguaia",
  }, {
    name: "São João do Arraial",
  }, {
    name: "São João do Caiuá",
  }, {
    name: "São João do Cariri",
  }, {
    name: "São João do Carú",
  }, {
    name: "São João do Itaperiú",
  }, {
    name: "São João do Ivaí",
  }, {
    name: "São João do Jaguaribe",
  }, {
    name: "São João do Manhuaçu",
  }, {
    name: "São João do Manteninha",
  }, {
    name: "São João do Oeste",
  }, {
    name: "São João do Oriente",
  }, {
    name: "São João do Pacuí",
  }, {
    name: "São João do Paraíso",
  }, {
    name: "São João do Pau d'Alho",
  }, {
    name: "São João do Piauí",
  }, {
    name: "São João do Polêsine",
  }, {
    name: "São João do Rio do Peixe",
  }, {
    name: "São João do Sabugi",
  }, {
    name: "São João do Soter",
  }, {
    name: "São João do Sul",
  }, {
    name: "São João do Tigre",
  }, {
    name: "São João do Triunfo",
  }, {
    name: "São João dos Patos",
  }, {
    name: "São Julião",
  }, {
    name: "São Leopoldo",
  }, {
    name: "São Lourenço",
  }, {
    name: "São Lourenço da Mata",
  }, {
    name: "São Lourenço da Serra",
  }, {
    name: "São Lourenço do Oeste",
  }, {
    name: "São Lourenço do Piauí",
  }, {
    name: "São Lourenço do Sul",
  }, {
    name: "São Ludgero",
  }, {
    name: "São Luis do Piauí",
  }, {
    name: "São Luiz",
  }, {
    name: "São Luiz Gonzaga",
  }, {
    name: "São Luiz do Norte",
  }, {
    name: "São Luiz do Paraitinga",
  }, {
    name: "São Luís",
  }, {
    name: "São Luís Gonzaga do Maranhão",
  }, {
    name: "São Luís de Montes Belos",
  }, {
    name: "São Luís do Curu",
  }, {
    name: "São Luís do Quitunde",
  }, {
    name: "São Mamede",
  }, {
    name: "São Manoel do Paraná",
  }, {
    name: "São Manuel",
  }, {
    name: "São Marcos",
  }, {
    name: "São Martinho",
  }, {
    name: "São Martinho da Serra",
  }, {
    name: "São Mateus",
  }, {
    name: "São Mateus do Maranhão",
  }, {
    name: "São Mateus do Sul",
  }, {
    name: "São Miguel",
  }, {
    name: "São Miguel Arcanjo",
  }, {
    name: "São Miguel da Baixa Grande",
  }, {
    name: "São Miguel da Boa Vista",
  }, {
    name: "São Miguel das Matas",
  }, {
    name: "São Miguel das Missões",
  }, {
    name: "São Miguel de Taipu",
  }, {
    name: "São Miguel do Aleixo",
  }, {
    name: "São Miguel do Anta",
  }, {
    name: "São Miguel do Araguaia",
  }, {
    name: "São Miguel do Fidalgo",
  }, {
    name: "São Miguel do Gostoso",
  }, {
    name: "São Miguel do Guamá",
  }, {
    name: "São Miguel do Guaporé",
  }, {
    name: "São Miguel do Iguaçu",
  }, {
    name: "São Miguel do Oeste",
  }, {
    name: "São Miguel do Passa Quatro",
  }, {
    name: "São Miguel do Tapuio",
  }, {
    name: "São Miguel do Tocantins",
  }, {
    name: "São Miguel dos Campos",
  }, {
    name: "São Miguel dos Milagres",
  }, {
    name: "São Nicolau",
  }, {
    name: "São Patrício",
  }, {
    name: "São Paulo",
  }, {
    name: "São Paulo das Missões",
  }, {
    name: "São Paulo de Olivença",
  }, {
    name: "São Paulo do Potengi",
  }, {
    name: "São Pedro",
  }, {
    name: "São Pedro da Aldeia",
  }, {
    name: "São Pedro da Cipa",
  }, {
    name: "São Pedro da Serra",
  }, {
    name: "São Pedro da União",
  }, {
    name: "São Pedro da Água Branca",
  }, {
    name: "São Pedro das Missões",
  }, {
    name: "São Pedro de Alcântara",
  }, {
    name: "São Pedro do Butiá",
  }, {
    name: "São Pedro do Iguaçu",
  }, {
    name: "São Pedro do Ivaí",
  }, {
    name: "São Pedro do Paraná",
  }, {
    name: "São Pedro do Piauí",
  }, {
    name: "São Pedro do Suaçuí",
  }, {
    name: "São Pedro do Sul",
  }, {
    name: "São Pedro do Turvo",
  }, {
    name: "São Pedro dos Crentes",
  }, {
    name: "São Pedro dos Ferros",
  }, {
    name: "São Rafael",
  }, {
    name: "São Raimundo Nonato",
  }, {
    name: "São Raimundo das Mangabeiras",
  }, {
    name: "São Raimundo do Doca Bezerra",
  }, {
    name: "São Roberto",
  }, {
    name: "São Romão",
  }, {
    name: "São Roque",
  }, {
    name: "São Roque de Minas",
  }, {
    name: "São Roque do Canaã",
  }, {
    name: "São Salvador do Tocantins",
  }, {
    name: "São Sebastião",
  }, {
    name: "São Sebastião da Amoreira",
  }, {
    name: "São Sebastião da Bela Vista",
  }, {
    name: "São Sebastião da Boa Vista",
  }, {
    name: "São Sebastião da Grama",
  }, {
    name: "São Sebastião da Vargem Alegre",
  }, {
    name: "São Sebastião de Lagoa de Roça",
  }, {
    name: "São Sebastião do Alto",
  }, {
    name: "São Sebastião do Anta",
  }, {
    name: "São Sebastião do Caí",
  }, {
    name: "São Sebastião do Maranhão",
  }, {
    name: "São Sebastião do Oeste",
  }, {
    name: "São Sebastião do Paraíso",
  }, {
    name: "São Sebastião do Passé",
  }, {
    name: "São Sebastião do Rio Preto",
  }, {
    name: "São Sebastião do Rio Verde",
  }, {
    name: "São Sebastião do Tocantins",
  }, {
    name: "São Sebastião do Uatumã",
  }, {
    name: "São Sebastião do Umbuzeiro",
  }, {
    name: "São Sepé",
  }, {
    name: "São Simão",
  }, {
    name: "São Tiago",
  }, {
    name: "São Tomás de Aquino",
  }, {
    name: "São Tomé",
  }, {
    name: "São Tomé das Letras",
  }, {
    name: "São Valentim",
  }, {
    name: "São Valentim do Sul",
  }, {
    name: "São Valério",
  }, {
    name: "São Valério do Sul",
  }, {
    name: "São Vendelino",
  }, {
    name: "São Vicente",
  }, {
    name: "São Vicente Ferrer",
  }, {
    name: "São Vicente Férrer",
  }, {
    name: "São Vicente de Minas",
  }, {
    name: "São Vicente do Seridó",
  }, {
    name: "São Vicente do Sul",
  }, {
    name: "Sério",
  }, {
    name: "Sítio Novo",
  }, {
    name: "Sítio Novo do Tocantins",
  }, {
    name: "Sítio d'Abadia",
  }, {
    name: "Sítio do Mato",
  }, {
    name: "Sítio do Quinto",
  }, {
    name: "Tabaporã",
  }, {
    name: "Tabapuã",
  }, {
    name: "Tabatinga",
  }, {
    name: "Tabaí",
  }, {
    name: "Tabira",
  }, {
    name: "Tabocas do Brejo Velho",
  }, {
    name: "Tabocão",
  }, {
    name: "Taboleiro Grande",
  }, {
    name: "Taboão da Serra",
  }, {
    name: "Tabuleiro",
  }, {
    name: "Tabuleiro do Norte",
  }, {
    name: "Tacaimbó",
  }, {
    name: "Tacaratu",
  }, {
    name: "Taciba",
  }, {
    name: "Tacima",
  }, {
    name: "Tacuru",
  }, {
    name: "Taguatinga",
  }, {
    name: "Taguaí",
  }, {
    name: "Taiaçu",
  }, {
    name: "Tailândia",
  }, {
    name: "Taiobeiras",
  }, {
    name: "Taipas do Tocantins",
  }, {
    name: "Taipu",
  }, {
    name: "Taió",
  }, {
    name: "Taiúva",
  }, {
    name: "Talismã",
  }, {
    name: "Tamandaré",
  }, {
    name: "Tamarana",
  }, {
    name: "Tambaú",
  }, {
    name: "Tamboara",
  }, {
    name: "Tamboril",
  }, {
    name: "Tamboril do Piauí",
  }, {
    name: "Tanabi",
  }, {
    name: "Tangará",
  }, {
    name: "Tangará da Serra",
  }, {
    name: "Tanguá",
  }, {
    name: "Tanhaçu",
  }, {
    name: "Tanque Novo",
  }, {
    name: "Tanque d'Arca",
  }, {
    name: "Tanque do Piauí",
  }, {
    name: "Tanquinho",
  }, {
    name: "Taparuba",
  }, {
    name: "Tapauá",
  }, {
    name: "Tapejara",
  }, {
    name: "Tapera",
  }, {
    name: "Taperoá",
  }, {
    name: "Tapes",
  }, {
    name: "Tapira",
  }, {
    name: "Tapiramutá",
  }, {
    name: "Tapiratiba",
  }, {
    name: "Tapiraí",
  }, {
    name: "Tapurah",
  }, {
    name: "Taquara",
  }, {
    name: "Taquaral",
  }, {
    name: "Taquaral de Goiás",
  }, {
    name: "Taquarana",
  }, {
    name: "Taquaraçu de Minas",
  }, {
    name: "Taquari",
  }, {
    name: "Taquaritinga",
  }, {
    name: "Taquaritinga do Norte",
  }, {
    name: "Taquarituba",
  }, {
    name: "Taquarivaí",
  }, {
    name: "Taquarussu",
  }, {
    name: "Taquaruçu do Sul",
  }, {
    name: "Tarabai",
  }, {
    name: "Tarauacá",
  }, {
    name: "Tarrafas",
  }, {
    name: "Tartarugalzinho",
  }, {
    name: "Tarumirim",
  }, {
    name: "Tarumã",
  }, {
    name: "Tasso Fragoso",
  }, {
    name: "Tatuí",
  }, {
    name: "Taubaté",
  }, {
    name: "Tauá",
  }, {
    name: "Tavares",
  }, {
    name: "Tefé",
  }, {
    name: "Teixeira",
  }, {
    name: "Teixeira Soares",
  }, {
    name: "Teixeira de Freitas",
  }, {
    name: "Teixeiras",
  }, {
    name: "Teixeirópolis",
  }, {
    name: "Tejupá",
  }, {
    name: "Tejuçuoca",
  }, {
    name: "Telha",
  }, {
    name: "Telêmaco Borba",
  }, {
    name: "Tenente Ananias",
  }, {
    name: "Tenente Laurentino Cruz",
  }, {
    name: "Tenente Portela",
  }, {
    name: "Tenório",
  }, {
    name: "Teodoro Sampaio",
  }, {
    name: "Teofilândia",
  }, {
    name: "Teolândia",
  }, {
    name: "Teotônio Vilela",
  }, {
    name: "Terenos",
  }, {
    name: "Teresina",
  }, {
    name: "Teresina de Goiás",
  }, {
    name: "Teresópolis",
  }, {
    name: "Terezinha",
  }, {
    name: "Terezópolis de Goiás",
  }, {
    name: "Terra Alta",
  }, {
    name: "Terra Boa",
  }, {
    name: "Terra Nova",
  }, {
    name: "Terra Nova do Norte",
  }, {
    name: "Terra Rica",
  }, {
    name: "Terra Roxa",
  }, {
    name: "Terra Santa",
  }, {
    name: "Terra de Areia",
  }, {
    name: "Tesouro",
  }, {
    name: "Teutônia",
  }, {
    name: "Teófilo Otoni",
  }, {
    name: "Theobroma",
  }, {
    name: "Tianguá",
  }, {
    name: "Tibagi",
  }, {
    name: "Tibau",
  }, {
    name: "Tibau do Sul",
  }, {
    name: "Tietê",
  }, {
    name: "Tigrinhos",
  }, {
    name: "Tijucas",
  }, {
    name: "Tijucas do Sul",
  }, {
    name: "Timbaúba",
  }, {
    name: "Timbaúba dos Batistas",
  }, {
    name: "Timbiras",
  }, {
    name: "Timburi",
  }, {
    name: "Timbé do Sul",
  }, {
    name: "Timbó",
  }, {
    name: "Timbó Grande",
  }, {
    name: "Timon",
  }, {
    name: "Timóteo",
  }, {
    name: "Tio Hugo",
  }, {
    name: "Tiradentes",
  }, {
    name: "Tiradentes do Sul",
  }, {
    name: "Tiros",
  }, {
    name: "Tobias Barreto",
  }, {
    name: "Tocantins",
  }, {
    name: "Tocantinópolis",
  }, {
    name: "Tocantínia",
  }, {
    name: "Tocos do Moji",
  }, {
    name: "Toledo",
  }, {
    name: "Tomar do Geru",
  }, {
    name: "Tomazina",
  }, {
    name: "Tombos",
  }, {
    name: "Tomé-Açu",
  }, {
    name: "Tonantins",
  }, {
    name: "Toritama",
  }, {
    name: "Torixoréu",
  }, {
    name: "Toropi",
  }, {
    name: "Torre de Pedra",
  }, {
    name: "Torres",
  }, {
    name: "Torrinha",
  }, {
    name: "Touros",
  }, {
    name: "Trabiju",
  }, {
    name: "Tracuateua",
  }, {
    name: "Tracunhaém",
  }, {
    name: "Traipu",
  }, {
    name: "Trairi",
  }, {
    name: "Trairão",
  }, {
    name: "Trajano de Moraes",
  }, {
    name: "Tramandaí",
  }, {
    name: "Travesseiro",
  }, {
    name: "Tremedal",
  }, {
    name: "Tremembé",
  }, {
    name: "Treviso",
  }, {
    name: "Treze Tílias",
  }, {
    name: "Treze de Maio",
  }, {
    name: "Trindade",
  }, {
    name: "Trindade do Sul",
  }, {
    name: "Triunfo",
  }, {
    name: "Triunfo Potiguar",
  }, {
    name: "Trizidela do Vale",
  }, {
    name: "Trombas",
  }, {
    name: "Trombudo Central",
  }, {
    name: "Três Arroios",
  }, {
    name: "Três Barras",
  }, {
    name: "Três Barras do Paraná",
  }, {
    name: "Três Cachoeiras",
  }, {
    name: "Três Corações",
  }, {
    name: "Três Coroas",
  }, {
    name: "Três Forquilhas",
  }, {
    name: "Três Fronteiras",
  }, {
    name: "Três Lagoas",
  }, {
    name: "Três Marias",
  }, {
    name: "Três Palmeiras",
  }, {
    name: "Três Passos",
  }, {
    name: "Três Pontas",
  }, {
    name: "Três Ranchos",
  }, {
    name: "Três Rios",
  }, {
    name: "Três de Maio",
  }, {
    name: "Tubarão",
  }, {
    name: "Tucano",
  }, {
    name: "Tucumã",
  }, {
    name: "Tucunduva",
  }, {
    name: "Tucuruí",
  }, {
    name: "Tufilândia",
  }, {
    name: "Tuiuti",
  }, {
    name: "Tumiritinga",
  }, {
    name: "Tunas",
  }, {
    name: "Tunas do Paraná",
  }, {
    name: "Tuneiras do Oeste",
  }, {
    name: "Tuntum",
  }, {
    name: "Tunápolis",
  }, {
    name: "Tupaciguara",
  }, {
    name: "Tupanatinga",
  }, {
    name: "Tupanci do Sul",
  }, {
    name: "Tupanciretã",
  }, {
    name: "Tupandi",
  }, {
    name: "Tuparendi",
  }, {
    name: "Tuparetama",
  }, {
    name: "Tupi Paulista",
  }, {
    name: "Tupirama",
  }, {
    name: "Tupiratins",
  }, {
    name: "Tupã",
  }, {
    name: "Tupãssi",
  }, {
    name: "Turiaçu",
  }, {
    name: "Turilândia",
  }, {
    name: "Turiúba",
  }, {
    name: "Turmalina",
  }, {
    name: "Tururu",
  }, {
    name: "Turuçu",
  }, {
    name: "Turvelândia",
  }, {
    name: "Turvo",
  }, {
    name: "Turvolândia",
  }, {
    name: "Turvânia",
  }, {
    name: "Tutóia",
  }, {
    name: "Uarini",
  }, {
    name: "Uauá",
  }, {
    name: "Ubaitaba",
  }, {
    name: "Ubajara",
  }, {
    name: "Ubaporanga",
  }, {
    name: "Ubarana",
  }, {
    name: "Ubatuba",
  }, {
    name: "Ubatã",
  }, {
    name: "Ubaí",
  }, {
    name: "Ubaíra",
  }, {
    name: "Uberaba",
  }, {
    name: "Uberlândia",
  }, {
    name: "Ubirajara",
  }, {
    name: "Ubiratã",
  }, {
    name: "Ubiretama",
  }, {
    name: "Ubá",
  }, {
    name: "Uchoa",
  }, {
    name: "Uibaí",
  }, {
    name: "Uiramutã",
  }, {
    name: "Uirapuru",
  }, {
    name: "Uiraúna",
  }, {
    name: "Ulianópolis",
  }, {
    name: "Umari",
  }, {
    name: "Umarizal",
  }, {
    name: "Umbaúba",
  }, {
    name: "Umburanas",
  }, {
    name: "Umburatiba",
  }, {
    name: "Umbuzeiro",
  }, {
    name: "Umirim",
  }, {
    name: "Umuarama",
  }, {
    name: "Una",
  }, {
    name: "Unaí",
  }, {
    name: "Uniflor",
  }, {
    name: "Unistalda",
  }, {
    name: "União",
  }, {
    name: "União Paulista",
  }, {
    name: "União da Serra",
  }, {
    name: "União da Vitória",
  }, {
    name: "União de Minas",
  }, {
    name: "União do Oeste",
  }, {
    name: "União do Sul",
  }, {
    name: "União dos Palmares",
  }, {
    name: "Upanema",
  }, {
    name: "Urandi",
  }, {
    name: "Uraí",
  }, {
    name: "Urbano Santos",
  }, {
    name: "Uru",
  }, {
    name: "Uruana",
  }, {
    name: "Uruana de Minas",
  }, {
    name: "Uruará",
  }, {
    name: "Uruaçu",
  }, {
    name: "Urubici",
  }, {
    name: "Uruburetama",
  }, {
    name: "Urucará",
  }, {
    name: "Urucuia",
  }, {
    name: "Urucurituba",
  }, {
    name: "Urucânia",
  }, {
    name: "Uruguaiana",
  }, {
    name: "Uruoca",
  }, {
    name: "Urupema",
  }, {
    name: "Urupá",
  }, {
    name: "Urupês",
  }, {
    name: "Urussanga",
  }, {
    name: "Urutaí",
  }, {
    name: "Uruçuca",
  }, {
    name: "Uruçuí",
  }, {
    name: "Urânia",
  }, {
    name: "Utinga",
  }, {
    name: "Vacaria",
  }, {
    name: "Vale Real",
  }, {
    name: "Vale Verde",
  }, {
    name: "Vale de São Domingos",
  }, {
    name: "Vale do Anari",
  }, {
    name: "Vale do Paraíso",
  }, {
    name: "Vale do Sol",
  }, {
    name: "Valente",
  }, {
    name: "Valentim Gentil",
  }, {
    name: "Valença",
  }, {
    name: "Valença do Piauí",
  }, {
    name: "Valinhos",
  }, {
    name: "Valparaíso",
  }, {
    name: "Valparaíso de Goiás",
  }, {
    name: "Vanini",
  }, {
    name: "Vargem",
  }, {
    name: "Vargem Alegre",
  }, {
    name: "Vargem Alta",
  }, {
    name: "Vargem Bonita",
  }, {
    name: "Vargem Grande",
  }, {
    name: "Vargem Grande Paulista",
  }, {
    name: "Vargem Grande do Rio Pardo",
  }, {
    name: "Vargem Grande do Sul",
  }, {
    name: "Vargeão",
  }, {
    name: "Varginha",
  }, {
    name: "Varjota",
  }, {
    name: "Varjão",
  }, {
    name: "Varjão de Minas",
  }, {
    name: "Varre-Sai",
  }, {
    name: "Varzedo",
  }, {
    name: "Varzelândia",
  }, {
    name: "Vassouras",
  }, {
    name: "Vazante",
  }, {
    name: "Venda Nova do Imigrante",
  }, {
    name: "Venha-Ver",
  }, {
    name: "Ventania",
  }, {
    name: "Venturosa",
  }, {
    name: "Venâncio Aires",
  }, {
    name: "Vera",
  }, {
    name: "Vera Cruz",
  }, {
    name: "Vera Cruz do Oeste",
  }, {
    name: "Vera Mendes",
  }, {
    name: "Veranópolis",
  }, {
    name: "Verdejante",
  }, {
    name: "Verdelândia",
  }, {
    name: "Vereda",
  }, {
    name: "Veredinha",
  }, {
    name: "Vermelho Novo",
  }, {
    name: "Vertente do Lério",
  }, {
    name: "Vertentes",
  }, {
    name: "Verê",
  }, {
    name: "Veríssimo",
  }, {
    name: "Vespasiano",
  }, {
    name: "Vespasiano Corrêa",
  }, {
    name: "Viadutos",
  }, {
    name: "Viamão",
  }, {
    name: "Viana",
  }, {
    name: "Vianópolis",
  }, {
    name: "Vicente Dutra",
  }, {
    name: "Vicentina",
  }, {
    name: "Vicentinópolis",
  }, {
    name: "Victor Graeff",
  }, {
    name: "Vicência",
  }, {
    name: "Vidal Ramos",
  }, {
    name: "Videira",
  }, {
    name: "Vieiras",
  }, {
    name: "Vieirópolis",
  }, {
    name: "Vigia",
  }, {
    name: "Vila Bela da Santíssima Trindade",
  }, {
    name: "Vila Boa",
  }, {
    name: "Vila Flor",
  }, {
    name: "Vila Flores",
  }, {
    name: "Vila Lângaro",
  }, {
    name: "Vila Maria",
  }, {
    name: "Vila Nova do Piauí",
  }, {
    name: "Vila Nova do Sul",
  }, {
    name: "Vila Nova dos Martírios",
  }, {
    name: "Vila Pavão",
  }, {
    name: "Vila Propício",
  }, {
    name: "Vila Rica",
  }, {
    name: "Vila Valério",
  }, {
    name: "Vila Velha",
  }, {
    name: "Vilhena",
  }, {
    name: "Vinhedo",
  }, {
    name: "Viradouro",
  }, {
    name: "Virgem da Lapa",
  }, {
    name: "Virginópolis",
  }, {
    name: "Virgolândia",
  }, {
    name: "Virgínia",
  }, {
    name: "Virmond",
  }, {
    name: "Visconde do Rio Branco",
  }, {
    name: "Viseu",
  }, {
    name: "Vista Alegre",
  }, {
    name: "Vista Alegre do Alto",
  }, {
    name: "Vista Alegre do Prata",
  }, {
    name: "Vista Gaúcha",
  }, {
    name: "Vista Serrana",
  }, {
    name: "Vitor Meireles",
  }, {
    name: "Vitorino",
  }, {
    name: "Vitorino Freire",
  }, {
    name: "Vitória",
  }, {
    name: "Vitória Brasil",
  }, {
    name: "Vitória da Conquista",
  }, {
    name: "Vitória das Missões",
  }, {
    name: "Vitória de Santo Antão",
  }, {
    name: "Vitória do Jari",
  }, {
    name: "Vitória do Mearim",
  }, {
    name: "Vitória do Xingu",
  }, {
    name: "Viçosa",
  }, {
    name: "Viçosa do Ceará",
  }, {
    name: "Volta Grande",
  }, {
    name: "Volta Redonda",
  }, {
    name: "Votorantim",
  }, {
    name: "Votuporanga",
  }, {
    name: "Várzea",
  }, {
    name: "Várzea Alegre",
  }, {
    name: "Várzea Branca",
  }, {
    name: "Várzea Grande",
  }, {
    name: "Várzea Nova",
  }, {
    name: "Várzea Paulista",
  }, {
    name: "Várzea da Palma",
  }, {
    name: "Várzea da Roça",
  }, {
    name: "Várzea do Poço",
  }, {
    name: "Wagner",
  }, {
    name: "Wall Ferraz",
  }, {
    name: "Wanderley",
  }, {
    name: "Wanderlândia",
  }, {
    name: "Wenceslau Braz",
  }, {
    name: "Wenceslau Guimarães",
  }, {
    name: "Westfália",
  }, {
    name: "Witmarsum",
  }, {
    name: "Xambioá",
  }, {
    name: "Xambrê",
  }, {
    name: "Xangri-lá",
  }, {
    name: "Xanxerê",
  }, {
    name: "Xapuri",
  }, {
    name: "Xavantina",
  }, {
    name: "Xaxim",
  }, {
    name: "Xexéu",
  }, {
    name: "Xinguara",
  }, {
    name: "Xique-Xique",
  }, {
    name: "Zabelê",
  }, {
    name: "Zacarias",
  }, {
    name: "Zortéa",
  }, {
    name: "Zé Doca",
  }, {
    name: "Água Azul do Norte",
  }, {
    name: "Água Boa",
  }, {
    name: "Água Branca",
  }, {
    name: "Água Clara",
  }, {
    name: "Água Comprida",
  }, {
    name: "Água Doce",
  }, {
    name: "Água Doce do Maranhão",
  }, {
    name: "Água Doce do Norte",
  }, {
    name: "Água Fria",
  }, {
    name: "Água Fria de Goiás",
  }, {
    name: "Água Limpa",
  }, {
    name: "Água Nova",
  }, {
    name: "Água Preta",
  }, {
    name: "Água Santa",
  }, {
    name: "Águas Belas",
  }, {
    name: "Águas Formosas",
  }, {
    name: "Águas Frias",
  }, {
    name: "Águas Lindas de Goiás",
  }, {
    name: "Águas Mornas",
  }, {
    name: "Águas Vermelhas",
  }, {
    name: "Águas da Prata",
  }, {
    name: "Águas de Chapecó",
  }, {
    name: "Águas de Lindóia",
  }, {
    name: "Águas de Santa Bárbara",
  }, {
    name: "Águas de São Pedro",
  }, {
    name: "Águia Branca",
  }, {
    name: "Álvares Florence",
  }, {
    name: "Álvares Machado",
  }, {
    name: "Álvaro de Carvalho",
  }, {
    name: "Áurea",
  }, {
    name: "Ângulo",
  }, {
    name: "Érico Cardoso",
  }, {
    name: "Óbidos",
  }, { name: "Óleo" }];

 export default cidades;
